module.exports = {
  login: {
    title: "系统登录",
    logIn: "登录",
    username: "请输入您的账号",
    password: "密码6-18位",
    changeCheckCode: "换一张",
    checkcode: "请输入验证码",
    footerTxt: "中国电信",
    contact: "合同系统",
    scm: "供应链",
    project: "项目管理",
    hr: "人力系统",
    error_account_null: "账号不能为空",
    error_pwd_null: "密码不能为空",
    error_checkcode_null: "验证码不能为空",
    switchingusers: "切换用户",
    retreat: "退出",
    loginoutmsg: "您已退出系统或者登陆超时，请重新登录"
  },
  layout: {
    sysTitle: "PTO系统"
  },
  ffbreadcb: {
    currlocation: "当前位置："
  },
  common: {
    no: "序号",
    home: "首页",
    indexMethod: "序号",
    expList: "导出",
    expDataCutList: "割接导出",
    impDataCut: "割接导入",
    checkboxT: "选择",
    addbut: "新增",
    delbut: "删除",
    query: "查询",
    advancedquery: "高级查询",
    reset: "重置",
    delnoselected: "请选择需要删除的记录!",
    delsuccess: "删除成功!",
    savesuccess: "保存成功！",
    reloadsuccess: "重新加载成功！",
    opertype: "操作",
    fileup: "附件上传",
    todo: "办理",
    inputTips: "请输入",
    selectTips: "请选择",
    selectfile: "选取文件",
    uptoftp: "上传",
    nodata: "暂无数据",
    reload: "重新加载",
    todos: "待办",
    alreadtodo: "已办",
    yes: "是",
    cannot: "不能",
    morethan: "超过",
    develop: "展开",
    shrink: "收缩",
    clean: "清除",
    close: "关闭",
    save: "保存",
    reqcompanycodeTips: "请选择公司",
    confirm: "确定",
    cancel: "取消",
    impexcel: "导入excel",
    delmsg: "确定删除单据吗?",
    tiptitle: "提示",
    cancelmsg: "已取消操作",
    batchtodo: "批量办理",
    showMoreTip: "展开",
    hideTip: "隐藏",
    panelShowDetailTip: "展开",
    panelhideTip: "隐藏",
    companycode: "公司代码",
    selnulluserinfotip: "请选择人员信息",
    warning: "警告",
    refeshright: "刷新模块权限",
    reqfileTips: "请点击浏览，选择导入文件!",
    print: "打印",
    checkHystrix: "正常合同调用接口",
    checkHystrix2: "合同服务端接口报错调用",
    batch: "批量",
    filereplace: "替换",
    nosavefiletip: "先保存文档，然后可以上传附件。",
    btnUploadFile: "上传附件",
    filename: "附件",
    billno: "单据编号",
    inputNum:"请输入数字"
  },
  materialcommon: {
    changestoreTips: "请清空已选择的物资需求明细，再更换仓库!",
    checkapplynumtip: "行项申请数量不能大于可用库存数量！",
    donenum: "已开单数量",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    costcentercode: "成本中心编码",
    costcentername: "成本中心名称",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    outprojcode: "委外子项目编码",
    belongeregion: "所属区域",
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    manuname: "供应商",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "计量单位",
    chcurrency: "交易币种",
    startdate: "开始日期",
    enddate: "结束日期",
    baseinfoTab: "基本信息",
    billno: "单据编码",
    plandate: "开单日期",
    storedate: "过账日期",
    storeid: "仓库",
    recstoreid: "收料仓库",
    planuserid: "账务管理员",
    storeuserid: "实物管理员",
    remark: "备注",
    materialWrap: "物资需求明细",
    price: "单价",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum: "金额",
    degree: "库存属性",
    notes: "备注",
    checknumtip: "行项实际数量不能大于开单数量!",
    outbillno: "委外出库单号",
    outmanuname: "受托供应商",
    projcode: "子项目编码",
    projname: "子项目名称",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    demandbillno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    fileup: "上传附件",
    applynum: "申请数量",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    demandlistinfo: "需求清单",
    listinfo: "本次发货清单",
    emptyrowlist: "本次发货清单不能为空!",
    checkplannumtip: "行项开单数量不能大于可用库存数量！",
    checkdemandnumtip: "本次开单数量+已办理数量不能大于需求申请数量!",
    demandbillno2: "需求单据编码",
    receivedate: "到达任务池时间",
    costcenter: "成本中心",
    glcode: "总账科目",
    contractcode: "法律订单编码",
    stockusername: "采购管理员",
    orderdate: "订单日期",
    backplandate: "退货日期",
    backstoreid: "退货仓库",
    backlistinfo: "本次退货清单",
    backstocknum: "收货数量",
    backonlinenum: "已退数量",
    backrecnum: "可退数量",
    backplannum: "退货数量",
    backstorenum: "实退数量",
    speccode: "专业",
    stocktype: "采购种类",
    manucode: "供应商编码",
    manuname2: "供应商名称",
    to1: "至",
    contractname2: "合同名称",
    contractcode2: "合同编号"
  },
  pubbillhead: {
    sendsap: "发送SAP",
    sendmq: "发送MQ",
    assetaddsendsap: "资产创建状态",
    assetmodifysendsap: "资产修改状态",
    mblnrs: "物料凭证",
    sendbss: "发送BSS"
  },
  pubbillbtn: {
    resetsaplog: "重置SAP日志"
  },
  syslog: {
    logdate1: "日志文件日期",
    indexMethod: "序号",
    logfilename: "日志文件",
    logdate: "接口发送日期",
    servicecode: "接口编码",
    query: "查询",
    reset: "重置",
    servicename: "接口名称",
    requestTime: "请求日期",
    requestlog: "请求报文",
    responselog: "反馈报文",
    clienttitle: "客户端日志",
    servertitle: "服务端日志",
    url: "过滤地址",
    valid: "是否有效",
    system: "系统",
    keyval: "业务单据ID",
    result: "是否成功"
  },
  testdemo: {
    listDemo: "测试列表",
    listDemoDetail: "测试列表明细页"
  },
  travel: {
    //出差审批
    task: "待办",
    deleteList: "删除",
    addList: "新增",
    checkboxT: "选择",
    indexMethod: "序号",
    creadate: "日期",
    currusername: "姓名",
    applydept: "部门",
    applydate: "办理日期",
    applyuser: "当前办理人",
    currstatus: "当前状态",
    status: "状态",
    operate: "操作",
    look: "查看",
    allFiles: "全部文件"
  },
  travelDetail: {
    //出差审批详情
    title: "出差审批",
    applyuser: "申请人",
    applydept: "申请部门",
    applyareacode: "编号",
    usernum: "出差人数",
    toolname: "乘坐交通工具",
    travelauser: "出差人员",
    traveldate: "出差日期",
    returndate: "返回时间",
    traveladdress: "出差目的地",
    task: "出差任务说明",
    zsap: "住宿安排",
    zsremark: "住宿安排备注",
    toolremark: "乘坐交通工具备注",
    remark: "备注",
    selectedPlaceholder: "请选择",
    inputPlaceholder: "请输入内容",
    startTime: "开始时间",
    endTime: "结束时间",
    //单据标题
    contentTitle: "内容标题",
    contentLine: "行项列表",
    contentFlow: "办理过程",
    //行项列表
    nums: "数量",
    price: "出差费用"
  },
  flow_process: {
    title: "流程处理",
    nextstatus: "下一步骤",
    nextapprover: "Next Approver",
    nextuser: "下一办理人",
    reader: "传阅人员",
    advice: "办理意见",
    advicelengthwarn: "办理意见长度不能超过2000个字符",
    pleaseselect: "请选择",
    addadvice: "新增常用意见",
    deladvicesucc: "删除常用意见成功",
    deladviceerror: "删除常用意见失败",
    changle: "取消",
    confirm: "确定",
    retrieve: "重新提取待办",
    successtip1: "系统将在",
    successtip2: "秒后自动跳转回原页面！",
    savesuccess: "保存成功！",
    currlocation: "当前位置",
    curruser: "当前办理人",
    notnulltip: "必填",
    msgtitle: "错误信息",
    saveerror: "数据保存出现问题，请稍后再试",
    saveerror2: "数据保存出现问题，请联系管理员",
    processtitle: "提示",
    deletemsg: "确定删除单据吗?",
    cancelmsg: "已取消操作",
    confirmReclaim: "确定后，回收到本步骤！",
    loading: "数据加载中...",
    submitting: "数据提交中...",
    errormsg: "{0}不能为空!",
    defaultadvice_agree: "同意",
    defaultadvice_disagree: "不同意",
    notice: "通知",
    sendmail: "Send Mail(To Approver)",
    sendmail_to_cc: "Send Mail(To CC Person)",
    sendsms: "发送短信",

    // 办理过程
    bflow_flowinfo: "流程信息",
    bflow_flowname: "流程名称",
    bflow_flowstatus: "流程状态",
    bflow_currflowstatus: "当前环节",
    bflow_list_info: "流程及意见跟踪列表",
    bflow_list_index: "序号",
    bflow_list_username: "审批人",
    bflow_list_status: "处理环节",
    bflow_list_advice: "审批意见",
    bflow_list_proctime: "审批时间",

    // 设置流程
    setflow_list_title: "设置流程",
    setflow_list_index: "序号",
    setflow_list_currstatus: "当前办理步骤",
    setflow_list_currarea: "当前办理地区",
    setflow_list_currdept: "当前办理部门",
    setflow_list_currusername: "当前办理人",
    setflow_list_receivetime: "接收时间",

    setflow_adjusted: "调整为",
    setflow_latest_steps: "最新步骤",
    setflow_latest_handler: "最新办理人",
    setflow_orderno: "运维工单号",
    setflow_notion: "调整原因",

    // 历史调整记录
    history_list_title: "历史调整记录",
    history_list_index: "序号",
    history_list_orderno: "运维工单号",
    history_list_notion: "调整原因",
    history_list_adjustmenttime: "调整时间",
    history_list_handler: "操作人员",
    history_list_OriginalProcessName: "原流程名称",
    history_list_NewProcessName: "新流程名称",

    //阅办
    read_title: "阅办意见",
    read_advice: "请输入办理意见",
    process_prediction: "流程预判",
    process_track: "流程跟踪",
    tip_syncTaskSucc: "提取待办成功",
    tip_chgCurrFlowSucc: "调整流程任务实例成功",
    billreloaderror: "单据加载失败，请刷新或者重新打开单据加载"
  },
  selectUser: {
    title: "人员选择",
    rownum: "序号",
    username: "用户名",
    account: "账号",
    deptname: "所属部门",
    clear: "清空",
    query: "查询",
    placeholder: "输入关键字搜索",
    confirm: "确定",
    cancel: "取消",
    nomsg: "暂无数据",
    notselectuser: "请选择人员信息"
  },
  treeTag: {
    placeholder: "请输入关键字过滤"
  },
  selectList: {
    title: "行项选择",
    clear: "清空",
    reset: "重置",
    query: "查询",
    confirm: "确定",
  },
  demo: {
    //模版
    indexMethod: "序号",
    expList: "导出",
    tabname: "列表",
    checkboxT: "选择",
    a1: "供应商编码",
    a2: "供应商名称",
    a3: "",
    titeData: ["模版页面"],
    reflash: "刷新"
  },
  formValidate: {
    tipTitle: "信息错误",
    maxCharLength: "内容总长度不能超过{0}个字符",
    minCharLength: "内容总长度不能少于{0}个字符",
    decimal1: "请输入不超过{0}位的整数",
    decimal2: "请输入整数位数不能超过{0}位且小数位数不能超过{1}位的数值",
    integer: "请输入不超过{0}位的整数",
    positive: "请输入正数",
    negative: "请输入负数",
    handler: "自定义客户端（方法：{0}）校验发现错误（详细信息未提供，请联系开发人员，进行补充）.",
    idcard: "请输入正确的二代身份证号码",
    phone: "请输入正确的手机号码",
    email: "请输入正确的邮箱",
    savesuccess: "保存成功！",
    success: "成功！",
    defeat: "失败！",
  },
  contract: {
    btnUpdate: "修改",
    btnsave: "保存",
    btnpdf: "定稿",
    btnPrint:"打印",
    title: "合同审批表",
    info: "合同信息",
    relatedContract: "关联合同",
    createtime: "拟稿日期",
    signcode: "发起号",
    contractcode: "合同编号",
    frameflag: "签约类型",
    contractname: "合同名称",
    contractfactbook: "合同背景及概况",
    partatype: "公司代码",
    tradesum: "合同金额",
    concode3class: "合同类型",
    fundflag: "收付类型",
    emergencydegree: "合同紧急程度",
    iffinancialpro: "是否财务承诺",
    applyareadept: "承办部门",
    department: "部门",
    applyusername: "承办人",
    applyusertel: "联系电话",
    tel: "承办人/电话",
    partbname: "对方名称",
    ifrelatetrading: "是否关联交易",
    relatetradetype: "关联交易类型",
    ifinsidetrade: "是否内部交易",
    insidetradetype: "内部交易类型",
    accountname: "开户名称",
    bankname: "开户银行",
    bankaccounts: "开户账号",
    mgrdept: "授权代表",
    consaddr: "地址",
    partbtradesum: "合同分摊金额",
    presentid: "我方名称",
    baseTitle: "基本信息",
    partbTitle: "签约主体",
    payTitle: "履约信息",
    selectpaytype1: "付款方式",
    selectpaytype2: "收款方式",
    paymethoddesc1: "付款方式描述",
    paymethoddesc2: "收款方式描述",
    extendedterms: "是否有顺延条款",
    manuname: "对方名称",
    payno: "第N次",
    payitem: "履行要求",
    perdate: "约定履行日期",
    payplan1: "付款计划",
    theorypaydate_days1: "预计付款日期",
    perrate1: "约定付款比例(%)",
    persum1: "约定付款金额",
    payplan2: "收款计划",
    theorypaydate_days2: "预计收款日期",
    perrate2: "约定收款比例(%)",
    persum2: "约定收款金额",
    payplan3: "收款计划",
    theorypaydate_days3: "预计收款日期",
    perrate3: "约定收款比例(%)",
    persum3: "约定收款金额",
    opinionTitle: "合同审批信息",
    deptopinion: "承办部门意见",
    signopinion: "会签部门意见",
    finaceopinion: "财务部门意见",
    lawopinion: "法律部门意见",
    manageopinion: "管理层意见",
    fileTitle: "合同正文和附件信息",
    usecontext: "合同范本类型",
    firstPage: "首页",
    contractCreate: "合同新建",
    contractContent: "合同审批",
    pre_contractname: "原合同名称",
    pre_contractcode: "原合同编号",
    iftradechange: "是否涉及金额变更",
    cooperationtype: "是否合作分成",
    currencytype: "币种",
    pre_tradesum: "原合同金额",
    tradesumchange: "变更后合同差额",
    changetradesum: "变更后金额",
    concodedate: "编号生成日期",
    finaldate: "定稿日期",
    stampdate: "签署日期",
    stampuser: "签署人员",
    signenddate: "生效日期",
    signenduser: "生效人员",
    archivedate: "归档日期",
    archiveuser: "归档人员",
    applyuser: "承办人",
    applyarea: "承办单位",
    applydept: "承办部门",
    signdateenddate: "履行日期",
    status: "状态",
    legalofficer: "主办法律事务专员",
    signuser: "会签部门",
    tradesumstandard: "折算本位币金额",
    signTitle: "签约依据",
    poweranalyzeflag: "签约依据",
    powerfile: "签约依据附件",
    pbasecontext: "备注说明",
    htfiletype: "合同范本类型",
    contractproper: "合同正文",
    attachmentinfo: "附件信息",
    signendbook: "备注",
    contractperiod: "合同履行期限",
    postponeddate: "顺延日期",
    paytype: "费用类型",
    finaTitle: "财务税务信息",
    taxitem: "印花税计税品目",
    taxableproperty: "应税属性",
    ifvatinvoices: "是否提供增值税专用发票",
    taxpayertype: "纳税人类型",
    taxpayerno: "纳税人识别号",
    invoicetype: "发票类型",
    exctaxamount: "不含增值税金额",
    taxrate: "税率",
    tax: "税额",
    totalvalorem: "价税合计",
    costtype: "合同支出类型",
    costtype2: "费用属性",
    otherTitle: "附加信息",
    internalappitems: "内控审批项目类别",
    renewcontractflag: "是否续约提醒",
    ifoutsourccon: "是否业务外包合同",
    ifrelatedcon: "是否关联合同",
    relatedcontractid: "关联合同信息",
    frametype: "框架属性",
    frameareas: "框架适用地区",
    sumMoney: "合计",
    framename: "框架名称",
    framecode: "框架编号",
    gencontractcode: "合同编号",
    btnstamp: "已签署未生效",
    btnstampsign: "已签署已生效",
    cancelbtnstamp: "取消签署",
    cancelbtnstampsign: "取消签署和生效",
    stampsucces: "签署成功",
    signsucces: "生效成功",
    cancelstampscucces: "取消已签署成功",
    cancelsignscucces: "取消已签署和生效成功",
    toarchive: "归档",
    archiveend: "已归档",
    templatename: "文本名称",
    templatetype: "合同范本类型",
    versionno: "文本发起号",
    btnContractWrod: "自拟WORD文本",
    btnContractTemplate: "规范文本",
    templateCreateTime: "登记时间",
    approvedate: "正式入库时间",
    templateTitle: "合同规范文本审批表",
    arearange: "适用范围（可多选）",
    templateConcode3class: "适用合同类型",
    templateFile: "规范文本附件",
    templateOtherFile: "其它附件",
    btnUploadFile: "上传附件",
    currstatus: "流程步骤",
    month: "月",
    remindingtime: "续约提醒时间",
    accountmanuname: "供应商名称",
    accountmanuno: "供应商编号",
    srcbankname: "原开户银行",
    srcaccountname: "原开户名称",
    srcbankaccounts: "原开户账号",
    chgbankname: "变更后开户银行",
    chgaccountname: "变更后开户名称",
    chgbankaccounts: "变更后开户账号",
    accountchangefile: "账户变更依据",
    accountTitle: "合同对方收款账户变更审批",
    finalpdf: "定稿",
    uploadsignpage: "上传签章页",
    contractexecutor: "合同履行人员",
    perifrequency: "频率",
    perieachamount: "每期金额",
    sealednomore: "已签署不能再进行已签署操作！",
    nosigned: "已生效不能再进行已签署已生效操作！",
    nocancelsign: "未生效无需进行取消“已签署和生效”操作!",
    nostamp: "未签署无需进行取消签署操作！",
    pleaseinputcontract: "请输入合同编号",
    pleaseclickseach: "请点击查询按钮！",
    seachcontracterror: "根据合同编号未找到相关单据信息！",
    billno: "单据编号",
    billtime: "单据日期",
    description: "履约描述",
    performdoc: "履约文档",
    performanceTitle: "合同履行相关文档录入审批表",
    ifcounterpartychange: "是否对方主体变更",
    transfertype: "转让类型",
    ifsrccounterparty: "是否原合同对方",
    cancelBtn: "撤销",
    sureCancelContract: "确认对合同发起撤销?",
    nostampsign: "已生效的合同不能进行取消签署操作！",
    archivemsg: "归档成功！",
    pleaseupload: "请先下载安装以下相关软件！",
    contractperform: "履约记录",
    btnStopCancel: "终止撤销",
    stopCancelMsg: "终止撤销成功！",
    stopCancelMsg1: "终止撤销失败！",
    stopCancelMsg2: "原步骤不存在不能终止撤销！",
    stopCancelError: "终止撤销失败！",
    revokereason: "撤销原因",
    beginRevoke: "发起撤销失败！",
    beginRevoke1: "原步骤不存在，不能发起撤销！",
    extendedtype1: "顺延至",
    extendedtype2: "无期限顺延",
    ifmainsupplier: "是否主设备供应商",
    delafterflow: "删除成功",
    checkstock: "合同已生成订单不能发起撤销",
    checkcfmoney: "财务已占用不能发起撤销",
    btnCSPF: "生成CSPF",
    btnSendMail: "邮件通知",
    btnSend: "发送",
    mailTitleInfo: "邮件内容",
    defaultMailInfo: "您好:\n    {contractname}已生成Contract Signing Procedure Form，请接收，谢谢！",
    defualtSignMailInfo: "您好:\n  Contract number{contractcode}has been signed and already effective.",
    defualtSendMail: "发送成功",
    tradeterms: "贸易术语",
    ifperiodic: "是否周期性",
    ifproject: "是否项目合同",
    exportregulations: "出口管理条例",
    payremark: "备注",
    titleandrist: "所有权与风险转移",
    deliveryservicedate: "交货/服务日期",
    bond: "债券",
    liabilityforbreach: "违约责任",
    operatetype: "起草分类",
    signdate: "履行开始日期",
    enddate: "履行结束日期",
    region: "区域",
    siteid:"站点 ID",
    potemplate:"采购订单批准模板",
    major:"专业",
  },
  contractguarantee: {
    guaranteeTitle: "银行保函",
    ifguarantee: "是否涉及银行担保",
    guaranteetype: "银行担保类型",
    issuingmethod: "担保签发方式",
    issuingdate: "银行保函签发日期",
    aftersign: "签署后天",
    proportion: "担保比例",
    returndate: "银行保函返回日",
    issuinglocation: "银行保函签发地点",
    guarcurrency: "担保货币",
    personnel: "合同对方合同人员",
    partbemail: "合同对方邮箱",
  },
  contractntko: {
    ntkodesc1: "未安装PDFCREATE",
    ntkodesc2: "不能装载文档控件,请在检查浏览器的选项中检查浏览器的安全设置。",
    ntkodesc3: "尚未安装NTKO Web FireFox跨浏览器插件",
    ntkodesc4: "暂不支持其他浏览器",
    ntkodesc5: "vue集成ntko示例浏览器参数：",
  },
  contractselect: {
    companyCode: "选择公司代码",
    signingType: "选择合同签订类型",
    paymentType: "选择付款类型",
    incomeType: "选择收入类型",
    department: "选择部门",
  },
  contractsendinfo: {
    sendtype: "接口类型",
    sendinfobtn: "重发",
    contractid: "合同ID",
    requestdata: "发送报文",
    resposedata: "反馈报文",
    sendinfo: "重发",
  },
  contractstock: {
    stockresult: "采购结果",
    projcode: "项目编码",
    projname: "项目名称",
    projsum: "项目分摊金额",
    resultno: "采购结果编号",
    resultname: "采购结果名称",
    checkselectmsg: "采购结果需求来源不一致，不能选择",
    checksignmodemsg: "采购结果签约模式不一致，不能选择",
  },
  contractorder: {
    signcode: "订单发起号",
    contractcode: "订单合同编号",
    contractname: "采购订单名称",
    partatype: "公司名称",
    contractfactbook: "订单内容概述",
    tradesum: "订单价税合计总额",
    ordertotalprice: "订单价款总额",
    ordertotaltax: "订单税款总额",
    exchangerate: "汇率",
    funcurrency: "本位币币种",
    tradesumstandard: "本位币金额",
    applyarea: "订单创建单位",
    applyusername: "订单创建人",
    orderstardate: "订单履行日期起",
    orderenddate: "订单履行日期止",
    arrivaldate: "双方约定到货日期",
    pre_contractcode: "原订单编号",
    pre_contractname: "原订单名称",
    pre_tradesum: "原订单金额",
    cancelbegin: "发起撤销成功",
  },
  contractstatus: {
    revokestatus: "(已撤销)",
    stampstatus: "(已签署)",
    signstatus: "(已签署已生效)",
    archivestatus: "(已生效-已归档)",
  },
  contractcheck: {
    countpartblist: "签约主体对方名称行项记录至少填写一条记录！",
    countpaylist: "履约信息行项记录至少填写一条记录！",
    template3class: "请先选择合同类型!",
    signpage: "必须上传签章页!",
    contractword: "必须上传合同正文!",
    checkselectpay: "“付款方式”、“付款方式描述”两者必须填写一项!",
    checkselectpay2: "“收付方式”、“收付方式描述”两者必须填写一项!",
    fileupload: "请先点击[上传到服务器]按扭",
    filenum: "当前限制上传文件数量:",
    filetype: "只能上传文件类型:",
    bsscheck1: "该单据ID已生成合同，请核查！",
    bsscheck2: "该单据ID已解除或生成变更合同在途单，请核查！",
    bsscheck3: "该单据ID已解除或生成变更合同在途单，请核查！",
    bsscheckcancel: "该单据ID已生成合同撤销单或不支持发起合同撤销，请核查！",
    checkcontractcode: "请先生成合同编号!",
    checkFinalPdf: "请先进行定稿操作！",
    checkifmainsupplier: "主设备供应商只能选择一个",
    checkifmainsupplier2: "主设备供应商必须选择一个",
    checkremovecfmoney: "财务已占用金额不能解除合同",
    checkremovecgmoney: "合同存在订单不能进行解除操作",
    checkCGOrderMoney: "供应商分摊金额不能小于已生成的订单金额",
    checkCGFrameMoney: "合同存在在途订单不能进行变更操作",
    checkStockResult: "请先选择采购结果",
    checkcspf: "生成失败",
    checkhttradesum: "合同金额必须大于0",
    checkfundflag: "请选择收付类型",
    checkframeflag: "请选择签约类型",
    checkpartatype: "请选择公司主体",
    checkcooperatetype: "请选择合作分成方式",
    checkCanxelBss: "不符合条件，不能进行撤销操作",
    checkSignPage: "合同未签约生效，请签约生效后，再上传签字页",
    checkMaxSize: "不能超过系统限定的大小{0}M",
    checkUploadSuccess: "正在上传请稍等",
    checkcontractname: "合同名称必填",
    checkcspfsuccess: "CSPF文件生成成功",
    checktradesumformat: "合同金额不能是千分位格式",
    checksignuser: "“无会签部门”不能与其它部门一起，选择请删除“无会签部门”",
    checkrelation1:"{0}是内部供应商，是否内部交易必填且只能为是",
    checkrelation2:"{0}是内部供应商，是否内部交易必填且只能为是",
    checkrelation3:"{0}是内部供应商，关联交易类型必填",
    checkrelation4:"{0}是内部供应商，内部交易类型必填",
    checkpdffinal:"定稿成功",
    checkpdffail:"定稿失败",
    checkcutoverword:"第{0}行合同正文为空",
    checkcutoversign:"第{0}行签字页为空",
    checkpowerfile:"请上传“签署的MOC”作为证明文件",
    
  },
  contractcutover: {
    cutovercode: "割接编号",
    cutoverTitle: "合同附件割接",
    fileproper: "附件",
    fileattachment: "合同正文",
    fileapproval: "合同审批稿",
    filesign: "合同签章页",
    fileother: "其它附件",
    filepower: "签约依据附件",
  },
  problem: {
    problemTitle: "合同问题审批表|合同问题审批表",
    problemcode: "问题编号|问题编号",
    questiontitle: "问题标题|问题标题",
    revisedcontents: "修订内容",
    applyusername: "发起人",
    applydate: "登记日期",
    curruser: "当前办理人",
    currstatus: "流程状态",
    problemtype: "问题类型|问题类型",
    revisewhyreason: "修订原因和理由",
    dealremark: "运维人员处理结果",
    dealdate: "办理时间",
    applyadvice: "承办人确认",
    finishdate: "办理时间",
    contractcodeandname: "合同编号/合同名称",
    applyusertel: "承办人电话",
    contractstatus: "合同状态",
    probleminfo: "问题概况",
    opinionTitle: "问题单审批信息",
    problemMsg1: "(友情提示：需要修正审批中、已签约、已归档的合同审批表单上的错误信息。)",
    problemMsg2: "(友情提示：需要修正审批中的合同附件（如合同审批稿、其他附件）中的错误信息。)",
    problemMsg3: "(友情提示：需要补充框架适用单位。)",
    checkcontract: "问题类型为“修改合同文本及附件”，不能选择已归档的合同。",
  },
  impExcel: {
    title: "EXCEL导入",
    impFormat: "导入格式",
    impTemplate: "导入模板",
    impMethod: "导入方式",
    over: "覆盖",
    append: "追加",
    impdesc: "说明",
    impRemark: "追加是指在现有的基础上新增，覆盖是指本次导入覆盖之前所有的清单。",
    impExcelFile: "Excel文件导入",
    selUpFile: "选择上传文件",
    browse: "浏览",
    import: "导入",
    impDesc: "只能上传.xls,.xlsx文件",
    impErrorIdx: "序号",
    impErrorMsg: "错误信息",
    impLimitMsg: "只能选择1个文件!",
    selOneFileMsg: "请选择文件!",
    upSuccessMsg: "配时文件上传成功!",
  },
  itemlist: {
    titeData: "项目立项",
    indexMethod: "序号",
    tabname: "列表",
    checkboxT: "选择",
    itemcode: "项目编码",
    itemname: "项目名称",
    projmanager: "项目经理",
    applyuser: "创建人",
    applyarea: "创建单位",
    applydept: "创建部门",
    currstatus: "当前办理步骤",
    curruser: "当前办理人",
    id: "主键",
    addbut: "新增",
    delbut: "删除",
    savebut: "保存",
    title: "项目立项",
    tabmain: "基本信息",
    detailtitle: "建设项目信息",
    detailtitlesec: "项目分解",
    investyear: "投资年度",
    managementunit: "立项管理单位",
    itemleader: "立项管理员",
    itemapproveamount: "立项金额（元）",
    constructunit: "建设单位",
    itemthisyearsum: "本年投资额（元）",
    itemspeccode: "一级专业",
    itemsubspeccode: "二级专业",
    planbegindate: "计划启动日期",
    planenddate: "计划完工日期",
    managemode: "项目类型",
    itemdesigntype: "设计类型",
    itemchecktype: "验收类型",
    companycode: "公司代码",
    profitcenter: "利润中心",
    belongregion: "所属区域",
    buildmotivation: "建设理由",
    resourcestatus: "资源现状",
    itembuildcontent: "建设内容",
    file: "附件",
    fileup: "附件上传",
    intputmoney: "请输入金额",
    intputseldate: "请选择日期",
    toselect: "请选择",
    investtype: "投资渠道",
    itemstatus: "项目状态",
    home: "首页",
    projectlist: "子项目列表",
    projcode: "子项目编码",
    projname: "子项目名称",
    manager: "子项目经理",
    projinvestsum: "预计总投资额（元）",
    expList: "导出",
    reset: "重置",
    query: "查询",
    applydate: "发起时间",
    buscate: "业务大类",
    debuscate: "业务细类",
    itemapplydate: "项目办结日期",
    sentosap: "发送SAP",
    deliverloadlist: "交付资产列表",
    itembudgetsum: "项目预算",
    itemthisbudgetsum: "项目本年预算",
    projapprovaldocno: "立项批复文号",
    basestationaccessmode: "基站接入方式",
    longitude: "经度",
    latitude: "纬度",
    constructcontent: "建设内容",
    itemimpexcel: "项目信息导入",
    projimpexcel: "子项目信息导入",
    srvimpexcel: "服务订单导入",
    srvrowimpexcel: "服务订单行向导入",
    smimpexcel: "项目物料服务登记导入",
    srvprojornot: "是否服务项目",
    relatedeqsubproj: "关联设备子项目",
    assistant: "助理",
    checkprojname:"子项目名称不能重复!",
    
    //审批信息
    approvalinfo:"审批信息"
  },
  itemchange: {
    changetype: "项目变更类型",
    title: "项目变更\/终止",
    taptitle: "项目变更\/终止",
    ifcancel: "是否取消本项目",
    preamount: "原立项金额",
    prethisyearsum: "原本年投资额",
    changeamount: "调整后立项金额",
    changethisyearsum: "调整后本年投资额",
    chgagreedate: "变更批复日期",
    chgagreeno: "变更批复文号",
    signdept: "会签部门",
    remark: "变更理由",
    changebefore_thisyearsum: "原本年投资总额",
    changeafter_thisyearsum: "调整后本年投资总额",
    changebefore_investsum: "原预计投资总额",
    changeafter_investsum: "调整后预计投资总额",
    chgprojmanager: "调整后主项目经理",
    ifcancelproj: "是否取消本子项目",
    rowtitle: "子项目信息（元）",
    tip1: "调整后立项金额不能为空",
    tip2: "本次变更金额大于可用预算",
    tip3: "请输入正确的变更后金额",
    tip4: "变更后本年投资不能大于总投资",
    tip5: "子项目变更后总金额不能大于项目变更后金额",
    tip6: "请先选择变更类型再进行新增",
    aftprojmanager: "变更后项目经理"
  },
  design: {
    designntitle: "设计标题",
    designtype: "设计类型",
    designtage: "设计阶段",
    designcode: "设计批复编码",
    designname: "设计批复标题",
    designwtcode: "设计委托编码",
    designwtname: "设计委托标题",
    design: "设计信息",
    designpf: "设计录入",
    designwt: "设计委托",
    wtmanuname: "设计委托单位",
    manuname: "设计受托单位",
    reallyfinishdate: "实际完成日期",
    designreplydate: "设计批复日期",
    designdetail: "设计要求",
    designpfinvestsum: "设计金额",
    designpfsum: "批复金额",
    designremark: "设计情况",
    replyramerk: "批复情况",
    designperson: "设计人员",
    designgm: "设计规模",
    designreplycode: "设计批复文号",
    tip1: "请选择同一项目下的子项目",
    tip2: "已选择,请不要重复选择子项目",
    tip3: "请先选择设计类型！",
    firststagedesignunitname: "一阶段设计单位",
    secondstagedesignunitname: "二阶段设计单位",
    bigtitle: "项目服务单位管理单",
    effectivedate: "生效日期",
    checkProjcode: "子项目编码不能为空",
    batchimport: "批量导入",
    unitrowbigtitle:"服务单位明细信息"
  },
  designchange: {
    title: "设计变更",
    taptitle: "设计变更",
    projcode: "子项目编码",
    projname: "子项目名称",
    changetumes: "变更次数",
    changedate: "变更日期",
    predesignsum: "原设计金额",
    chgdesignsum: "变更后设计金额",
    changreason: "变更原因及变更内容",
    chgreplysum: "设计变更批复金额",
    designreplydate: "设计变更批复日期",
    designreplyno: "设计变更批复文号",
    designreplyname: "设计变更批复文件名称",
    replytitle: "批复信息",
    tip1: "请输入正确的 ",
    tip2: "子项目的设计批复金额不能大于项目的总投资",
    tip3: "存在在途单据"
  },
  itemanalyze: {
    chstatus: "当前状态",
    itemanalyze: "项目分解",
    finishbut: "分解完成",
    analyzeflag: "最终分解完成",
    calanalyzeflag: "取消最终分解完成",
    tip1: "请先分解完成本次分解的子项，再进行最终分解！",
    tip2: "分解的子项目预计总投资总和，不能大于项目的立项金额！",
    tip3: "分解的子项目本年投资额不能大于预计总投资额！",
    tip4: "分解的子项目本年投资额总和，不能大于项目的本年投资额！",
    tip5: "当是否服务项目选择'是'，关联设备子项目不能为空！"
  },
  budgetapproval: {
    taptitle: "预算下达/调整",
    title: "预算下达/调整",
    year: "下达年度",
    version: "版本号",
    valid: "是否生效",
    speccode: "投资专业",
    ifcontrol: "是否严控",
    control: "严控",
    budgetsum: "下达预算",
    zybudgetsum: "已占用预算",
    ysxbudgetsum: "已生效预算",
    combut: "生效",
    sykybudgetsum: "剩余可用预算",
    exxdbudgetsum: "前一版下达预算",
    allspeccode: "全专业",
    kybudgetsum: "可用预算",
    ifvalid: "是否确认生效",
    tip1: "全专业合计 的下达预算不能小于已占用预算！",
    tip2: "下达预算不能小于已占用预算！",
    check: "校验",
    yes: "是"
  },
  projbegin: {
    beigintitle: "开工标题",
    begindate: "实际开工日期",
    planbegindate: "计划开工日期",
    begincode: "开工编码",
    title: "开工管理",
    projinvestsum: "子项目总投资",
    execunitid: "施工单位",
    moniunitid: "监理单位",
    constructscale: "建设内容",
    safefile: "安全事项清单",
    otherfile: "其他附件"
  },
  projend: {
    endtitle: "完工标题",
    enddate: "实际完工日期",
    planenddate: "计划完工日期",
    endcode: "完工编码",
    title: "完工管理",
    projinvestsum: "子项目总投资",
    execunitid: "施工单位",
    moniunitid: "监理单位",
    constructscale: "项目建设情况",
    safefile: "安全事项清单",
    otherfile: "附件"
  },
  firstcheck: {
    title: "初验批复",
    taptitle: "初验批复",
    lzworkplan: "列账进度",
    sgdw: "施工单位",
    jldw: "监理单位",
    begindate: "开工日期",
    enddate: "完工日期",
    firstcheckcode: "初验批复编码",
    firstchecktitle: "初验批复标题",
    remark: "项目验收内容",
    leftproblems: "初验遗留问题",
    fileup: "验收事项清单",
    firstcheckdate: "实际初验日期",
    checkprojpacbatch:"子项目不在同一个PAC批次",
    ossstatus:"OSS状态"
  },
  finalcheck: {
    title: "终验批复",
    taptitle: "终验批复",
    lzworkplan: "列账进度",
    sgdw: "施工单位",
    jldw: "监理单位",
    begindate: "开工日期",
    enddate: "完工日期",
    finalcheckcode: "终验批复编码",
    finalchecktitle: "终验批复标题",
    remark: "子项目验收内容",
    leftproblems: "终验遗留问题",
    fileup: "验收事项清单",
    finalcheckdate: "终验日期",
    finalchecksum: "终验金额",
    checkprojpacbatch:"子项目不在同一个PAC批次或验收类型"
  },
  asset: {
    finalacctcode: "业务单据号",
    startdate: "开始时间",
    enddate: "结束时间",
    fttitle: "项目交付",
    tapfttitle: "项目交付",
    tap2title: "会计凭证",
    applyuser: "发起人",
    applydate: "发起时间",
    projinvest: "子项目预计总投资",
    projsjinvest: "子项目总投资",
    accountsum: "列账金额",
    tabtitle1: "FT项目负责人填写",
    agreeflag: "是否确认",
    expandflag: "建卡方式",
    oripcardno_krsb: "扩容设备原固定资产卡片编号",
    originpcardno: "大修资产原资产卡片号",
    area: "所属地区",
    assetcategory: "资产分类",
    assetcatalog: "固定资产目录",
    assetname: "资产名称",
    spec: "规格型号",
    val: "数量",
    unit: "计量单位",
    checkdate: "验收日期",
    vendor: "生产厂家",
    tradesum: "设备采购合同价(元)(不含增值税)",
    tabtitle2: "网运填写",
    managedepartment: "实物管理部门",
    checkinput: "实物管理员",
    dept: "使用部门",
    materialman: "保管员",
    dutyman: "使用人",
    costcenter: "成本中心编码",
    tabtitle3: "FT项目负责人填写",
    eqpno: "实物ID",
    address: "所在地址",
    jobcostclass: "作业成本资产类别",
    tabtitle4: "sap分摊后反馈",
    equipsum: "设备金额（元）",
    otherfee: "待摊金额(元) ",
    assetdeliversum: "交付资产价值（元）",
    tabtitle5: "预资部/财务部资产管理负责审核",
    voucher: "产权凭证",
    depreciation: "折旧年限",
    remark: "备注",

    eqpno_popup_title: "关联实物ID",
    eqpno_popup_save: "保存",
    sno: "序号",
    companycode: "公司代码",
    finaareacode: "利润中心组",
    accountyear: "记账年度",
    completedate: "凭证完成日期",
    voucherno: "凭证编号",
    zbvoucherno: "自编凭证号",
    voucherman: "制证人",
    chgsum: "凭证金额(元)",
    thisacctchgtotal: "本次凭证金额小计:"
  },
  close: {
    closeproj: "是否关闭",
    close: "关闭",
    open: "开启",
    alclose: "已关闭",
    alopen: "已开启",
    teclose: "技术性关闭",
    teopen: "技术性开启",
    ficlose: "关闭",
    fiopen: "开启",
    closeitemmsg: "确定关闭该项目吗?",
    closeprojmsg: "确定关闭该子项目吗?",
    openitemmsg: "确定开启该项目吗?",
    openprojmsg: "确定开启该子项目吗?"

  },
  projsrventry: {
    signcode: "合同发起号",
    contractcode: "合同编号",
    contractname: "合同名称",
    contractuser: "合同承办人",
    contractmanuno: "供应商编码",
    contractmanu: "供应商",
    contractmanuname: "供应商名称",
    srvcode: "服务订单编号",
    srvname: "服务订单名称",
    contractcurrency: "币种",
    srventryamount: "服务订单总金额",
    applydate: "创建日期",

    bigtitle: "服务订单",
    baseinfo: "基本信息",
    applydate2: "发起时间",
    applyuser: "发起人",
    belongregion: "所属地区",
    contractamount: "合同总金额",
    yscfwtmamount: "已创建服务订单总金额",
    pricetotal: "价款总金额",
    taxtotal: "税款总金额",
    pricetaxtotal: "价税合计总额",
    contractpaytype: "付款方式",
    exchangerate: "汇率",
    checkpricetaxtotal: "价税合计总额与已创建服务订单总金额合计值不能大于合同总金额!",
    checksubmajor: "子专业不能为空!",

    rowbigtitle: "服务订单明细信息",
    number: "序号",
    srvrowid: "行项ID",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    stocknum: "数量",
    price: "单价（不含增值税）",
    price1: "单价",
    costprice: "价款（不含增值税）",
    taxrate: "增值税税率(%)",
    taxprice: "增值税",
    totalsum: "价税总金额",
    remarks:"备注",

    occupynum: "占用数量",
    prepayment: "预付款金额",
    progresspayment: "进度付款金额",
    opertype: "操作",
    payrecord: "付款记录",
    bigtitle2: "服务订单查询",
    billcode: "表单号",
    payment: "付款金额",
    paydate: "付款时间",
    usenumber: "使用数量",
    major: "专业",
    submajor: "子专业",
    ppacceptedqty: "进度款确认数量",
    pacacceptedqty: "初验确认数量",
    facacceptedqty: "终验确认数量",
    payer: "付款人",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    shareflag: "全区共用",
    paybaseassessment: "依据考核付款",
    createdaterange: "创建日期范围",
    applyusername: "创建人",
    contractusername: "合同发起人",
    frameflagname: "合同签署类型",
    contractamount_que: "合同金额",
    paymentsumform:"付款进度汇总单"
  },
  itemasset: {
    bigtitle: "交资转固",
    applyuser: "发起人",
    applydate: "发起日期",
    finalacctcode: "表单号",
    projcode: "F&T子项目编码",
    projname: "F&T子项目名称",
    settlematerialamountdito: "结算材料金额-DITO",
    settlematerialamountft: "结算材料金额-F&T",
    settleserviceamount: "结算服务金额",
    capinterestrate: "资本化利息利率",
    supervisionfeerate: "监理费利率",
    siteselectionfeerate: "站点选址利率",
    capinterestamount: "资本化利息金额",
    supervisionfeeamount: "监理费金额",
    siteselectionfeeamount: "站点选址金额",
    assetmode: "交资方式",
    resourcesysstatus: "资源系统状态",
    acceptancedate: "验收日期",
    sapassetstatus: "SAP状态",
    sapeostatus:"SAP EO状态",
    fixedassetsamount: "转固金额",
    tariffamount:"关税金额",

    settletab: "结算表",
    price:"单价(不含税)",
    costprice:"总价(不含税)",
    pono: "F&T PO号",
    contractcode:"F&T合同编号",
    eono: "EO号",
    verpramount:"本位币总价",

    assettab: "固定资产",
    agreeflag: "是否确认",
    expandflag: "建卡方式",
    oripcardno_krsb: "扩容设备原固定资产卡片编号",
    originpcardno: "大修资产原资产卡片号",
    area: "组织区域",
    assetcategory: "资产分类",
    assetcatalog: "固定资产目录",
    assetname: "资产名称",
    spec: "规格型号",
    val: "数量",
    unit: "计量单位",
    checkdate: "验收日期",
    vendor: "生产厂家",
    tradesum: "设备购置价",
    tabtitle2: "网运填写",
    managedepartment: "资产管理部门",
    checkinput: "资产管理员",
    dept: "使用部门",
    materialman: "保管员",
    dutyman: "使用人",
    costcenter: "成本中心",
    eqpno: "实物ID",
    region: "大区",
    province: "省",
    city: "市",
    barangay: "村（社）",
    address: "所在地址",
    cipmaterialdito:"材料-DITO",
    cipmaterialft:"材料-F&T",
    cipservice:"服务",
    cipsupervision: "CIP-监理金额",
    cipinterest: "CIP-资本化利息金额",
    cipsite: "CIP-站点选址金额",
    ciptariff: "CIP-关税",
    assetvalue: "卡片总价值",
    assetno: "资产卡片号",
    voucher: "产权凭证",
    depreciation: "折旧年限",
    remark: "备注",
    ifimports: "是否缴纳关税",
    documentno: "凭证号",
    eosumtab:"EO汇总",
    settleamount: "结算金额",
    settleamountphp: "结算金额（PHP）",
    convertcurrency:"币种转换",
    ifconvertcurrency:"确定币种转换操作吗?",
    viewoss:"查看OSS",
    checkresourcesysstatus:"当前资源系统状态是OSS未完成!",
    financeassignment:"财务分摊"
  },
  moneyrate:{
    month:"月份",
    version:"版本号",
    status:"状态",
    effectivedate:"生效日期",
    bigtitle:"汇率和利率维护",
    currency:"币种",
    eono:"EO号",
    exchangerate:"汇率",
    capinterestrate:"资本化利息利率",
    exchangerate2:"汇率2",
    checkMonth: "月份不能为空",
    tariffrate:"关税利率",

    mode1:"方式1",
    mode2:"方式2",
    describe1:"发起交资转固，触发OSS 资源管理系统编制交资表并完成资产确认流程，该方式适用于网络类项目",
    describe2:"发起交资转固，在MSS辅助系统编制交资转固表并完成资产确认流程，该方式适用于非网络类项目",
    majorcode:"专业编码",
    major:"专业名称",
    makeway:"交资方式"
  },
  settledbyft:{
    projcode:"F&T子项目编码",
    projname:"F&T子项目名称",
    pacformcode:"PAC表单号",
    pacformname:"PAC表单名称",
    ftdeliverydate:"F&T交付日期",
    manager:"F&T子项目经理",
    projincnum:"含子项目数",
    opertype:"操作",
    hanle:"办理",
    submitfinancenum:"提交财务数",
    bigtitle:"F&T结算子项目",
    bigtitle2:"PAC批次",
    major:"一级专业",
    submajor:"二级专业",
    currflow:"当前进度",
    curruser:"办理人"
  },
  projsrvprepay: {
    bigtitle: "服务预付款登记单",
    prepaycode: "服务预付款登记单编号",
    prepayname: "服务预付款登记单名称",
    prepaymentamount: "预付款金额",
    applydate: "发起日期",
    status: "状态",
    prepaymenttotal: "预付合计金额",
    srvrowidori: "行项ID",
    prepayment: "预付款金额（不含税）",
    prepaydate: "付款到期日",
    checkcurrencyandmanuno: "只能选择币种相同、供应商相同的服务条目单!",
    checkSrvcode: "服务条目单编码不能为空!",
    checkprepayment: "预付款金额不能大于价款!",
    paymentrate: "付款比例(%)",
    beforegolive: "系统上线前历史数据"
  },
  projpay: {
    paycode: "项目进度付款汇总单编号",
    payname: "项目进度付款汇总单名称",
    belongregion: "所属区域",
    currency: "币种",
    currstatus: "状态",
    bigtitle: "项目进度付款汇总单",
    baseinfo: "基本信息",
    rowbigtitle: "汇总信息",
    taxrate: "税率",
    paytype: "类型",
    alreadmoney: "预付款/到货款金额",
    paymoney: "已付进度款金额",
    thispayment: "本次付款金额（不含税）",
    outsourcecode: "委外单编码",
    srvcode: "服务订单编号/采购订单号",
    totalpayment: "本次付款合计金额",
    checkcurrency: "只能选择币种相同的物料服务登记",
    checktotalmoney: "本次付款金额加上已付进度款额金额不能超过价款",
    unitid: "计量单位",
    taxprice: "增值税",
    applyusername: "发起人",
    applydate: "发起起始日期范围",
    milestonepayment: "里程碑付款",
    lastpayment: "最后一次付款"
  },
  projpoeo: {
    bigtitle:"EO导入",
    ponum:"PO号",
    eonum:"EO号",
    applyuser:"发起人",
    applydate:"发起日期",
    effectivedate:"生效日期",
    batchimport:"批量导入"
  },
  projsettle: {
    bigtitle: "项目结算单",
    settlecode: "结算单编号",
    tabpanetable: "结算表",
    tabpaneadd: "结算加成表",
    tabpanedetail: "结算明细物料表",
    tabpanesummary: "结算汇总表",
    outsourcecode: "委外单编号",
    managemode: "管理属性",
    outmanuno: "委外供应商",
    ifimports: "是否缴纳关税",
    addrate: "加成率(%)",
    expexcel: "导出",
    deliverfee: "交付金额",
    checklastpayment: "请先完成服务费用的最后一次付款登记",
    verpr: "本位币单价",
    verpramount: "本位币金额",
    costpricesum: "成本金额（不含税）",
    deliverfeesum: "收入金额（不含税）",
    amount: "金额（含税）",
    receivableprogress: "应收账款（进度款）不含税",
    receivablesettle: "应收账款（结算款）不含税",
    verprcostamount: "本位币成本金额（不含税）",
    verprreceivable: "本位币应收金额（不含税）",
    sendtosap:"传送SAP",
    sapstatus:"SAP状态",
    ifsendtosap:"是否传送SAP",
    tabpanedocumentno:"凭证号表",
    costdocno:"成本凭证号",
    recdocno1:"应收凭证编号1",
    recdocno2:"应收凭证编号2",
    recdocno3:"应收凭证编号3",
    costreversedocno:"成本冲销凭证号",
    arreversedocno1:"应收凭证编号1",
    arreversedocno2:"应收凭证编号2",
    arreversedocno3:"应收凭证编号3"
  },
  projsummary: {
    summarytitle: "服务订单进度汇总",
    summarycode: "服务订单进度汇总单号",
    summaryname: "服务订单进度汇总单名称",
    totaldate: "数据汇总日期范围",
    summarymonth: "月份",
    startdate: "数据汇总开始日期",
    enddate: "数据汇总结束日期",
    applydate: "发起日期",
    addrate: "加成率",
    eonumber: "EO号",
    stocknum: "采购数量",
    costprice: "总价（不含税）",
    currency: "币种",
    completednum: "完成数量",
    completedprice: "完成数量总价（不含税）",
    completedaddprice: "完成数量加成总价（不含税）",
    completedtotal: "完成数量总价（含税）",
    manuname: "供应商",
    checkstartdate: "请选择数据汇总日期范围",
  },
  projsm: {
    bigtitle: "项目物料服务登记单",
    designreplysum: "设计批复金额",
    materialsum: "物资金额",
    servicesum: "服务费金额",
    investsum: "子项目预计成本",
    opertype: "操作",
    input: "录入",

    rowbigtitle: "子项目关联信息",
    type: "类型",
    advancepayment: "预付款金额",
    outsourcecode: "委外单编号",
    itemorbillcode: "服务订单编号/采购订单号",
    managemode: "管理属性",
    ifimports: "是否缴纳关税",
    editnum: "修改数量",
    outmanuname: "委外供应商",
    tip1: "登记数量不能大于剩余数量",
    tip2: "登记数量不能为空",
    tip3: "类型不能为空",
    tip4: "提示：这行未生效",
    moneycheck1: "行 {rowindex}:单价*数量必须等于价款",
    moneycheck2: "行 {rowindex}:价款+税款必须等于总价",
    sendoss: "发送OSS",
    sendsuccess: "发送成功",
    validrowdate: "生效日期"
  },
  queryproj: {
    title: "子项目全景视图",
    projstatus: "子项目状态",
    tab1: "基本信息",
    tab2: "投资",
    tab3: "设计",
    tab4: "采购",
    tab5: "合同",
    tab6: "施工",
    tab7: "领料",
    tab8: "验收",
    tab9: "列账",
    tab10: "交资",
    tab11: "审批信息",
    designtab: "一阶段设计",
    designtabsec: "初步设计",
    designtabsec2: "施工图设计",
    tztab2: "总投资/预算占用明细",
    batchtab: "施工信息",
    checktab1: "初验信息",
    checktab2: "终验信息",
    firstcheckdate: "初验日期",
    finalcheckdate: "终验日期",
    belnr: "凭证编号",
    budat: "记账日期",
    bldat: "凭证日期",
    kstar: "成本要素",
    matnr: "物料编号",
    maktx: "物料描述",
    mbgbtr: "输入的总数量",
    wtgbtrs: "借方金额",
    wtgbtrh: "贷方金额",
    uprice: "单价",
    meinb: "计量单位",
    usnam: "操作用户",
    refbn: "参考凭证号",
    ebeln: "采购凭证号",
    zddlsh: "采购订单流水号",
    proninvestsum: "子项目分解金额",
    designsum: "概算批复金额",
    designdate: "概算批复日期",
    ztys: "项目总体预算",
    ndys: "项目当前年度预算",
    xmkyyszt: "项目可用总体预算",
    xmzyyszt: "项目已占用总体预算",
    xmkyysnd: "项目可用年度预算",
    xmzyysnd: "项目已占用年度预算",
    assetdate: "交付日期",
    assetno: "交付凭证",
    alltab1: "项目立项",
    alltab2: "子项目设计",
    alltab3: "设计变更",
    alltab4: "开工管理",
    alltab5: "完工管理",
    alltab6: "初验",
    alltab7: "终验/一次性验收",
    alltab8: "项目交付",
    ebelp: "采购凭证的行项目编号",
    netwr: "采购订单货币的订单净值",
    dmbtrt: "订单收货金额",
    dmbtrs: "服务收货金额",
    reewr: "发票金额（不含增值税 ）",
    reevat: "发票金额（增值税）",
    reewrvat: "发票金额（含增值税）",
    status: "订单状态",
    elikz: "是否收货完成",
    menge: "数量",
    netpr: "单价",
    lifnr: "供应商名称",
    aedat: "订单创建日期",
    zhshhrq: "最后一次收货日期",
    zhfprq: "最后一次发票日期",
    zextdocno: "领/缴料单据号",
    zeile: "行项目号",
    prdha: "物料目录",
    meins: "单位",
    unitprice: "单价",
    dmbtr: "总金额",
    gysmc: "供应商名称",
    charg: "物料批次",

    presentname: "签约方",
    contractcode: "合同编码",
    contracttype: "合同类型",
    supplier: "供应商",
    contractamount: "合同总金额",
    projtradesum: "合同该工程分摊金额",
    contractstatus: "合同状态",
    signdate: "合同签约日期",
    archivedate: "合同归档日期",

    investsum: "子项目成本",
    sendsapdate: "立项日期",
    deliverydate: "交付日期",
    stationaccessmode: "基站接入方式",
    longandlatitude: "经纬度",
    stoutsourcematerialamount: "受托委外物资金额",
    zcoutsourcematerialamount: "自采委外物资金额",
    stautogestionmaterialamount: "受托自管物资金额",
    zcautogestionmaterialamount: "自采自管物资金额",
    alreadmoney: "预付款/到货款金额",
    paymoney: "进度款金额",
    price: "单价",
    costprice: "价款"
  },
  supplierapply: {
    title: "供应商申请",
    baseinfoTab: "主信息",
    otherinfoTab: "其它信息",
    baseinfoWrap: "基本信息",
    inputTips: "请输入",
    corpfullname: "公司全称",
    shortname: "公司简称",
    suppliercode: "供应商编码",
    suppliergroup: "供应商账户组",
    corptype: "公司类型",
    cooperatebiz: "合作业务",
    supplierdisctype: "供应商法定识别类型",
    relation: "是否内部供应商",
    relationtype: "内部供应商类型",
    buslicensevaliddate: "营业执照有效期",
    buslicenseAttach: "营业执照扫描件",
    reginfo: "供应商注册成立信息",
    regcontinent: "洲",
    regcountry: "国家或地区",
    regprovince: "省份",
    regcity: "城市",
    inputTips4Regprovince: "请输入省份",
    inputTips4Regcity: "请输入城市",
    linktel: "企业固定电话",
    linktel2: "分机号",
    fax: "传真",
    email: "邮箱",
    tipstel: "短信提醒号码",
    legalbodycodeidtype: "法定代表人证件类型",
    legalbodycodeidnum: "法定代表人证件号",
    legalbodycode: "法定代表人/负责人",
    manlinkman: "供应商主要联系人",
    manlinkmantel: "供应商主要联系人电话",
    postaddr: "通讯地址",
    postalcode: "邮政编码",
    corpinfo: "公司概况",
    applydept: "申请人部门",
    applyuser: "申请人",
    chstatus: "流程状态",
    createtime: "创建时间",
    bankinfoWrap: "银行账户信息",
    bankinfoinWrap: "供应商境内银行账户",
    number: "序号",
    accopenprovince: "开户省",
    accopencity: "开户市",
    accopenbank: "开户银行",
    bankcategory: "银行类别",
    accopenname: "开户名",
    accopenaccount: "账户",
    oldaccopenaccount: "原账户",
    combinenum: "联行号",
    func: "对公对私标示",
    isdefault: "默认账户",
    createprovince: "创建省份",
    bankinfooutWrap: "供应商境外银行账户",
    bankname: "银行名称",
    subbankname: "分行名称",
    subbankcode: "分行代码",
    bankaddress: "银行地址",
    payeename: "收款人名称",
    payeeaddress: "收款人地址",
    accounttype: "账户种类",
    payeeaaccountnumber: "收款人户口号码/IBAN号码",
    accountcurrency: "账户币种",
    taxnum: "税号",
    middlebankname: "中间行名称",
    middlebankaccount: "中间行账号",
    middlebankswift: "中间行SWIFT代码",
    middlebankiban: "中间行IBAN号码",
    internationalbank: "是否国际公司银行信息",
    bankareanum: "银行区号",
    bankaccount: "账户",
    eccontactsWrap: "商务联系人信息",
    contactsname: "姓名",
    contactsjob: "职务",
    contactsaddress: "通信地址",
    contactsemail: "邮箱",
    contactslinktel: "固话",
    contactsstatus: "状态",
    btaxWrap: "税务基本信息",
    busitype: "业务类型",
    taxpayercode: "纳税人识别号",
    taxcooperatebiz: "合作业务",
    taxitem: "应税项目",
    busitaxtype: "业务纳税类型",
    taxrate: "应税税率",
    factrate: "实际税率",
    businessrange: "经营范围",
    regfoundcurrency: "注册资本币种",
    regfound: "注册资本",
    createdate: "公司成立日期",
    corpscale: "公司规模",
    familyteleassg: "所有者/高层管理者是否有直系亲属和家庭成员在电信公司任职",
    rootsuppliercode: "母/总公司编码",
    rootsuppliername: "母/总公司名称",
    rootsupplierdisctype: "母/总公司法定识别类型",
    rootsupplierdisctypeval: "母/总公司法定识别码",
    welfarecorp: "是否为残疾人福利企业",
    authencertwrap: "认证证书",
    authencertname: "认证证书名称",
    authencerttype: "认证证书类型",
    authencertenddate: "有效期限",
    hrWrap: "人力资源情况",
    hryear: "年份",
    psncount: "员工总数",
    productorpsncount: "生产人员",
    managerpsncount: "管理人员",
    devpsncount: "研发人员",
    servicepsncount: "服务及技术支持人员",
    marketpsncount: "市场及销售人员",
    businessinfowrap: "公司财务和经营情况",
    businessinfoyear: "年份",
    biregfoundcurrency: "注册资本币种",
    assettotal: "资产总额年末值",
    debttotal: "负债总额年末值",
    debttrate: "资产负债率年末值(%)",
    assettotalavg: "总资产平均余额",
    capitaltotal: "资本公积",
    assetflow: "流动资产年末值",
    assetstore: "存货年末值",
    debtflow: "流动负债年末值",
    speedrate: "速动比率年末值(%)",
    payablemoney: "应付账款余额年末值",
    fundtotal: "货币资金年末值",
    transtotal: "交易性金融资产年末值",
    moneyrate: "现金比率年末值(%)",
    totalincome: "销售收入",
    serviceincome: "主营业务收入",
    servicetaxincome: "主营业务税金及附加",
    serviceprofit: "主营业务利润",
    saleprof: "营业利润",
    yearbeginrecmoney: "应收账款余额年初值",
    yearendrecmoney: "应收账款余额年末值",
    recmoneyavg: "应收账款平均值",
    recmoneyrate: "应收账款周转率(%)",
    devinmoney: "研发投入",
    stockholderassignwrap: "供应商股东构成",
    seniorstockholderratio: "资股东持股百分比",
    stockholdertype: "股东法定身份识别类型",
    stockholdernumber: "股东法定身份识别证件号码",
    stockholdername: "股东全称",
    stockholderratio: "持股比例",
    rootsupplierattach: "母/总公司法定识别证扫描件",
    reqsupplierbankinrow: "请填写供应商境内银行账户行项",
    reqeccontactsrow: "请填写商务联系人信息行项",
    reconcaccountwrap: "统驭科目",
    reconcaccount: "统驭科目",
    assignfile: "附件",
    businessinfofile: "附件",
    bankswift: "银行SWIFT代码",
    postalcodeExactlyCharLength: "内容总长度需等于{0}个字符",
    postalcodeMaxCharLength: "内容总长度不能超过{0}个字符",
    bankinforownoTips: "[银行账户信息]第{0}行",
    impexcel4Main: "供应商主表导入",
    impexcel4Item: "供应商行项导入",
    mainsupplierfile: "法定识别证扫描件",
    bankoutfile: "账号信息证明材料",
    factratevat: "增值税",
    factrateei: "预扣税",
    zzlgys: "租赁供应商标识",
    zterm: "付款条件",
    zwels: "付款方式",
    ztermnotnulltip: "付款条件,必填",
    zwelsnotnulltip: "付款方式,必填",
    regcitynotnulltip: "城市,必填",
    postaddrnotnulltip: "通讯地址,必填",
    nodatadisplay: "未搜索到您所需要的银行信息，请点击右上角“创建银行信息”按钮，新增银行主数据信息",
    tip_email: "1. 可以填写一个或多个电子邮件地址<br/>" +
      "2. 单个电子邮件地址的格式是XXXXX@XXXX，例如paul.xxx@dito.ph<br/>" +
      "3. 用“/”分隔多个电子邮件地址，例如Jane.cabanero@dito.ph/Elizabeth.luo@google.com/Burne-Jones@Gmail.com",
    accredited: "是否通过认证",
    isCWSupplier: "是否财务供应商",
    choosesuppliergroup: "请选择供应商账户组",
    supplierdisctypeval: "供应商法定识别码",
    bankcountry: "银行国家代码",
    suppliergrouplisttip: "一般供应商（Z001\\Z003)、财务供应商（Z002\\Z004\\Z005）"
  },
  supplierchange: {
    title: "供应商变更",
    reqchangesupplier: "请选择需要变更的供应商",
    taxratesingleTips: "增值税、预扣税仅单选!"
  },
  supplierstatus: {
    title: "供应商冻结/解冻",
    buysellstatus: "采购状态",
    paystatus: "支付状态",
    reason: "冻结/解冻原因",
    reqchgstatussupplier: "请选择需要冻结/解冻的供应商",
    choperflag: "申请类型",
    reqchgstatus: "请选择申请类型!",
    title1: "供应商冻结",
    title2: "供应商解冻",
    thawstatusTips: "采购状态与支付状态，请选择其中一个为解冻状态!",
    frozenstatusTips: "采购状态与支付状态，请选择其中一个为冻结状态!",
    thawbuysellstatusTips: "采购状态，请选择为解冻状态!",
    frozenbuysellstatusTips: "采购状态，请选择为冻结状态!",
    thawpaystatusTips: "支付状态，请选择为解冻状态!",
    frozenpaystatusTips: "支付状态，请选择为冻结状态!",
    stitle2: "供应商采购冻结",
    stitle3: "供应商支付冻结",
    stitle4: "供应商采购解冻",
    stitle5: "供应商支付解冻"
  },
  stockorderlist: {
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    stocktype: "采购种类",
    toselect: "请选择",
    addbut: "新增",
    delbut: "删除",
    expList: "导出EXCEL",
    indexMethod: "序号",
    chooseordertype: "请选择采购订单类型！",
    choosefundsource: "请选择采购需求来源！",
    purchasetype: "采购类型",
    fundsource: "需求来源",
    ordertype: "订单类型",
    billno: "单据编码",
    applydate: "发起日期",
    currstatus: "当前步骤",
    currusername: "当前办理人",
    contractname: "合同名称",
    contractcode: "合同编号",
    manuname: "供应商名称",
    manuno: "供应商编号",
    stockrecsum: "采购总金额",
    demandcode: "采购需求编码",
  },
  stocksmallorderlist: {
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    toybTab: "已办结采购结果列表",
    todoTab: "小额采购订单列表",
    toaddsmallorder: "触发小额采购订单",
  },
  stockorderquerylist: {
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    applydate: "申请日期",
    createtime: "创建日期",
    remark: "备注",
    rownotes: "行项备注",
    billno: "单据号",
    orderno_exact: "采购订单编号",
    ordertype: "订单类型",
    fundsource: "需求来源",
    showdetail: "明细信息",
    chcompany: "公司代码",
    chordertype: "订单类型",
    chfundsource: "需求来源",
    applydeptname: "创建部门",
    currstatus: "单据状态",
    currname: "当前办理人",
    applyusername: "申请人",
    remark2: "表头备注",
    materialcode: "物料编码",
    materialname: "物料名称",
    belongregion: "区域",
    speccode: "专业",
    contractcode: "合同编码",
    currency: "采购币种",
    stockcostsum: "采购币种总价款（不含税）",
    stockrecsum: "采购币种总金额（含税）"
  },
  PitoPurchaseOrder: {

  },
  stockorderbir: {
    manuno: "供应商编码",
    orderno: "订购单号码",
    contractcode: "合同编码",
    demandcode: "需求单编码",
    ebelp: "订单项编号",
    chordertype: "采购订单类型",
    purchgroup: "采购组",
    applydate: "采购订单创建日期",
    manuname: "供应商代码和名称",
    materialcode: "物料代码",
    materialname: "物料描述",
    materialgroup: "物料组",
    deletion: "指示是否删除采购申请的行项目",
    companycode: "公司代码",
    storeid_sap: "库存地点",
    stocknum: "数量",
    unitid: "计量单位",
    costprice: "净价",
    currency: "本位币",
    taxrate: "税务识别码",
    releaseindicator: "指示采购订单是否被批准",
    purchasecode: "参考购买请求单号",
    contractcode1: "合同编号",
    less_num: "订单项的采购订单中的剩余数量",
    less_sum: "订单项的采购订单剩余价值",
    less_arrive_num: "采购订单行项目的总数量减去发票数量",
    less_arrive_sum: "采购订单行项目的总值减去发票值",
  },
  contractpoquery: {
    contractcode: "合同编码",
    contractname: "合同名称",
    frameflag: "签约类型",
    contractuserid: "承办人",
    billno: "单据号",
    orderno: "采购订单编号",
    sendsapdate: "创建生效日期",
    stockrecsum: "含税金额",
  },
  stockorderload: {
    bigtitle: "采购订单信息表",
    cobigtitle: "订单合同采购订单信息表",
    sobigtitle: "小额订单信息表",
    pobigtitle: "采购订单信息表",
    baseinfo: "基本信息",
    otherinfo: "其他信息",
    stockfeerow: "费用清单",
    fee_chfeetype: "费用类型",
    fee_contractcode: "框架合同编码",
    fee_manuno: "供应商编码",
    fee_manuname: "供应商名称",
    fee_paytype: "付款方式",
    fee_relatetrade: "关联类型",
    fee_relatetradetype: "内部交易类型",
    fee_notaxsum: "价款总额",
    fee_taxsum: "税款总额",
    fee_totalsum: "价税合计总额",
    billid: "单据id",
    orderno: "采购订单编号",
    billno: "单据编码",
    ordername: "采购订单名称",
    resultno: "采购结果编码",
    resultname: "采购结果名称",
    companycode: "公司代码",
    contractid: "合同id",
    contractcode: "合同编码",
    contractname: "合同名称",
    newcontractcode: "新合同编码",
    newcontractname: "新合同名称",
    orderhtcode: "订单合同号",
    manuid: "供应商id",
    manuno: "供应商编码",
    manuname: "供应商名称",
    fundsource: "需求来源",
    stocktype: "采购种类",
    stocktaxsum: "订单税款总额",
    stockcostsum: "订单价款总额",
    stockrecsum: "订单价税合计总额",
    stocktaxsum_capital: "订单税款总额(可资本化)",
    stockcostsum_capital: "订单价款总额(可资本化)",
    stockrecsum_capital: "订单价税合计总额(可资本化)",
    currency: "交易币种",
    fxrate: "汇率",
    basecurrency: "本位币币种",
    sumcurrency: "本位币金额",
    frameid: "框架协议id",
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    frameuserid: "框架采购管理员",
    frametel: "框架采购管理员联系电话",
    frameareacode: "框架签约单位",
    frameclassifi: "框架份额分类",
    applyareacode: "订单创建单位",
    applyuserid: "订单创建人",
    applydeptid: "订单创建部门",
    applydept: "订单创建部门",
    applydate: "创建时间",
    applytel: "采购管理员联系电话",
    alluserid: "所有办理过的人员",
    status: "流程状态，默认1起草中",
    billstatus: "单据状态，默认0正常，1作废",
    zfflag: "是否直发现场",
    recareacode: "采购收货单位",
    recaddr: "送货地址",
    recuser: "接货人",
    rectel: "接货人联系电话",
    arrivedate: "约定到货日期",
    deliverynoteflag: "送货单状态",
    receipttel: "回单人联系电话",
    receiptdate: "回单日期",
    receiptuserid: "回单人",
    chgreason: "变更理由",
    voidflag: "是否作废",
    cancelreason: "作废理由",
    signdept: "会签部门",
    createtime: "创建日期",
    lastupdatetime: "最后更新时间",
    inputPlaceholder: "请输入内容",
    stockorderrow: "订单物资明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    costprice: "单价（不含增值税）",
    taxrate: "增值税率(%)",
    taxprice: "税款",
    price: "入库价",
    stocknum: "采购数量",
    prestocknum: "变更前采购数量",
    aftstocknum: "变更后采购数量",
    actarrivalnum: "实际到货数量",
    costsum: "价款小计",
    taxsum: "税额小计",
    recsum: "物资价税合计小计",
    servicerecsum: "服务费价税合计小计",
    thisarrivalnum: "本次到货数量",
    actarrivalsum: "实际到货设备款",
    returnbillflag: "是否回单",
    invoicamount: "开票金额",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    inventoryaddress: "库存地点",
    rowremark: "备注",
    loekzstate: "状态",
    demanduser: "需求编制人",
    demandusertel: "需求编制人电话",
    stockdemandno: "采购需求编码",
    materialdemandno: "物资需求编码",
    sysresource: "来源系统",
    selectservicebtn: "选择服务费用",
    urgentflag: "是否紧急",
    printflag: "是否打印",
    sendcontflag: "发送合同系统状态",
    senderpflag: "发送erp系统状态",
    celpayflag: "汇总及付款状态",
    saporderno: "sap订单号",
    shipdate: "发货日期",
    suppplandate: "供应商预计到货日期",
    archivedate: "归档日期",
    chgdate: "变更时间",
    gjflag: "数据割接状态",
    actpricesum: "实际价款合计",
    acttaxsum: "实际到货价税合计",
    budgetcheckflag: "是否进行过sap预算校验",
    projcode: "项目编码",
    projname: "项目名称",
    projmanager: "项目管理员",
    costcenter: "成本中心",
    glcode: "总账科目",
    applytype: "采购申请类型",
    assetcodeno: "资产卡片编号",
    assetclass: "资产分类",
    createassetbtn: "创建资产卡片",
    officeassetclass: "办公资产分类",
    officeassetcode: "办公资产编码",
    viewservicebtn: "查看服务费用",
    tipbeyondpricemsg: "综合办公单价超过设定单价!",
    beyondhtmainsummsg: "主供应商设备费用不能超过合同中主供应商分摊金额！",
    signmode: "签约模式",
    selstocktypemsg: "已选择物料信息，确定后将删除行项信息",
    ordertype: "采购订单类型",
    void: "作废",
    voidtitle: "作废信息",
    voidreason: "请填写作废理由",
    checkstocknummsg: "变更后的采购数量小于已完成收货数量！",
    checkstocknummsg1: "变更后的采购数量不能超过预制采购订单的采购数量！",
    ebelp: "行项目号",
    number: "序号",
    checkstocktypemsg: "请先选择采购种类！",
    checkapplytypemsg: "请先选择采购申请类型！",
    belongregion: "区域",
    speccode: "一级专业",
    subspeccode: "二级专业",
    checkselrowmsg: "请勾选需要复制的行！",
    checkinfocomplete: "请选择物料信息后保存行项再操作",
    errormsg1: "第{0}行修改后的税额小计超过设定的修改范围{1}-{2}！",
    errormsg2: "请上传资本支出批准申请表！",
    shareflag: "全区共用",
    demandcode: "采购需求编码",
    history: "历史调整记录",
    history_versions: "版本",
    history_chgdate: "发起日期",
    history_chguser: "变更发起人",
    history_chgreason: "变更理由",
    history_chgstatus: "变更状态",
    paymentterms : "付款条款",
    loekzstatetip : "STATUS状态说明：<br>"
        +"D Delete删除状态:不能收货，不能收发票。被标记的物资，不参与总价计算，该行项目的采购数量及金额保留，但仅做备查。<br>"
        +"B Blocking冻结状态:不能收货，不能收发票。被标记的物资，参与总价计算，该行项目的采购数量及金额保留。<br>"
        +"N 或空白，表示正常。<br>",
    loekzstate_delete: "删除",
    loekzstate_blocking: "冻结",
  },
  stockorderload_dito: {
    bigtitle: "采购订单信息表",
    cobigtitle: "订单合同采购订单信息表",
    sobigtitle: "小额订单信息表",
    pobigtitle: "采购订单信息表",
    baseinfo: "基本信息",
    otherinfo: "其他信息",
    stockfeerow: "费用清单",
    fee_chfeetype: "费用类型",
    fee_contractcode: "框架合同编码",
    fee_manuno: "供应商编码",
    fee_manuname: "供应商名称",
    fee_paytype: "付款方式",
    fee_relatetrade: "关联类型",
    fee_relatetradetype: "内部交易类型",
    fee_notaxsum: "价款总额",
    fee_taxsum: "税款总额",
    fee_totalsum: "价税合计总额",
    billid: "单据id",
    orderno: "采购订单编号",
    billno: "单据编码",
    ordername: "采购订单名称",
    resultno: "采购结果编码",
    resultname: "采购结果名称",
    companycode: "公司代码",
    contractid: "合同id",
    contractcode: "合同编码",
    contractname: "合同名称",
    newcontractcode: "新合同编码",
    newcontractname: "新合同名称",
    orderhtcode: "订单合同号",
    manuid: "供应商id",
    manuno: "供应商编码",
    manuname: "供应商名称",
    fundsource: "需求来源",
    stocktype: "采购种类",
    stocktaxsum: "订单税款总额",
    stockcostsum: "订单价款总额",
    stockrecsum: "订单价税合计总额",
    stocktaxsum_capital: "订单税款总额(可资本化)",
    stockcostsum_capital: "订单价款总额(可资本化)",
    stockrecsum_capital: "订单价税合计总额(可资本化)",
    currency: "交易币种",
    fxrate: "汇率",
    basecurrency: "本位币币种",
    sumcurrency: "本位币金额",
    frameid: "框架协议id",
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    frameuserid: "框架采购管理员",
    frametel: "框架采购管理员联系电话",
    frameareacode: "框架签约单位",
    frameclassifi: "框架份额分类",
    applyareacode: "订单创建单位",
    applyuserid: "订单创建人",
    applydeptid: "订单创建部门",
    applydept: "订单创建部门",
    applydate: "创建时间",
    applytel: "采购管理员联系电话",
    alluserid: "所有办理过的人员",
    status: "流程状态，默认1起草中",
    billstatus: "单据状态，默认0正常，1作废",
    zfflag: "是否直发现场",
    recareacode: "采购收货单位",
    recaddr: "送货地址",
    recuser: "接货人",
    rectel: "接货人联系电话",
    arrivedate: "约定到货日期",
    deliverynoteflag: "送货单状态",
    receipttel: "回单人联系电话",
    receiptdate: "回单日期",
    receiptuserid: "回单人",
    chgreason: "变更理由",
    voidflag: "是否作废",
    cancelreason: "作废理由",
    signdept: "会签部门",
    createtime: "创建日期",
    lastupdatetime: "最后更新时间",
    inputPlaceholder: "请输入内容",
    stockorderrow: "订单物资明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    costprice: "单价（不含增值税）",
    taxrate: "增值税率(%)",
    taxprice: "税款",
    price: "入库价",
    stocknum: "采购数量",
    prestocknum: "变更前采购数量",
    aftstocknum: "变更后采购数量",
    actarrivalnum: "实际到货数量",
    costsum: "价款小计",
    taxsum: "税额小计",
    recsum: "物资价税合计小计",
    servicerecsum: "服务费价税合计小计",
    thisarrivalnum: "本次到货数量",
    actarrivalsum: "实际到货设备款",
    returnbillflag: "是否回单",
    invoicamount: "开票金额",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    inventoryaddress: "库存地点",
    rowremark: "备注",
    loekzstate: "状态",
    demanduser: "需求编制人",
    demandusertel: "需求编制人电话",
    stockdemandno: "采购需求编码",
    materialdemandno: "物资需求编码",
    sysresource: "来源系统",
    selectservicebtn: "选择服务费用",
    urgentflag: "是否紧急",
    printflag: "是否打印",
    sendcontflag: "发送合同系统状态",
    senderpflag: "发送erp系统状态",
    celpayflag: "汇总及付款状态",
    saporderno: "sap订单号",
    shipdate: "发货日期",
    suppplandate: "供应商预计到货日期",
    archivedate: "归档日期",
    chgdate: "变更时间",
    gjflag: "数据割接状态",
    actpricesum: "实际价款合计",
    acttaxsum: "实际到货价税合计",
    budgetcheckflag: "是否进行过sap预算校验",
    projcode: "项目编码",
    projname: "项目名称",
    projmanager: "项目管理员",
    costcenter: "成本中心",
    glcode: "总账科目",
    applytype: "采购申请类型",
    assetcodeno: "资产卡片编号",
    assetclass: "资产分类",
    createassetbtn: "创建资产卡片",
    officeassetclass: "办公资产分类",
    officeassetcode: "办公资产编码",
    viewservicebtn: "查看服务费用",
    tipbeyondpricemsg: "综合办公单价超过设定单价!",
    beyondhtmainsummsg: "主供应商设备费用不能超过合同中主供应商分摊金额！",
    signmode: "签约模式",
    selstocktypemsg: "已选择物料信息，确定后将删除行项信息",
    ordertype: "采购订单类型",
    void: "作废",
    voidtitle: "作废信息",
    voidreason: "请填写作废理由",
    checkstocknummsg: "变更后的采购数量小于已完成收货数量！",
    checkstocknummsg1: "变更后的采购数量不能超过预制采购订单的采购数量！",
    ebelp: "行项目号",
    number: "序号",
    checkstocktypemsg: "请先选择采购种类！",
    checkapplytypemsg: "请先选择采购申请类型！",
    belongregion: "区域",
    speccode: "一级专业",
    subspeccode: "二级专业",
    checkselrowmsg: "请勾选需要复制的行！",
    checkinfocomplete: "请选择物料信息后保存行项再操作",
    errormsg1: "第{0}行修改后的税额小计超过设定的修改范围{1}-{2}！",
    errormsg2: "请上传资本支出批准申请表！",
    shareflag: "全区共用",
    demandcode: "采购需求编码",
    history: "历史调整记录",
    history_versions: "版本",
    history_chgdate: "发起日期",
    history_chguser: "变更发起人",
    history_chgreason: "变更理由",
    history_chgstatus: "变更状态",
    paymentterms : "付款条款",
    officeassetdetail: "办公资产信息",
    assetdetail_ebelp: "行项目号",
    assetdetail_demandcode: "办公资产编码",
    assetdetail_materialcode: "物料编码",
    assetdetail_materialname: "物料名称",
    assetdetail_assetclass: "资产分类",
    assetdetail_assetcodeno: "资产卡片编号",
    assetdetail_officeassetclass: "办公资产分类",
    assetdetail_officeassetcode: "办公资产编码",
    sendpo2bssbtn: "发送订单到BSS",
  },
  stockdemandlist: {
    billno: "单据编码",
    demandname: "需求名称",
    applyusername: "申请人",
    applydate: "申请日期",
    choosefundsource: "请选择需求来源",
    companycode: "公司代码",
    purchasetype: "采购类型",
    fundsource: "需求来源",
    fromdingtalk: "是否来自钉钉",
  },
  stockdemandload: {
    bigtitle: "采购需求单",
    baseinfo: "基本信息",
    rowbigtitle: "项目关联信息",
    billid: "单据id",
    billno: "单据编码",
    demandname: "需求名称",
    fundsource: "需求来源",
    companycode: "公司代码",
    ygsum: "预计采购金额合计(不含税)",
    budgetsum: "预计采购金额合计(含税)",
    currency: "本位币",
    arrivedate: "采购到货计划时间",
    sugpurmethod: "建议采购方式",
    sugpurmethodremark: "建议采购方式原因说明",
    sugmanuremark: "推荐供应商原因说明",
    remark: "需求说明",
    billstatus: "单据状态，默认0正常，1作废，2完成采购",
    sourcesys: "来源系统，默认1采购系统",
    applyareacode: "创建（申请）单位",
    applyusername: "采购需求人",
    applydeptid: "采购需求部门",
    applydept: "采购需求部门",
    applydate: "创建时间",
    applyuser_tel: "申请人联系电话",
    alluserid: "所有办理过的人员",
    status: "流程状态，默认1起草中",
    approvedate_begin: "审批开始时间",
    approvedate_end: "审批结束时间",
    number: "序号",
    itemcode: "项目编码",
    itemname: "项目名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    projsum: "预计采购金额",
    costcenter: "成本中心",
    projremark: "备注",
    stockuserid: "采购承办人",
    returnreason: "退回原因",
    returnuser: "退回人员",
    checkprojsum: "项目信息不为空时对应的预计采购金额必填！",
    useframestockflag: "是否采用框架采购",
    whetherbudgeted: "是否安排预算",
    applytype: "采购申请类型",
  },
  stockdemandgolist: {
    billno: "单据编码",
    demandname: "需求名称",
    applyusername: "申请人",
    applydate: "申请日期",
    choosedemandtype: "请选择物资服务类型",
  },
  stockdemandgowzload: {
    bigtitle: "综合采购物资需求单",
    baseinfo: "基本信息",
    rowbigtitle: "项目采购信息",
    billno: "需求编码",
    demandname: "需求名称",
    applydate: "单据日期",
    applydeptid: "采购需求部门",
    applydept: "采购需求部门",
    applyusername: "采购需求人",
    applyuser_tel: "采购需求人联系电话",
    fundsource: "需求来源",
    companycode: "公司代码",
    applytype: "采购申请类型",
    sugpurmethod: "采购方式",
    paytype: "付款方式",
    currency: "交易币种",
    demanddate: "需求日期",
    arrivedate: "采购到货计划时间",
    ygsum: "预计采购金额合计(不含税)",
    budgetsum: "预计采购金额合计(含税)",
    approvedflag: "是否核定",
    sugpurmethodremark: "建议采购方式原因说明",
    sugmanuremark: "推荐供应商原因说明",
    remark: "需求说明",
    number: "序号",
    materialcode: "物料编码",
    demanddesc: "需求描述",
    costcenter: "成本中心",
    costcentername: "成本中心名称",
    glcode: "总账科目",
    glcodename: "总账科目描述",
    num: "数量",
    unit: "计量单位",
    projsum: "预计采购金额(不含税)",
    projremark: "备注",
    whetherbudgeted: "是否安排预算",
    expensetype: "支出类型",
    budgetyear: "预算年度",
    budgetmonth: "预算月份",
    estpayduedate: "预计到期付款日期",
    saqrelated: "SAQ相关",
    dingtalkid: "对应的钉钉上的主单ID",
    budgetinstancecode: "预算指标编码",
    budgetinstancename: "预算指标名称",
    errormsg1: "预计采购金额合计(不含税) 不能超过 预计采购金额合计(含税)",
    errormsg2: "请选择采购申请类型",
    errormsg3: "请先保存单据",
    errormsg4: "请先选择支出类型",
    tiptitle1: "单一来源采购的采购方式下，项目采购信息中物料信息必填！",
    tiptitle2: "请通过物料基础资料选择物料，按物料编码侧边的图标。如果您要采购的物料不在基础资料中，可以通过基础资料功能将数据录入系统。此信息将自动带到采购订单中",
    checkidxmsg: "第{}行：",
    checknotnullmsg: "不能为空!",
    tiptitle3: "超出采购申请审批矩阵中定义的采购金额，需要MANCOM审批。",
    tiptitle4: "申请批准资本支出（AACE）是必需的，记得上传",
    costprice: "单价（不含税）",
    recsum: "总价（含税）",
    errormsg5: "第{0}行总价（含税）{1}不能少于预计采购金额(不含税){2}！",
  },
  stockddemandbudgetlist: {
    whetherbudgeted: "是否安排预算",
    applydate: "申请日期",
    applyusername: "申请人姓名",
    costcenter: "申请人所在成本中心代码",
    costcentername: "申请人所在成本中心名称",
    glcode: "GL 代码",
    glcodename: "GL 描述",
    demanddesc: "物料名称",
    currency: "币种",
    projsum: "金额"
  },
  selectbudgetinfo: {
    title: "选择预算指标",
    itemcode: "预算指标编码",
    itemname: "预算指标名称",
    itemfullpath: "父级指标编码",
    selectbudget: "请选择预算指标",
  },
  stockdemandquerylist: {
    billno: "采购需求编码",
    rowitemnum: "采购申请的行项目",
    applytype: "采购申请类型",
    deletion: "指示是否删除采购申请的行项目",
    releasestatus: "购买是否被批准",
    applydate: "采购申请的创建日期",
    applyuserid: "创建采购申请者的用户ID",
    lastupdatetime: "采购申请更改的最后日期",
    applyuserid2: "申购人",
    remark: "要求的项目或服务的描述",
    materialcode: "物料编号",
    companycode: "公司代码",
    chcompanycode: "公司代码名称",
    purchgroup: "采购组",
    storeid_sap: "仓库",
    materialgroup: "物料组",
    num: "需求数量",
    unit: "计量单位",
    arrivedate: "预计交付日期",
    releasedate: "购买请求的批准日期",
    valuationprice: "总价（价格单位乘以数量）",
    priceunit: "单位价格",
    closed: "状态",
    purchaseorder: "针对采购申请行项目创建的采购订单",
    currency: "币种",
  },
  prsendmailcfgload: {
    serviceTitle: "采购需求发送邮件配置信息",
    code: "角色",
    userid: "人员",
    mail: "邮箱",
    deptid: "部门",
  },
  stockplanlist: {
    billno: "单据编码",
    planname: "需求名称",
    applyusername: "申请人",
    applydate: "申请日期"
  },
  stockplanload: {
    bigtitle: "采购方案",
    baseinfo: "基本信息",
    rowbigtitle: "意向供应商",
    thirdbigtitle: "关联信息",
    billno: "采购方案编码",
    companycode: "公司代码",
    applyareaname: "申请单位",
    applydept: "申请部门",
    applyuserid: "采购管理员",
    planname: "采购方案名称",
    fundsource: "需求来源",
    stockmethod: "采购方式",
    stockcostsum: "预计采购金额合计",
    stockrecsum: "采购估算总额（含增值税）",
    stockcostsumcapital: "预计采购金额合计(大写)",
    stockrecsumcapital: "采购估算总额含增值税(大写)",
    prequalification: "资格预审",
    ifwtzb: "是否委托投标",
    manuno: "投标代理机构",
    purchpurposes: "采购用途",
    servicetype: "服务类别",
    stockdesc: "采购实施方案阐述",
    applyareacode: "创建（申请）单位",
    applyuser_tel: "申请人联系电话",
    applyuseremial: "采购管理员邮箱",
    manurow_manuno: "供应商编码",
    manurow_manuname: "意向供应商名称",
    manurow_manuremark: "推荐理由",
    manurow_sugpurmethod: "推荐采购方式",
    projrow_itemcode: "项目编码",
    projrow_itemname: "项目名称",
    projrow_projcode: "子项目编码",
    projrow_projname: "子项目名称",
    projrow_projsum: "预计采购金额",
    number: "序号",
    costcenter: "成本中心",
    operate: "操作",
    demandcode: "选择采购需求",
    selfundsourcetip: "提示",
    selfundsourcemsg: "已选择采购需求信息，确定后将删除行项信息",
    currency: "交易币种",
    fxrate: "汇率",
    basecurrency: "本位币币种",
    origcurrency: "原币种",
    origprojsum: "原预计采购金额",
    projremark: "备注",
    inputPlaceholder: "请输入内容",
    signuser: "会签人员",
    applytype: "采购申请类型",
    errormsg1: "预计采购金额合计 不能超过 采购估算总额（含增值税）",
  },
  stockresultlist: {
    billno: "采购结果编码",
    resultname: "采购结果名称",
    applyusername: "申请人",
    applydate: "申请日期",
    authorizeusername: "合同承办授权人",
    chgauthormsg: "确定修改合同承办授权人吗？",
  },
  stockresultload: {
    void: "作废",
    bigtitle: "采购结果",
    baseinfo: "基本信息",
    rowbigtitle: "中标供应商",
    thirdbigtitle: "关联信息",
    inputPlaceholder: "请输入内容",
    billid: "单据id",
    billno: "采购结果编码",
    resultname: "采购结果名称",
    companycode: "公司代码",
    planid: "采购方案ID",
    planno: "采购方案编码",
    planname: "采购方案名称",
    stockmethod: "采购方式",
    fundsource: "需求来源",
    currency: "交易币种",
    fxrate: "汇率",
    basecurrency: "本位币币种",
    stocktaxsum: "税额合计",
    resultcostsum: "采购金额合计（不含增值税）",
    resultrecsum: "采购金额合计（含增值税）",
    contractuserid: "合同拟稿人",
    validmanuflag: "流标-无有效供应商",
    resultdesc: "提请决策内容说明",
    itemdesc: "采购项目简介",
    billstatus: "单据状态",
    sourcesys: "来源系统",
    applyareacode: "申请单位",
    applyuserid: "采购管理员",
    applydeptid: "申请部门",
    applydept: "申请部门",
    applydate: "创建时间",
    applytel: "采购管理员联系电话",
    applyemail: "采购管理员邮箱",
    alluserid: "所有办理过的人员",
    status: "流程状态，默认1起草中",
    manurowid: "供应商行项ID",
    manuid: "供应商ID",
    manuno: "供应商编码",
    manuname: "供应商名称",
    manurecsum: "采购含增值税金额（元）",
    sugpurmethod: "推荐采购方式",
    itemcode: "项目编码",
    itemname: "项目名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    projsum: "采购金额（含增值税）",
    number: "序号",
    costcenter: "成本中心",
    demandcode: "采购需求编码",
    smallpurch: "触发小额采购订单",
    crtcontract: "触发生成合同",
    voidtitle: "作废信息",
    voidreason: "请填写作废理由",
    resultrecsum_bw: "本位币金额",
    resultrecsumcapital: "采购金额合计含增值税(大写)",
    origcurrency: "原币种",
    origprojsum: "原预计金额",
    remark: "备注",
    stockamount_nottax: "采购金额（不含增值税）",
    taxrate: "增值税率",
    tax: "税额",
    projsumtip: "可按照价款税款预估,小数点2位",
    noticename: "相关采购文件",
    zbnoticename: "投标公告标题",
    xjnoticename: "报价公告标题",
    dxnoticename: "竞争性谈判标题",
    itemsum: "采购金额（含增值税）",
    signmode: "签约模式",
    signuser: "会签人员",
    applytype: "采购申请类型",
    authorizeuser: "合同承办授权人",
    ifcontract: "是否需要正式合同",
    materialcode: "物料编码",
    materialname: "物料名称",
    stocknum: "数量",
  },
  stocktenderinvitelist: {
    billno: "招标委托编码",
    billname: "采招标委托名称",
    applyusername: "申请人",
    applydate: "申请日期"
  },
  stocktenderinviteload: {
    inputPlaceholder: "请输入内容",
    bigtitle: "采购招标委托",
    baseinfo: "基本信息",
    billid: "单据id",
    billno: "招标委托编码",
    billname: "招标委托名称",
    planid: "采购方案id",
    planno: "采购方案编码",
    planname: "采购方案名称",
    projcode: "采购项目编码",
    projname: "采购项目名称",
    invitemanuno: "招标代理编码",
    invitemanuname: "招标代理名称",
    inviteuserid: "招标代理联系人",
    inviteusertel: "联系电话",
    invitedate: "委托日期",
    publishflag: "是否发布",
    remark: "委托内容",
    applyareacode: "创建（申请）单位",
    applyuserid: "创建（申请）人",
    applydeptid: "创建（申请）部门",
    applydept: "创建（申请）部门",
    applydate: "创建时间",
    applytel: "申请人联系电话",
    applyemail: "采购管理员邮箱",
    alluserid: "所有办理过的人员",
    status: "流程状态，默认1起草中",
    approvedate_begin: "审批开始时间",
    approvedate_end: "审批结束时间",
    createtime: "创建时间",
    lastupdatetime: "上次更新时间",
  },
  stocknoticelist: {
    billno: "单据编码",
    billname: "单据名称",
    applyusername: "申请人",
    applydate: "申请日期",
    notselbilltype: "请选择公告类型",
    chbilltype: "公告类型",
  },
  stockinquiryload: {
    inputPlaceholder: "请输入内容",
    bigtitle: "询价文件",
    baseinfo: "基本信息",
    billno: "询价文件编码",
    billname: "询价文件标题",
    planid: "采购方案id",
    planno: "采购方案编码",
    planname: "采购方案名称",
    projcode: "采购项目编码",
    projname: "采购项目名称",
    noticetitle: "原公告标题",
    inquirytype: "询价方式",
    qualificattype: "资格审核方式",
    drafttime: "拟稿时间",
    publicitytime: "采购公示时间",
    to1: "至",
    inquirytransferendtime: "询价文件递交截止时间",
    authorscope: "授权范围",
    authorizedmanuno: "被授权方编码",
    authorizedmanuname: "被授权方名称",
    inquiryuserid: "询价人",
    construction: "建设单位",
    rfqtext: "询价公告正文",
  },
  stockprequalificatload: {
    inputPlaceholder: "请输入内容",
    bigtitle: "资格预审",
    baseinfo: "基本信息",
    billno: "文件编码",
    billname: "资格预审文件标题",
    projname: "采购项目名称",
    noticetitle: "原公告标题",
    stockmethod: "采购方式",
    agencyflag: "是否委托代理机构",
    agencyname: "代理机构",
    undertagsum: "标的金额(元)",
    moneysource: "资金来源",
    drafttime: "拟稿时间",
    publicitytime: "资格预审文件发售时间",
    to1: "至",
    inquirytransferendtime: "资格预审文件递交截止时间",
    authorscope: "授权范围",
    authorizedmanuno: "被授权方编码",
    authorizedmanuname: "被授权方",
    stockmanager: "采购管理员",
    stockmanagertel: "移动电话",
    stockmanagermail: "邮箱",
    remark: "资格预审文件内容说明",
    rfqtext: "资格预审公告正文",
  },
  stocksinglesourceload: {
    inputPlaceholder: "请输入内容",
    bigtitle: "单一来源文件",
    baseinfo: "基本信息",
    billno: "采购文件编码",
    billname: "采购文件标题",
    planno: "采购方案编码",
    planname: "采购方案名称",
    projcode: "采购项目编码",
    projname: "采购项目名称",
    invitemanuno: "子项目编码",
    invitemanuname: "子项目名称",
    remark: "备注",
    drafttime: "拟稿时间",
    publicitytime: "采购公示时间",
    to1: "至",
    authorscope: "授权范围",
    authorizedmanuno: "被授权方编码",
    authorizedmanuname: "被授权方名称",
    rfqtext: "单一来源采购公示正文",
    stockmethod: "采购方式",
    agencyflag: "是否委托代理机构",
    agencyname: "招标代理机构",
    undertagsum: "标的金额/控制价(元)",
    moneysource: "资金来源",
    stockmanager: "采购管理员",
    stockmanagertel: "移动电话",
    stockdeptid: "采购处室",
    stockmanagermail: "邮箱",
  },
  stockselectionload: {
    inputPlaceholder: "请输入内容",
    bigtitle: "比选",
    baseinfo: "基本信息",
    billno: "比选文件编码",
    billname: "比选文件标题",
    noticetitle: "原公告标题",
    stockmethod: "比选方式",
    qualificattype: "资格审核方式",
    planno: "采购方案编码",
    planname: "采购方案名称",
    projcode: "采购项目编码",
    projname: "采购项目名称",
    invitemanuno: "子项目编码",
    invitemanuname: "子项目名称",
    remark: "备注",
    drafttime: "拟稿时间",
    publicitytime: "比选文件发售时间",
    to1: "至",
    inquirytransferendtime: "比选文件递交截止时间",
    authorscope: "授权范围",
    authorizedmanuno: "被授权方编码",
    authorizedmanuname: "被授权方名称",
    selecttype: "比选方式",
    agencyflag: "是否委托代理机构",
    agencyname: "招标代理机构",
    undertagsum: "标的金额/控制价(元)",
    moneysource: "资金来源",
    stockmanager: "采购管理员",
    stockmanagertel: "移动电话",
    stockdeptid: "采购处室",
    stockmanagermail: "邮箱",
    pastperioddiff: "与往期项目的差异和变化",
    specificatdiff: "与规范文本的差异和变化",
    number: "序号",
    packagerow: "标包信息",
    packagename: "标包名称",
    manuname: "供应商",
    rowfile: "操作"
  },
  stockcompetenegotiatload: {
    inputPlaceholder: "请输入内容",
    bigtitle: "竞争性谈判",
    baseinfo: "基本信息",
    billno: "谈判文件编码",
    billname: "竞争性谈判文件标题",
    noticetitle: "原公告标题",
    negotiating: "谈判方式",
    qualificattype: "资格审核方式",
    planno: "采购方案编码",
    planname: "采购方案名称",
    projcode: "采购项目编码",
    projname: "采购项目名称",
    invitemanuno: "子项目编码",
    invitemanuname: "子项目名称",
    undertagsum: "标的金额/控制价(元)",
    moneysource: "资金来源",
    drafttime: "拟稿时间",
    agencyflag: "是否委托代理机构",
    agencyname: "招标代理机构",
    publicitytime: "竞争性谈判文件发售时间",
    to1: "至",
    inquirytransferendtime: "竞争性谈判文件递交截止时间",
    authorscope: "授权范围",
    authorizedmanuname: "被授权方名称",
    stockmanager: "采购管理员",
    stockmanagertel: "移动电话",
    stockdeptid: "采购处室",
    remark: "备注",
    pastperioddiff: "与往期项目的差异和变化",
    specificatdiff: "与规范文本的差异和变化",
    number: "序号",
    packagerow: "标包信息",
    packagename: "标包名称",
    manuname: "供应商",
    rowfile: "操作"
  },
  stockpoollist: {
    applyareacode: "采购需求单位",
    applydeptid: "采购需求部门",
    applyuserid: "采购需求人",
    docreatestockplan: "生成采购方案",
    docreatestockresult: "生成采购结果",
    docreatestockorder: "采购订单合同",
    billno: "单据编码",
    demandname: "需求名称",
    rownum: "行号",
    fundsource: "需求来源",
    currency: "交易币种",
    stockuserid: "采购承办人",
    applydept: "需求部门",
    applyuser: "需求人",
    confirm: "确认",
    cancel: "取消",
    selstockusermsg: "确认修改当前采购承办人？",
    selstockusertip: "提醒",
    seldiffsource: "选择的行项与已选择行项的公司代码 或 采购申请类型 或 需求来源不一致，不能同时开单，请重新选择！",
    selalldiffsource: "公司代码 或 采购申请类型 或 需求来源不一致，不能同时开单，请重新选择！",
    seldemandinfo: "请选择一行数据",
    operate: "操作",
    backtostockuserid: "退回",
    backtostocksuccessmsg: "退回成功",
    backtostockfailmsg: "退回失败",
    reqtype: "采购需求类型",
    reqtypemsg: "提示：你同时有采购需求和备库需求来源的待办需要处理！可选择采购需求类型分别进行处理。",
    dohunt: "寻源",
    selkjhuntmsg: "框架协议不能做寻源",
    returntiptitle: "退回需求发起人",
    returnmsg: "退回原因",
    seldemandusermsg: "请先选择需求承办人",
    inputreturnreasonmsg: "请输入退回原因后再做此操作",
    doassigned: "批量指派",
    assigntiptitle: "指派需求承办人",
    seldemanduser: "请选择被指派的人员",
    companycode: "公司代码",
    itemcode: "项目编码",
    itemname: "项目名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    costcenter: "成本中心",
    projremark: "备注",
    projsum: "预计金额",
    checkboxT: "选择",
    applytype: "采购申请类型",
    dosimplepo: "发起小额采购订单",
    oversmallstocksum: "超过小额采购订单设置阈值",
  },
  stockfundload: {
    bigtitle: "需求物料信息",
    demandrowinfo: "需求行项信息",
    listnum: "行号",
    billno: "需求编码",
    listinfo: "本次关联清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "计量单位",
    itemcode: "项目编码",
    itemname: "项目名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    costcenter: "成本中心",
    applynum: "数量",
    framecode: "框架协议报价单编码",
    framecontractcode: "框架合同编码",
    framename: "框架协议报价单名称",
    chmaterialtype: "采购种类",
    tipmsg1: "没有关联的信息",
    tipmsg2: "只允许选择同一个框架报价协议单",
    demanddesc: "需求描述",
    num: "数量",
    unit: "计量单位",
    projsum: "预计采购金额",
    projremark: "备注",
    tipmsg3: "只允许相同物料编码的采购需求行项",
  },
  BatchMatchDemandInfo: {
    title: "选择框架物料信息",
    noseldemandmsg: "请先选择左侧的需求信息",
    confirm: "确定",
    cancel: "取消",
    clear: "清空",
    operaterow: "操作",
    checkboxT: "选择",
    rownum: "行号",
    billno: "需求编码",
    itemcode: "项目编码",
    itemname: "项目名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    costcenter: "成本中心",
    framecode: "框架协议报价单编码",
    framecontractcode: "框架合同编码",
    framename: "框架协议报价单名称",
    materialname: "物料名称",
    materialcode: "物料编码",
    manuno: "供应商",
    sobkz: "库存类型",
    applynum: "数量",
    spec: "规格型号",
    chunit: "单位",
    origmanuname: "原厂商",
    origmanuprod: "原厂商产品规格型号",
    origmanudesc: "原厂商产品描述",
    origmanumaterial: "原厂商产品名称",
    status: "状态",
    placeholder: "输入关键字搜索",
    nomsg: "暂无数据",
    manuname: "供应商",
    price: "单价",
    batchmatchbtore: "匹配框架物料",
    choosestore: "请选择需求",
    choosebilldemandList: "请选择需要匹配物料的需求清单",
    chooseselectmaterialrow: "请选择需求信息",
    selectbstore: "请选择库存信息",
    chmaterialtype: "采购种类",
    inputapplynummsg: "请输入数量信息",
  },
  stockresultchainlist: {
    manuname: "供应商名称",
    manuno: "供应商编码",
    billno: "采购结果编码",
    resultname: "采购结果名称",
    itemcode: "项目编码",
    itemname: "项目名称",
    costcenter: "成本中心",
    projsum: "项目分摊金额",
    sumbit: "合同拟稿",
    diffmanumsg: "只能对同一个供应商进行发起合同！",
    choosestockresult: "请选择采购结果行项信息",
    chfundsource: "需求来源",
    seldiffsource: "框架协议的来源不能跟其他来源一起触发合同！",
    seldiffsignmode: "不同签约模式不能一起触发合同！",
    queryTips: "点击下面行查询",
    signmode: "签约模式",
    companycode: "公司代码",
    fundsource: "需求来源",
  },
  expertspeclist: {
    speccode: "专业编码",
    chspec: "专业名称",
    speccode2: "二级专业编码",
    chspec2: "二级专业名称",
    upspeccode: "一级专业编码",
    upchspec: "一级专业名称",
    status: "是否启用",
    operate: "操作",
    addbut: "新增一级专业",
    edit: "编辑",
    addnext: "新建下级专业",
    yes: "是",
    no: "否",
  },
  expertspecload: {
    bigtitle: "专业分类",
    baseinfo: "基本信息",
    speccode: "专业编码",
    chspec: "专业名称",
    upspeccode: "上级专业编码",
    upchspec: "上级专业名称",
    status: "是否启用",
    remark: "备注"
  },
  expertapplylist: {
    billno: "单据编码",
    username: "专家姓名",
    unit: "工作单位",
    enspec: "申报专业分类",
    sourceflag: "专家来源",
    expertname: "专家姓名",
    applyusername: "申请人",
    applydate: "申请日期",
    approvedate: "审批日期",
    status: "流程状态"
  },
  expertapplyload: {
    bigtitle: "专家入库审批表",
    baseinfo: "基本信息",
    billno: "单据号",
    applyusername: "申请人",
    applydate: "申请日期",
    applydept: "申请部门",
    approveusername: "审批人",
    approvedate: "审批日期",
    sourceflag: "专家来源",
    expertname: "专家姓名",
    sex: "性别",
    idcard: "身份证号",
    birthday: "出生日期",
    health: "身体状况",
    learning: "学历",
    school: "毕业院校",
    specialty: "在校专业",
    unit: "工作单位",
    address: "工作地址",
    joinworkdate: "参加工作日期",
    technicalpost: "职称",
    incumbent: "现任职务",
    phone2: "移动电话",
    phone1: "固定电话",
    fax: "传真",
    email: "电子邮箱",
    enspec: "申报专业",
    specialtyyear: "相关专业从事年限",
    achievement: "相关专业工作业绩",
    fileup: "附件"
  },
  framelist: {
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    applyusername: "申请人",
    applydate: "申请日期",
    attachframe: "是否附属框架协议",
    authorizeusername: "授权人",
    assignauthorperson: "指派授权人",
    chgauthormsg: "确定修改授权人吗？",
    framecontractcode: "框架合同编码",
    framecontractname: "框架合同名称",
    contractdate: "合同日期（起止）",
  },
  framequerylist: {
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    applydate: "申请日期",
    chattachframe: "是否附属框架协议",
    createtime: "创建日期",
    remark: "备注",
    rownotes: "行项备注",
    framecontractcode: "框架合同编码",
    billno_exact: "单据号",
    showdetail: "明细信息",
    chcompany: "公司代码",
    applydeptname: "创建部门",
    currstatus: "单据状态",
    currname: "当前办理人",
    applyusername: "申请人",
    remark2: "表头备注",
    materialcode: "物料编码",
    materialname: "物料名称",
    costprice: "价款",
  },
  framechglist: {
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    applyusername: "申请人",
    applydate: "申请日期",
    attachframe: "是否附属框架协议",
    tochg: "变更",
    tofrozen: "冻结",
    tovoid: "作废",
    tothaw: "解冻",
    tochgtab: "待变更列表",
    tothawtab: "待解冻列表",
    todotab: "变更列表",
    chgtype: "变更种类",
    currstatus: "流程状态",
  },
  framemainload: {
    bigtitle: "框架协议报价单",
    baseinfo: "基本信息",
    rowbigtitle: "物资明细",
    manubigtitle: "主供应商服务明细",
    agreebigtitle: "服务及运保费报价清单",
    number: "行号",
    frametype: "框架类型",
    attachframe: "是否附属框架协议",
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    framecategory: "框架份额分类",
    companycode: "签署单位",
    framecontractcode: "框架合同编码",
    framecontractname: "框架合同名称",
    manuno: "供应商",
    manuname: "供应商名称",
    sourcegoods: "供货渠道",
    currency: "交易币种",
    origmanu: "原厂商",
    extendedtype: "协议履约期限",
    signenddate: "报价单签订日期",
    signdate: "报价单生效日期",
    enddate: "报价单终止日期",
    framescope: "签约主体适用范围",
    payratio: "付款比例",
    stockmanager: "采购管理员",
    basisbackground: "签约依据及背景",
    contoverview: "合同概况",
    remark: "备注",
    agreestate: "报价单状态",
    approvedate_begin: "审批开始时间",
    approvedate_end: "审批结束时间",
    belongregion: "区域",
    visiblescope: "可见范围",
    visiblekey: "可见方",
    row_copy: "复制",
    row_materialcode: "物资编码",
    row_materialname: "物资名称",
    row_spec: "物料规格",
    row_unitid: "计量单位",
    row_framecategory: "框架份额分类",
    row_materialtype: "采购种类",
    row_origmanuname: "原厂商",
    row_origmanuprod: "原厂商产品规格型号",
    row_origmanudesc: "原厂商产品描述",
    row_origmanumaterial: "原厂商产品名称",
    row_weightuint: "单位重量（千克/米或千克/个）",
    row_weightcopper: "铜重系数（千克/米）",
    row_costprice: "价款",
    row_taxrate: "增值税率%",
    row_taxprice: "税款",
    row_price: "价税合计",
    row_sharecontrol: "是否份额控制（是/否）",
    row_currency: "交易币种",
    row_state: "状态",
    row_rowremark: "行项备注",
    manu_demandunit: "需求单位",
    manu_costname: "费用名称",
    manu_frameshare: "框架份额分类",
    manu_manuname: "供应商",
    manu_feetype: "费用类型",
    manu_pricetype: "计价方式",
    manu_rate: "费率%",
    manu_unit: "计量单位",
    manu_price: "价款",
    manu_taxrate: "增值税率",
    agree_demandunit: "需求单位",
    agree_costname: "费用名称",
    agree_feetype: "费用类型",
    agree_frameshare: "框架份额分类",
    agree_manuname: "供应商",
    agree_pricetype: "计价方式",
    agree_rate: "费率%",
    agree_unit: "计量单位",
    agree_price: "价款",
    agree_disrate: "折扣率（%）",
    agree_taxrate: "增值税率（%）",
    agree_taxcharge: "税款",
    agree_totalprice: "价税合计",
    agree_enableflag: "启用/禁用",
    agree_optionflag: "可选/必选",
    agree_remark: "备注",
    selectsubframe: "选择附属协议",
    extendedterms: "是否有顺延条款",
    postponeddate: "顺延日期",
    agree_catalogprice: "目录价款",
    tipoptionflagmsg: "相同费用类型如果存在必选了，其他可以不用！",
    tipoptionflagmsg1: "相同费用类型、相同计价方式，启用禁用只能存在一条！",
    tipoptionflagmsg2: "相同所属区域只能存在一条！",
    tipoptionflagmsg3: "请先选择区域信息！",
    checkselrowmsg: "请勾选需要复制的行！",
    chgreason: "变更理由",
    historydetail: "历史调整记录",
    showqueryrow: "显示查询框",
    hidequeryrow: "隐藏查询框",
  },
  framesubload: {
    bigtitle: "框架协议报价单",
    baseinfo: "基本信息",
    rowbigtitle: "物资明细",
    manubigtitle: "主供应商服务明细",
    agreebigtitle: "服务及运保费报价清单",
    number: "行号",
    frametype: "框架类型",
    attachframe: "是否附属框架协议",
    framecode: "框架协议报价单编码",
    framename: "框架协议报价单名称",
    framecategory: "框架份额分类",
    companycode: "签署单位",
    framecontractcode: "框架合同编码",
    framecontractname: "框架合同名称",
    manuno: "供应商",
    manuname: "供应商名称",
    sourcegoods: "供货渠道",
    currency: "交易币种",
    origmanu: "原厂商",
    compledeadline: "协议履约期限",
    signdate: "协议签订日期",
    effectdate: "协议生效日期",
    terminatdate: "协议终止日期",
    framescope: "签约主体适用范围",
    payratio: "付款比例",
    stockmanager: "采购管理员",
    basisbackground: "签约依据及背景",
    contoverview: "合同概况",
    remark: "备注",
    agreestate: "报价单状态",
    approvedate_begin: "审批开始时间",
    approvedate_end: "审批结束时间",
    row_materialcode: "物资编码",
    row_materialname: "物资名称",
    row_spec: "物料规格",
    row_unitid: "计量单位",
    row_framecategory: "框架份额分类",
    row_materialtype: "采购种类",
    row_origmanuname: "原厂商",
    row_origmanuprod: "原厂商产品规格型号",
    row_origmanudesc: "原厂商产品描述",
    row_origmanumaterial: "原厂商产品名称",
    row_weightuint: "单位重量（千克/米或千克/个）",
    row_weightcopper: "铜重系数（千克/米）",
    row_costprice: "价款",
    row_taxrate: "增值税率%",
    row_taxprice: "税款",
    row_price: "价税合计",
    row_sharecontrol: "是否份额控制（是/否）",
    row_currency: "交易币种",
    row_state: "状态(1启用/0禁用)",
    row_rowremark: "行项备注",
    manu_demandunit: "需求单位",
    manu_costname: "费用名称",
    manu_frameshare: "框架份额分类",
    manu_manuname: "供应商",
    manu_feetype: "费用类型",
    manu_pricetype: "计价方式",
    manu_rate: "费率%",
    manu_unit: "计量单位",
    manu_price: "价款",
    agree_demandunit: "需求单位",
    agree_costname: "费用名称",
    agree_feetype: "费用类型",
    agree_frameshare: "框架份额分类",
    agree_manuname: "供应商",
    agree_pricetype: "计价方式",
    agree_rate: "费率%",
    agree_unit: "计量单位",
    agree_price: "价款",
    agree_disrate: "折扣率",
    agree_taxrate: "增值税率（%）",
    agree_taxcharge: "税款",
    agree_totalprice: "价税合计",
    agree_enableflag: "启用/禁用",
    agree_optionflag: "可选/必选",
    agree_remark: "备注",
    agree_catalogprice: "目录价款",
    tipdisratemsg: "折扣率请填写0-1之间的数",
    chgreason: "变更理由",
    historydetail: "历史调整记录",
  },
  framehistorydetail: {
    framecode: "变更单据号",
    chguser: "调整人",
    chgdate: "调整日期",
    chgreason: "变更理由",
  },
  framecontractlist: {
    contractcode: "框架协议编码",
    contractname: "框架协议名称",
    signdate: "履约开始日期",
    enddate: "履约结束日期",
    manuname: "供应商名称",
    applyusername: "框架协议发起人",
    authorizeusername: "授权人",
    assignauthorperson: "指派授权人",
    chgauthormsg: "确定修改授权人吗？",
  },
  stockprecastlist: {
    billno: "预制订单编码",
    billname: "预制订单名称",
    applyusername: "创建人",
    applydate: "创建时间",
    contractcode: "合同编码",
  },
  stockprecastload: {
    baseinfo: "基本信息",
    otherinfo: "框架关联合同",
    framecontractcode: "框架合同编码",
    framecontractname: "框架合同名称",
    manuno: "供应商编码",
    manuname: "供应商名称",
    signcode: "合同发起号",
    toorderht: "触发订单合同",
    bigtitle: "预制采购申请单",
    rowbigtitle: "到货时间管理",
    thirdbigtitle: "物资明细",
    number: "行号",
    inputPlaceholder: "请输入内容",
    billno: "预制订单编码",
    billname: "预制订单名称",
    companycode: "公司代码",
    fundsource: "需求来源",
    applytype: "采购申请类型",
    stocktaxsum: "订单税款总额",
    stockcostsum: "采购价款总额(未含增值税",
    stockrecsum: "订单总额（含增值税）",
    currency: "交易币种",
    fxrate: "汇率",
    basecurrency: "本位币币种",
    standard_stocktaxsum: "本位币订单税款总额",
    standard_stockcostsum: "本位币采购价款总额(未含增值税",
    standard_stockrecsum: "本位币订单总额（含增值税）",
    applyarea: "我方名称",
    applyareaname: "采购申请单位",
    applyprovincecode: "创建省份",
    applyuserid: "创建人",
    applydeptid: "创建部门",
    applydept: "创建部门",
    applydate: "创建时间",
    applytel: "经办人电话",
    alluserid: "所有办理过的人员",
    status: "流程状态",
    billstatus: "单据状态",
    genorderstatus: "生成订单状态",
    applystatus: "采购申请状态",
    remark: "备注",
    arrival_frameno: "框架协议报价单编码",
    arrival_framename: "框架协议报价单名称",
    arrival_framecontractcode: "框架合同编码",
    arrival_framecontractname: "框架合同名称",
    arrival_arrivalremark: "交货承诺",
    arrival_arrivaldate: "约定到货日期",
    row_materialcode: "物资编码",
    row_materialname: "物资名称",
    row_frameno: "框架协议报价单编码",
    row_framecontractcode: "框架合同编码",
    row_framename: "框架协议报价单名称",
    row_materialtype: "采购种类",
    row_spec: "物料规格",
    row_unitid: "计量单位",
    row_currency: "交易币种",
    row_fxrate: "汇率",
    row_costprice: "设备单价（不含增值税）",
    row_price: "设备及服务费单价（不含增值税）",
    row_taxrate: "增值税率%",
    row_stocknum: "采购数量",
    row_costsum: "物资价款小计",
    row_taxsum: "物资税款小计",
    row_recsum: "物资价税合计小计",
    row_demandid: "采购需求id",
    row_demandrowid: "采购需求行项id",
    row_demandcode: "采购需求编码",
    row_demandname: "采购需求名称",
    row_demanduser: "需求编制人",
    row_manuid: "供应商ID",
    row_manuno: "供应商编码",
    row_manuname: "供应商名称",
    row_orimanuname: "原厂商",
    row_orimanuprodname: "原厂商产品名称",
    row_orimanuspec: "原厂商规格型号",
    row_orimanudrip: "原厂商产品描述",
    row_recareacode: "送货地区",
    row_recaddr: "送货地址",
    row_recuser: "接货人",
    row_rectel: "接货人联系电话",
    row_type: "项目工程类型",
    row_itemcode: "项目编码",
    row_itemname: "项目名称",
    row_projcode: "子项目编码",
    row_projname: "子项目名称",
    row_projsum: "预计金额",
    row_costcenter: "成本中心",
    row_projmanager: "子项目经理",
    row_inventoryaddress: "库存地点",
    row_orderstatus: "处理状态",
    row_orderuserid: "处理人",
    row_feerate_1: "关税费率",
    row_feerate_2: "代理费率",
    row_feerate_3: "物流费率",
    row_feerate_4: "检测费率",
    row_feerate_5: "系统集成费率",
    row_feerate_6: "安装督导费率",
    row_feerate_7: "仓储费率",
    row_feerate_8: "末端配送费率",
    row_feerate_9: "货运/报关代理费率",
    row_feerate_10: "服务费率",
    row_feerate_11: "其他费用率",
    row_feerate_12: "清关杂费率",
    row_price_1: "关税价款",
    row_price_2: "代理价款",
    row_price_3: "物流价款",
    row_price_4: "检测价款",
    row_price_5: "系统集成价款",
    row_price_6: "安装督导价款",
    row_price_7: "仓储价款",
    row_price_8: "末端配送价款",
    row_price_9: "货运/报关代理价款",
    row_price_10: "服务价款",
    row_price_11: "其他费用价款",
    row_price_12: "清关杂价款",
    row_manuno_1: "关税商",
    row_manuno_2: "代理商",
    row_manuno_3: "物流商",
    row_manuno_4: "检测商",
    row_manuno_5: "系统集成商",
    row_manuno_6: "安装督导商",
    row_manuno_7: "仓储商",
    row_manuno_8: "末端配送商",
    row_manuno_9: "货运/报关代理商",
    row_manuno_10: "服务商",
    row_manuno_11: "其他费用商",
    row_manuno_12: "清关杂商",
    row_taxrate_1: "关税增值税率",
    row_taxrate_2: "代理增值税率",
    row_taxrate_3: "物流增值税率",
    row_taxrate_4: "检测增值税率",
    row_taxrate_5: "系统集成增值税率",
    row_taxrate_6: "安装督导增值税率",
    row_taxrate_7: "仓储增值税率",
    row_taxrate_8: "末端配送增值税率",
    row_taxrate_9: "货运/报关代理增值税率",
    row_taxrate_10: "服务增值税率",
    row_taxrate_11: "其他费用增值税率",
    row_taxrate_12: "清关杂增值税率",
    row_currency_1: "关税币种",
    row_currency_2: "代理币种",
    row_currency_3: "物流币种",
    row_currency_4: "检测币种",
    row_currency_5: "系统集成币种",
    row_currency_6: "安装督导币种",
    row_currency_7: "仓储币种",
    row_currency_8: "末端配送币种",
    row_currency_9: "货运/报关代理币种",
    row_currency_10: "服务币种",
    row_currency_11: "其他费用币种",
    row_currency_12: "清关杂币种",
    row_rowremark: "备注",
    selfundsourcemsg: "请先选择需求来源",
    errormsg1: "还有未生成订单合同的关联信息，请触发完再提交！",
    errormsg2: "只能匹配单个框架协议！",
    errormsg3: "第{0}行修改后的物料税额小计超过设定的修改范围{1}-{2}！",
    errormsg4: "只允许相同物料编码的采购需求行项同时发起选择物料！",
  },
  stockorderchglist: {
    toybTab: "归档订单",
    tochgtodoTab: "变更列表",
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    stocktype: "采购种类",
    toselect: "请选择",
    indexMethod: "行号",
    orderchgtitle: "订单变更",
    chgreason: "变更理由",
    chgorder: "发起变更",
    inputchgreasonmsg: "请输入变更原因",
    applydate: "发起时间",
    applyusername: "变更发起人",
    chbtype: "变更类型",
    currstatus: "变更状态",
    htonwaymsg: "存在在途的合同变更单，请在合同系统提交完后再进行订单变更！",
    shonwaymsg: "存在在途的收货单，请在提交完后再进行订单变更！",
    billno: "单据编码",
    contractcode: "合同编码",
    demandcode: "采购需求编码",
    speccode: "专业",
    belongregion: "区域",
  },
  role: {
    inputPlaceholder: "请输入内容",
    title: "角色新增修改",
    cancel: "取消",
    add: "新增",
    query: "查询",
    delete: "删除",
    confirm: "确定",
    home: "首页",
    permission: "权限配置",
    roleConfig: "角色配置",
    baseInfo: "基本信息",
    rolename: "角色名称",
    rolecode: "角色代码",
    itemList: "行项列表",
    roledesc: "角色描述",
    roletype: "角色类型",
  },
  roleload: {
    title: "角色信息",
    rolecode: "角色代码",
    rolename: "角色名称",
    roledesc: "角色描述",
    sysflag: "是否系统内置角色",
    suitflag: "是否适用整个地区",
    selectedPlaceholder: "请选择",
    inputPlaceholder: "请输入内容",
    save: "保存",
    personInfo: "人员信息",
    deptInfo: "部门信息",
    roleuserid: "主键ID",
    userid: "用户ID",
    username: "用户名称",
    index: "序号",
    roledeptid: "主键ID",
    areacode: "所属地区id",
    deptid: "部门id",
    deptname: "部门",
    areaname: "所属地区",
  },
  modutree: {
    inputPlaceholder: "请输入内容",
    save: "暂存",
    basiInfo: "基本信息",
    add: "新增",
    delete: "删除",
    moduid: "模块代码",
    moduname: "模块名称",
    ifrulecontrol: "是否权限控制",
    menuname: "对应控制菜单",
    modusystem: "对应控制系统",
    modutype: "模块类型",
    rightlevel: "默认权限类型",
    queryLevel: "默认查询范围",
    areaname: "地区",
    checkrightid: "主键ID",
    areacode: "所属地区id",
    roleid: "角色id",
    rolecode: "角色编码",
    rolename: "角色名称",
    roledesc: "角色描述",
    checkright: "特殊权限",
    defaultCheckright: "默认权限"
  },
  organize: {
    billdetail: "单据信息",
    num: "序号",
    deptcode: "部门编码",
    pdeptname: "上级部门",
    deptname: "部门名称",
    deptname_en: "部门名称（英）",
    deptname_ph: "部门名称（菲）",
    disport: "排序",
    depttype: "部门类型",
    status: "是否有效",
    bmzz: "部门正职",
    bmfz: "部门副职",
    save: "保存",
    cancel: "取消",
    add: "新增",
    query: "查询",
    delete: "删除",
    userid: "账号",
    username: "用户名",
    username_en: "用户名称(英)",
    username_ph: "用户名称(菲)",
    gender: "性别",
    mobile: "用户电话",
    email: "用户邮箱",
    userstatus: "状态",
    islock: "是否锁定",
    company: "公司",
    title: "部门职务",
    deptselect: "部门选择",
    deleteConfig: "确定要删除吗"
  },
  sendscene: {
    orderno: "采购订单编号",
    contractcode: "法律订单编码",
    stockusername: "采购管理员",
    query: "查询",
    ordername: "采购订单名称",
    orderdate: "订单日期",
    startdate: "开始日期",
    enddate: "结束日期",
    reset: "重置",
    order: "行号",
    manuname: "供应商",
    oper: "操作",
    view: "查看",
    billno: "单据编码",
    applydate: "开单日期",
    chstore: "收料仓库",
    accountdate: "过账日期",
    del: "删除",
    tosendscene: "待直发现场",
    sendscene: "直发现场",
    todo: "办理",
    tosendsceneback: "待直发现场退货",
    sendsceneback: "直发现场退货"
  },
  sendscenebill: {
    plandate: "到货日期",
    storedate: "过账日期",
    planuserid: "开单员",
    orderno: "采购订单编号",
    storeid: "收料仓库",
    manuname: "供应商名称",
    ordername: "采购订单名称",
    remark: "备注",
    listinfo: "列表信息",
    listnum: "行号",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "单位",
    stocknum: "采购数量",
    recnum: "可收数量",
    plannum: "到货数量",
    storenum: "实收数量",
    price: "单价",
    recsum: "金额",
    projcode: "子项目编码",
    projname: "子项目名称",
    investflag: "子项目出库类别",
    zstrp: "进项税转出类型",
    execunitname: "施工单位",
    execteamid: "施工小队",
    notes: "备注",
    serialno: "库存批次",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    billno: "单据编码",
    checknumtip: "行项实收数量不能大于到货数量！",
    checkrecnumtip: "行项到货数量不能大于可收数量！",
    title: "直发现场收货单",
    baseinfo: "基本信息",
    backtitle: "直发现场退货单",
    backstoreid: "退货仓库",
    backstocknum: "收货数量",
    backonlinenum: "已退数量",
    backrecnum: "可退数量",
    backstorenum: "实退数量",
    costcenter: "成本中心",
    chouttype2: "用途类别"
  },
  rec: {
    orderno: "采购订单编号",
    stockbillno: "采购单据编码",
    contractcode: "订单合同编码",
    stockusername: "采购管理员",
    query: "查询",
    ordername: "采购订单名称",
    orderdate: "订单日期",
    startdate: "开始日期",
    enddate: "结束日期",
    reset: "重置",
    order: "行号",
    manuname: "供应商",
    manuno: "供应商编码",
    oper: "操作",
    view: "查看",
    billno: "单据编码",
    applydate: "开单日期",
    chstore: "收料仓库",
    accountdate: "过账日期",
    del: "删除",
    torec: "待订单收货",
    rec: "收货单",
    todo: "办理",
    outmanuname: "委外供应商",
    belongeregion: "区域",
    speccode: "一级专业"
  },
  recbill: {
    plandate: "到货日期",
    storedate: "过账日期",
    planuserid: "账务管理员",
    orderno: "采购订单编号",
    stockbillno: "采购单据编码",
    storeid: "收料仓库",
    manuname: "供应商名称",
    manuno: "供应商编码",
    ordername: "采购订单名称",
    remark: "备注",
    listinfo: "列表信息",
    listnum: "行号",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "单位",
    stocknum: "采购数量",
    recnum: "可收数量",
    plannum: "到货数量",
    storenum: "实收数量",
    price: "单价",
    recsum: "金额",
    projcode: "子项目编码",
    projname: "子项目名称",
    investflag: "子项目出库类别",
    zstrp: "进项税转出类型",
    execunitname: "施工单位",
    execteamid: "施工小队",
    notes: "备注",
    serialno: "库存批次",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    billno: "单据编码",
    checknumtip: "行项实收数量不能大于到货数量！",
    checkrecnumtip: "行项到货数量不能大于可收数量！",
    title: "收货单",
    title2: "采购订单收货并委外",
    title3: "受托自管入库单",
    title4: "受托物资收货并委外",
    baseinfo: "基本信息",
    editesn: "录入串码",
    viewesn: "查看串码",
    oper: "操作",
    currency: "交易币种",
    outmanuname: "委外供应商",
    duties_total: "关税总额",
    customs_total: "运杂费总额",
    recsum_total: "金额合计",
    recsum_goods: "货物金额",
    duties: "关税",
    customs: "清关运杂费",
    price_goods: "单价",
    sn: "实物序列号",
    assetclass: "资产分类",
    assetcodeno: "资产卡片编号",
    taxsum: "税额",
    costcenter: "成本中心",
    checkapplynumtip: "行项到货数量不能大于可用数量！",
    reqoutmanunoTips: "请选择委外供应商!",
    changeoutmanunoTips: "请清空已选择的物资需求明细，再更换委外供应商!",
    fileup: "上传附件",
    ifjngs: "DITO是否缴纳关税",
    ebelp: "行项目号",
    localrecsum: "本位币金额",
    localrecsum_total: "本位币金额合计",
    ukurs: "汇率",
    belongeregion: "区域",
    contractcode: "合同编码",
    contractname: "合同名称",
    officeassetclass: "办公资产分类",
    officeassetcode: "办公资产卡片编号",
    officeassettitle: "办公资产卡片信息",
    useusername: "使用人",
    usedept: "使用部门",
    assetstatus: "资产状态",
    estimareplacedate: "预计更换日期",
    receivebillno: "收货单编号",
    purchaseamount: "购买金额",
    description: "资产描述",
    qy: "区域",
    assignusername: "领用人",
    ifcapitalizable: "是否可资本化",
    relatebillno: "资产最终关联单据编号",
    match:"实物序列号",
    savebtn:"保存",
    checkidxmsg: "第{}行：",
    checknotnullmsg: "不能为空!",
    assetinfo:"办公资产信息",
    sendft:"传送FT"
  },
  expexcel: {
    msg: "导出成功，请点击下载：",
    tiptitle: "提示",
    confirm: "确定",
    cancel: "取消",
    cancelmsg: "已取消操作",
    download: "下载"
  },
  stockcommonreport: {
    msg: "确定删除单据吗?",
    tiptitle: "提示",
    confirm: "确定",
    cancel: "取消",
    cancelmsg: "已取消操作",
    choosedelbill: "请选择要删除的单据",
    chooseapplydept: "请选择申请部门",
    choosecompanycode: "请选择公司代码",
    chooseapplytype: "请选择采购申请类型",
    selapplytypemsg: "已选择采购需求信息，确定后将删除行项信息",
  },
  materialdatalist: {
    billno: "单据编码",
    billname: "单据名称",
    applyusername: "申请人",
    applydate: "申请日期"
  },
  materialdataload: {
    officebigtitle: "办公资产物料主数据",
    officesuppliesbigtitle : "办公用品物料主数据",
    bigtitle: "物料主数据",
    baseinfo: "基本信息",
    applyareaname: "申请单位",
    applydeptname: "申请部门",
    applyusername: "申请人",
    applydate: "申请日期",
    billno: "单据编码",
    billname: "申请单据名",
    mobile: "联系电话",
    officerowbigtitle: "办公资产物料明细",
    rowbigtitle: "物料列表信息",
    materialtypename: "物资目录",
    materialtypecode: "物资目录编号",
    first: "一级物资目录名称",
    second: "二级物资目录名称",
    third: "三级物资目录名称",
    materialname: "物料名称",
    materialcode: "物料编码（归档自动生成）",
    materialtype: "物资类型",
    spec: "规格型号",
    materialdesc: "物料描述",
    unitid: "计量单位",
    bussinessdesc: "业务描述",
    expandmaterialname: "推荐的物料名称",
    expandmaterialcode: "推荐的物料编码",
    expandspec: "推荐物料规格型号",
    ifserial: "是否实例化管理",
    evalclass: "评估类名称",
    itemevaltype: "项目库存的评估分类",
    itemevaltypename: "项目库存评估类名称",
    ifmianmaterial: "是否主辅料",
    checkMaterialExistTips1: "第",
    checkMaterialExistTips2: "行的物料重复,请重新录入!",
    zwtgc: "是否生成卡片",
    zcml: "资产目录",
    zobj_type: "对应资源规格编码",
    zobj_type_name: "对应资源规格名称",
    zmanu: "生产厂商",
    zbrma: "生产厂商品牌",
    officeassetclass: "办公资产分类",
    assetclass: "资产分类",
    sapmsg: "错误"
  },
  materialtypedatalist: {
    billno: "单据编码",
    applytypename: "申请类型",
    applyusername: "申请人",
    applydate: "申请日期",
    billname: "单据名称"
  },
  materialtypedataload: {
    officebigtitle: "办公资产物料目录申请单",
    officesuppliesbigtitle: "办公用品物料目录申请单",
    bigtitle: "物料目录申请单",
    baseinfo: "基本信息",
    applyareaname: "申请单位",
    applydeptname: "申请部门",
    applyusername: "申请人",
    applydate: "申请日期",
    billno: "单据编码",
    billname: "单据名称",
    mobile: "申请人联系电话",
    officerowbigtitle: "办公资产物资分类明细",
    rowbigtitle: "物资分类列表信息",
    pmaterialtypecode: "父级分类编码",
    pmaterialtypename: "父级分类名称",
    materialtypecode: "子级分类编码(归档自动生成）",
    materialtypename: "子级分类名称",
    evalclass: "评估类名称",
    qklas: "项目库存评估分类",
    status: "状态",
    choosematerialtype: "选择物资目录",
    firstmaterialtypewarn: "当前创建的是物资目录主数据一级节点，是否继续创建",
    parentofficeassetclass: "父级办公资产分类",
    officeassetclass: "办公资产分类",
    assetclass: "资产分类",
    checkMaterialtypeExistTips1: "第",
    checkMaterialtypeExistTips2: "行的子级分类名称重复,请重新录入!",
    sapmsg: "错误"
  },
  vendorbanklist: {
    vendorbanklist: "供应商银行",
    vendorbankdatalist: "供应商银行申请",
    bankcode: "银行代码",
    bankswift: "银行SWIFT代码",
    bankname: "银行名称",
    applytypename: "申请类型",
    applyusername: "申请人",
    applydate: "申请日期",
    opertype: "申请类型",
    chooseopertype: "请选择申请类型",
    countryname: "国家",
    bankaddress: "银行地址",
    tochange: "变更",
    addBank: "创建银行信息",
    rowbigtitle: "供应商银行日志"
  },
  vendorbankload: {
    bigtitle: "供应商银行",
    baseinfo: "基本信息",
    bankswift: "银行SWIFT代码",
    bankcode: "银行代码",
    bankname: "银行名称",
    country: "国家",
    belongregion: "地区",
    city: "城市",
    bankgroup: "银行组",
    bankaddress: "银行地址",
    applydate: "申请日期",
    applytype: "申请类型",
    voidflag: "是否有效"
  },
  materialdatachglist: {
    billno: "单据编码",
    applytype: "申请类型",
    applytypename: "申请类型",
    applyusername: "申请人",
    applydate: "申请日期",
    opertype: "申请类型",
    chooseopertype: "请选择申请类型"
  },
  materialdatachgload: {
    bigtitle: "物料变更申请",
    officebigtitle: "办公资产物料变更申请",
    officesuppliesbigtitle: "办公用品物料变更申请",
    baseinfo: "基本信息",
    applyareaname: "申请单位",
    applydeptname: "申请部门",
    applyusername: "申请人",
    applydate: "申请日期",
    billno: "单据编码",
    applytype: "申请类型",
    mobile: "申请人联系电话",
    rowbigtitle: "冻结/解冻物料信息",
    materialtypename: "物资目录",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    unitid: "计量单位",
    reason: "冻结/解冻原因",
    sapmsg: "错误"
  },
  BatchMatchBstoreInfo: {
    title: "选择库存信息",
    confirm: "确定",
    cancel: "取消",
    clear: "清空",
    operaterow: "操作",
    checkboxT: "选择",
    rownum: "行号",
    materialname: "名称",
    materialcode: "编码",
    sobkz: "库存类型",
    applynum: "数量",
    spec: "规格型号",
    chunit: "单位",
    status: "状态",
    placeholder: "输入关键字搜索",
    nomsg: "暂无数据",
    materialnameqct: "名称(精确)",
    storedate: "入库时间",
    storenum_que: "可用库存数量",
    storenum: "库存数量",
    onlinenum: "在途占用",
    thisbillstorenum: "本单占用",
    serialno: "批次号",
    projcode: "子项目编码",
    chstore: "仓库",
    manuname: "供应商",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商产品规格型号",
    orimanudrip: "原厂商产品描述",
    chifserial: "是否实例化管理",
    plannum: "本次开单数量",
    price: "单价",
    batchmatchbtore: "匹配自有库存",
    choosestore: "请选择仓库",
    choosebilldemandList: "请选择需要匹配库存的需求清单",
    chooseselectmaterialrow: "请选择需求信息",
    plannumgreaterthanzero: "开单数量必须大于0!",
    plannumgtusablestorenum: "行项开单数量不能大于可用库存数量！",
    thisbillstorenumgtusablestorenum: "本单占用数量大于可用库存数量，无法再匹配！",
    selectbstore: "请选择库存信息",
    usablestorenumequalzero: "可用库存数量为0，无法再匹配！",
    thispendingnumltzero: "待处理数量已全部匹配，需要重新调整已匹配物料!"
  },
  selectMaterial: {
    title: "选择物料信息",
    operaterow: "操作",
    checkboxT: "选择",
    rownum: "行号",
    materialname: "名称",
    materialcode: "编码",
    spec: "规格型号",
    unitid: "单位",
    status: "状态",
    clear: "清空",
    query: "查询",
    placeholder: "输入关键字搜索",
    confirm: "确定",
    cancel: "取消",
    nomsg: "暂无数据",
    vmaterialnameqct: "名称(精确)",
    vismodel: "是否有框架",
    vstatus: "物料状态",
    vmaterialtypename: "已选择物料目录",
    vmaterialtype: "物资类型",
    warn: "请选择物料信息"
  },
  stockserviceload: {
    materialcode: "物料编码",
    materialname: "物料名称",
    manuname: "服务供应商",
    chfeetype: "费用类型",
    feerate: "费率（%）",
    taxrate: "服务增值税率（%）",
    inputPlaceholder: "请输入",
    serviceTitle: "采购物资服务费用明细信息",
    savebtn: "保存",
    pricemode: "计价方式",
    costprice: "单价",
    costsum: "服务费总金额（不含增值税）",
    currency: "交易币种",
    checkidxmsg: "第{}行：",
    checknotnullmsg: "不能为空!",
  },
  flow: {
    btype: "业务类型",
    curruser: "当前办理人",
    currstatus: "当前办理步骤",
    receivetime: "送达时间",
    billno: "编号/字号",
    title: "标题",
    operlimitdate: "办理时间",
    status: "办理步骤"
  },
  sstorelist: {
    storecode: "仓库编码",
    chstore: "仓库名称",
    storetype: "仓库归属",
    storeproperty: "仓库级别",
    storeclass: "仓库类型",
    tel: "联系电话",
    address: "仓库地址",
    chstatus: "仓库状态",
    applyareaname: "地区",
    sstore_main_imp: "仓库信息导入",
    sstore_row_imp: "管理员信息导入",
  },
  sstoreload: {
    bigtitle: "库房配置",
    storeuserbigtitle: "实物管理员",
    planuserbigtitle: "账务管理员",
    baseinfo: "基本信息",
    storecode: "仓库编码",
    storeid_sap: "SAP仓库编码",
    storeid_crm: "CRM仓库编码",
    chstore: "仓库名称",
    storetype: "仓库归属",
    storeproperty: "仓库级别",
    linkuser: "联系人",
    storeclass: "仓库类型",
    tel: "联系电话",
    address: "仓库地址",
    chstatus: "仓库状态",
    storeuserid: "实物管理员ID",
    storeusername: "实物管理员名称",
    storeuserdept: "部门",
    storeusertel: "联系电话",
    storeuserstatus: "是否有效",
    planuserid: "账务管理员ID",
    planusername: "账务管理员名称",
    planuserdept: "部门",
    planusertel: "联系电话",
    planuserstatus: "是否有效",
    accountuserid: "料账员ID",
    accountusername: "料账员名称",
    accountuserdept: "部门",
    accountusertel: "联系电话",
    accountuserstatus: "是否有效",
    storegroup: "仓库组"
  },
  accountdatecfglist: {
    queryoperlog: "操作日志查询",
    setautoswitchtime: "设定账期自动切换时点",
    accountdate: "账期年月",
    status: "状态",
    operate: "操作",
    areaconfig: "公司账期配置",
    reopenaccountdate: "重新开账",
    closeaccountdate: "关账",
    switchaccountdateerror: "账期配置切换失败",
    executionfrequency: "执行频率",
    monthly: "每月",
    executiondate: "执行日期",
    executiontime: "执行时间点",
    disabled: "是否禁用",
    checkexecutiondateerror: "执行日期不能为空!",
    checkexecutiontimeerror: "执行时间点不能为空!"
  },
  accountdatecfgload: {
    bigtitle: "账期配置",
    areaconfigTitle: "公司账期配置",
    areaname: "公司",
    baseinfo: "基本信息",
    accountdate: "账期年月",
    status: "是否启用",
    notes: "备注",
    remark: "备注"
  },
  accountdateoperloglist: {
    choper_type: "操作类型",
    oper_username: "操作人名称",
    oper_user: "操作人账号",
    accountdate_before: "修改前账期",
    accountdate_after: "修改后账期",
    createtime: "操作时间"
  },
  smateriallist: {
    rownum: "序号",
    materialtypecode: "物资目录编码",
    materialtypename: "物资目录",
    bigmaterialtypename: "物资目录大类",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    evalclass: "评估类型及名称",
    chstatus: "状态",
    choosematerialtype: "请选择物资目录"
  },
  smaterialload: {
    bigtitle: "物料展示信息",
    officebigtitle: "办公资产物料展示信息",
    officesuppliesbigtitle: "办公用品物料展示信息",
    baseinfo: "基本信息",
    applyusername: "申请人",
    createtime: "申请日期",
    rowbigtitle: "物料状态变更日志",
    materialname: "物料名称",
    materialcode: "物料编码",
    materialtypecode: "物资目录编码",
    materialtypename: "物资目录名称",
    chmaterialtype: "物料类型",
    spec: "规格型号",
    unitname: "计量单位",
    evalclassname: "评估类型",
    text: "物料描述",
    bussinessdesc: "业务描述",
    expandmaterialcode: "推荐物料编码",
    expandmaterialname: "推荐物料名称",
    expandspec: "推荐规格型号",
    chifmianmaterial: "是否主辅料",
    chzwtgc: "是否生成卡片",
    zcml: "资产目录",
    zobj_type: "对应资源规格编码",
    zobj_type_name: "对应资源规格名称",
    assetclass: "资产分类",
    officeassetclass: "办公资产分类",
    rownum: "序号",
    chstatus: "状态",
    changeuser: "变更人",
    changedate: "变更时间",
    reason: "冻结/解冻原因",
    applytypename: "变更后状态",
    beforestatus: "变更前状态"
  },
  movedemandlist: {
    rownum: "序号",
    billno: "单据编码",
    createtime: "申请日期",
    createtime_begin: "开始日期",
    createtime_end: "结束日期",
    movetypename: "发起方",
    calltypename: "调拨类型",
    storetypename: "仓库类型",
    applyusername: "申请人",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    choosedemandtype: "请选择需求类型",
    chooseusetype: "请选择申请类型",
    notexistdemandtype: "需求类型不存在",
    choosemovetype: "请选择发起方"
  },
  movedemandload: {
    bigtitle: "移库需求单",
    unit: "单位",
    baseinfo: "基本信息",
    billno: "单据编码",
    applyusername: "申请人",
    applydeptname: "申请部门",
    applyareaname: "申请地区",
    createtime: "申请日期",
    applyuser_tel: "申请人电话",
    rowbigtitle: "物资明细",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    unitname: "计量单位",
    uploadfile: "附件",
    rownum: "行号",
    movetypename: "发起方",
    calltypename: "调拨类型",
    sourcetype: "需求来源",
    remark: "备注",
    price: "预估单价",
    currency: "交易币种",
    recsum: "预估金额(元)",
    applynum: "申请数量",
    linkaddress: "收货地址",
    linkuser: "收货联系人",
    linktel: "收货联系电话",
    jh_linkaddress: "交货地址",
    jh_linkuser: "交货联系人",
    jh_linktel: "交货联系电话",
    notes: "备注",
    backusername: "需求退回人",
    backnum: "退回数量",
    backreason: "退回原因",
    chstore_out: "移出仓库",
    chstore_in: "移入仓库",
    logistics_cost_borne: "物流费用承担方",
    expected_logistics_recsum: "预计物流费金额",
    storeSameTips: "请选择不同的调出仓库和调入仓库!"
  },
  demandlist: {
    rownum: "行号",
    billno: "单据编码",
    createtime: "制单日期",
    createtime_begin: "开始日期",
    createtime_end: "结束日期",
    demandtypename: "需求类型",
    projcode: "子项目编码",
    projname: "子项目名称",
    outprojname: "委外子项目名称",
    outprojcode: "委外子项目编码",
    outmanuno: "委外供应商编码",
    outmanuname: "委外供应商",
    applyusername: "申请人",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    choosedemandtype: "请选择需求类型",
    chooseusetype: "请选择申请类型",
    notexistdemandtype: "需求类型不存在",
    demandlistTab: "领料需求"
  },
  inventorythresholdcfglist: {
    rownum: "行号",
    billno: "单据编码",
    createtime: "制单日期",
    createtime_begin: "开始日期",
    createtime_end: "结束日期",
    applyusername: "申请人",
    chdemandstatus: "需求状态",
    materialcode: "物料编码"
  },
  inventorythresholdcfgload: {
    bigtitle: "库存阈值设置",
    baseinfo: "基本信息",
    billno: "单据编码",
    applyusername: "申请人",
    applydeptname: "申请部门",
    applyareaname: "申请地区",
    createtime: "制单日期",
    applyuser_tel: "申请人电话",
    rowbigtitle: "物资明细",
    materialname: "物料名称",
    materialcode: "物料编码",
    rownum: "行号",
    remark: "备注",
    notes: "备注",
    storeid: "仓库",
    voidflag: "是否有效",
    plannum: "预警数量",
    stocknum: "采购数量",
    dealstatus: "处置方式",
    submitbtn: "提交",
    noticeuser: "预警通知人",
    noticetel: "预警通知人联系电话"
  },
  officeassetmanagercfg: {
    bigtitle: "办公资产管理员配置",
    baseinfo: "基本信息",
    usertype: "用户类型",
    userid: "管理员ID",
    username: "管理员名称",
    deptname: "部门",
    voidflag: "是否有效"
  },
  materialgetlist: {
    toget: "待开单",
    get: "领料需求正式单",
    rownum: "行号",
    billno: "正式单据编码",
    demandbillno: "需求单据编码",
    createtime: "申请日期",
    createtime_begin: "开始日期",
    createtime_end: "结束日期",
    demandtypename: "需求类型",
    chbelongeregion: "所属地区",
    projcode: "子项目编码/委外供应商编码/成本中心",
    applyusername: "申请人",
    operate: "操作",
    todo: "办理",
    batchtodo: "批量办理",
    choosedemand: "请选择领料需求",
    execunitname: "施工单位",
    receivedate: "到达任务池时间",
    plandate: "开单日期",
    startdate: "开始时间",
    enddate: "结束时间",
    storeid: "仓库",
    chcompanycode: "公司代码",
    demandtypeerror: "请选择相同的需求类型行项",
    sourcetypeerror: "请选择相同的需求来源行项",
    projcodeerror: "请选择相同的子项目编码/委外供应商编码/成本中心行项",
    execunitcodeerror: "请选择相同的施工单位行项",
    storeiderror: "请选择相同的子仓库行项",
    companycodeerror: "请选择相同的公司代码行项",
    belongeregionerror: "请选择相同的所属地区"
  },
  itemmaterialgetbillload: {
    plandate: "开单日期",
    storedate: "过账日期",
    planusername: "账务管理员",
    storeusername: "实物管理员",
    orderno: "采购订单编号",
    chstore: "仓库",
    manuname: "供应商名称",
    ordername: "采购订单名称",
    remark: "备注",
    demandinfo: "需求清单",
    listinfo: "本次发货清单",
    listnum: "行号",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "计量单位",
    applynum: "申请数量",
    donenum: "已处理数量",
    applysum: "申请金额",
    plannum: "开单数量",
    storenum: "实际数量",
    price: "单价",
    recsum: "金额",
    projcode_out: "子项目编码",
    projname_out: "子项目名称",
    outprojname: "委外子项目名称",
    outprojcode: "委外子项目编码",
    investflag: "子项目出库类别",
    costcenter: "成本中心",
    zstrp: "进项税转出类型",
    execunitname: "施工单位",
    notes: "备注",
    serialno: "库存批次",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    billno: "单据编码",
    baseinfo: "基本信息",
    unit: "单位",
    bigtitle: "领料发货出库单",
    chexecunitflag: "是否施工管理",
    applyareaname: "领料单位",
    proj_status: "项目状态",
    ifstoremanage: "是否实物库管理",
    orgdemandbillno: "领料需求单号",
    chzstrp: "进项税转出类型",
    evalclassname: "评估类",
    storenum_que: "可用库存数量",
    onlinenum: "在途占用数量",
    chinvestflag: "项目出库类别",
    tomatchstore: "匹配自有库存",
    checknumtip: "行项实际数量不能大于开单数量！",
    checkplannumtip: "行项开单数量不能大于可用库存数量！",
    checkdemandnumtip: "本次开单数量+已办理数量不能大于需求申请数量",
    emptyrowlist: "本次发货清单不能为空!",
    chcurrency: "交易币种",
    chouttype2: "用途类别",
    belongeregion: "所属地区",
    outmanuno: "委外供应商编码",
    outmanuname: "委外供应商",
    aufnr: "内部订单编号"
  },
  othermaterialgetbillload: {
    plandate: "开单日期",
    storedate: "过账日期",
    planusername: "账务管理员",
    storeusername: "实物管理员",
    orderno: "采购订单编号",
    storeid: "仓库",
    manuname: "供应商名称",
    ordername: "采购订单名称",
    remark: "备注",
    demandinfo: "需求清单",
    listinfo: "本次发货清单",
    listnum: "行号",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "计量单位",
    applynum: "申请数量",
    donenum: "已处理数量",
    applysum: "申请金额",
    plannum: "开单数量",
    storenum: "实际数量",
    price: "单价",
    recsum: "金额",
    projcode_out: "子项目编码",
    projname_out: "子项目名称",
    investflag: "子项目出库类别",
    zstrp: "进项税转出类型",
    execunitname: "施工单位",
    notes: "备注",
    serialno: "库存批次",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商规格型号",
    orimanudrip: "原厂商产品描述",
    billno: "单据编码",
    baseinfo: "基本信息",
    unit: "单位",
    bigtitle: "领料发货出库单",
    chexecunitflag: "是否施工管理",
    applyareaname: "领料单位",
    proj_status: "项目状态",
    ifstoremanage: "是否实物库管理",
    orgdemandbillno: "领料需求单号",
    chzstrp: "进项税转出类型",
    evalclassname: "评估类",
    storenum_que: "可用库存数量",
    onlinenum: "在途占用数量",
    chinvestflag: "项目出库类别",
    tomatchstore: "匹配自有库存",
    checknumtip: "行项实际数量不能大于开单数量！",
    checkplannumtip: "行项开单数量不能大于可用库存数量！",
    checkdemandnumtip: "本次开单数量+已办理数量不能大于需求申请数量",
    emptyrowlist: "本次发货清单不能为空!",
    chcurrency: "交易币种"
  },
  itemdemandload: {
    bigtitle: "领料需求单",
    unit: "单位",
    baseinfo: "基本信息",
    billno: "单据编码",
    applyusername: "申请人",
    applydeptname: "申请部门",
    applyareaname: "申请地区",
    createtime: "制单日期",
    applyuser_tel: "申请人电话",
    rowbigtitle: "物资明细",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    unitname: "计量单位",
    uploadfile: "附件",
    rownum: "行号",
    demandtype: "需求类型",
    sourcetype: "需求来源",
    remark: "备注",
    price: "预估单价",
    currency: "交易币种",
    recsum: "预估金额(元)",
    applynum: "申请数量",
    projname: "子项目名称",
    projcode: "子项目编码",
    outprojname: "委外子项目名称",
    outprojcode: "委外子项目编码",
    execunitname: "施工单位",
    investflag: "项目出库类别",
    zxslx: "视同销售类型",
    zstrp: "进项税转出类型",
    linkaddress: "收货地址",
    linkuser: "收货联系人",
    linktel: "收货联系电话",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商产品规格型号",
    orimanudrip: "原厂商产品描述",
    notes: "备注",
    backusername: "需求退回人",
    backnum: "退回数量",
    store_out: "仓库",
    planusername: "账务管理员",
    backreason: "退回原因",
    execunitflag: "是否施工单位管理",
    costcenter: "成本中心",
    execunitcodeerror: "是否施工单位为是时,施工单位必填",
    chouttype2: "用途类别",
    belongeregion: "区域",
    outmanuname: "委外供应商",
    aufnr: "内部订单编号"
  },
  otherdemandload: {
    bigtitle: "领料需求单",
    unit: "单位",
    baseinfo: "基本信息",
    billno: "单据编码",
    applyusername: "申请人",
    applydeptname: "申请部门",
    applyareaname: "申请地区",
    createtime: "制单日期",
    applyuser_tel: "申请人电话",
    rowbigtitle: "物资明细",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    unitname: "计量单位",
    uploadfile: "附件",
    rownum: "序号",
    demandtype: "需求类型",
    sourcetype: "需求来源",
    remark: "备注",
    price: "预估单价",
    currency: "交易币种",
    recsum: "预估金额(元)",
    applynum: "申请数量",
    projname: "运维项目名称",
    projcode: "运维项目编码",
    execunitname: "施工单位",
    investflag: "项目出库类别",
    zxslx: "视同销售类型",
    zstrp: "进项税转出类型",
    linkaddress: "收货地址",
    linkuser: "收货联系人",
    linktel: "收货联系电话",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商产品规格型号",
    orimanudrip: "原厂商产品描述",
    notes: "备注",
    store_out: "仓库",
    planusername: "账务管理员",
    backusername: "需求退回人",
    backnum: "退回数量",
    backreason: "退回原因",
    execunitflag: "是否施工单位管理",
    costcenter: "成本中心",
    usetype: "用途类别",
    netelemname: "网络元素"
  },
  selectAufnrInfo: {
    title: "选择内部订单",
    orderCode: "内部订单编号",
    remark: "描述",
    controlRange: "控制范围",
    orderType: "订单类型",
    profitsCenter: "利润中心",
    orderCurrency: "订单货币",
    reqstorematerialTips: "请选择内部订单信息"
  },
  serviceconfirm: {
    title: "服务确认单",
    baseinfoTab: "基本信息",
    toserviceconfirmTab: "服务确认订单查询",
    serviceconfirmTab: "服务确认单据查询",
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    manuname: "供应商",
    stockusername: "采购管理员",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    demandtype: "需求类型",
    remark: "备注",
    fileup: "上传附件",
    listinfo: "列表信息",
    manuno2: "服务供应商编码",
    manuname2: "服务供应商名称",
    materialcode: "服务编码",
    materialname: "服务名称",
    stocknum: "采购数量",
    price: "单价",
    recnum: "可收数量",
    stockrecsum: "订单金额",
    confirmedscale: "比例(%)-已开单",
    confirmscale: "比例(%)-本次开单",
    finsum: "金额-已开单",
    recsum: "金额-本次开单",
    donlinenum: "数量-已开单",
    plannum: "数量-本次开单",
    isfinish: "是否最终收货完成",
    projcode: "子项目编码",
    projname: "子项目名称",
    zstrp: "进项税转出类型",
    notes: "备注",
    plannumMaxTips: "本次开单数量不能大于可收数量",
    reqplannumTips: "请在本次开单数量输入框内输入数值",
    contractcode: "法律订单编码",
    orderdate: "订单日期",
    startdate: "开始日期",
    enddate: "结束日期",
    rececompleteflag: "是否已确认",
    onlinenum: "数量-在途开单",
    onlinesum: "金额-在途开单",
    onlineconfirmscale: "比例(%)-在途开单",
    plannumMinTips: "本次开单数量不能大于已开单数量"
  },

  //===================================
  //人力系统公用
  hrcommon: {
    currstatus: "办理步骤",
    curruser: "当前办理人",
    submitbtn: "提交",
    savebtn: "保存",
    delbtn:"删除",
    copysucceed: "复制成功",
    imgtypelimit: "上传头像图片只能是 {0} 格式!",
    uploadtip1: "附件为空",
    uploadtip3: "上传失败",
    askifsumbit: "是否继续提交？",
    submitbilltip:"是否确认提交单据信息？",
    submitsuccess:"单据提交成功！"
  },
  //组织管理
  //部门创建
  deptload: {
    deptadd: "部门创建申请",
    deptchange: "部门变更申请",
    deptstop: "部门停用申请",
    billno: "单据编号",
    applyuserid: "申请人",
    contact: "联系方式",
    applydate: "申请日期",
    compid: "所属公司",
    deptcode: "部门编码",
    deptname: "部门名称",
    deptshortname: "部门缩写",
    pdeptid: "上级组织",
    deptcreatetime: "成立时间",
    effectivetime: "生效日期",
    stopbillid: "部门编码",
    stopdate: "停用日期",
    remark: "备注",
    inputPlaceholder: "请输入",
    prechange: "变更前部门信息",
    aftchange: "变更后部门信息",
    deptinfo: "部门信息",

    changeMsg: "该部门正在变更",
    stopMsg: "该部门正在停用",
    isRepeat: "部门编码重复",
    beforeSelectDept: "请选择公司",
    beforeSelectDepttwo: "请选择组织结构类型",
    beforeSelectPost: "请选择部门",
    selectupone: "组织结构类型为Division,上级组织请选择Company",
    selectuptwo: "组织结构类型为Department,上级组织请选择Division",
    selectupthree: "组织结构类型为Function,上级组织请选择Department",
  },
  deptlist: {
    indexMethod: "序号",
    billno: "单据编号",
    applydate: "申请日期",
    compid: "所属公司名称",
    deptshortname: "部门简称",
    deptname: "部门名称",
    deptcode: "部门编码",
    pdeptid: "上级组织",
    structuretype: "组织结构类型",
    effectivetime: "生效日期",

    curruserid: "当前审批人",

    tab1: "部门创建单",
    tab2: "归档单据"
  },
  //部门变更
  deptchangeload: {
    deptchange: "部门变更申请",
    billno: "单据编号",
    applyuserid: "申请人",
    contact: "联系方式",
    applydate: "申请日期",
    compid: "所属公司",
    structuretype: "部门类型",
    deptcode: "部门编码",
    deptname: "部门名称",
    deptshortname: "部门缩写",
    pdeptid: "上级组织",
    deptcreatetime: "成立时间",
    effectivetime: "生效日期",
    stopbillid: "部门编码",
    remark: "备注",
    inputPlaceholder: "请输入",
    prechange: "变更前部门信息",
    aftchange: "变更后部门信息",
    deptinfo: "部门信息",
  },
  deptchangelist: {
    indexMethod: "序号",
    billno: "单据编号",
    applydate: "申请日期",
    predeptname: "变更前部门名称",
    deptname: "变更后部门名称",
    compid: "公司名称",
    pdeptid: "上级组织",
    effectivetime: "生效日期",

    curruserid: "当前审批人",

    tab1: "部门变更单",
    tab2: "归档单据"
  },
  //部门停用
  deptstopload: {
    deptstop: "部门停用申请",
    billno: "单据编号",
    applyuserid: "申请人",
    contact: "联系方式",
    applydate: "申请日期",
    compid: "所属公司",
    structuretype: "部门类型",
    deptcode: "部门编码",
    deptname: "部门名称",
    deptshortname: "部门缩写",
    pdeptid: "上级组织",
    deptcreatetime: "成立时间",
    effectivetime: "生效日期",
    stopdate: "停用日期",
    remark: "备注",
    inputPlaceholder: "请输入",
    deptinfo: "部门信息",
  },
  deptstoplist: {
    indexMethod: "序号",
    billno: "单据编号",
    applydate: "申请日期",
    compid: "公司名称",
    deptname: "部门名称",
    deptcode: "部门编码",
    pdeptid: "上级组织",
    stopdate: "停用时间",

    curruserid: "当前审批人",

    tab1: "部门停用单",
    tab2: "归档单据"
  },
  //公司创建
  companyload: {
    companyadd: "公司创建申请",
    billno: "单据编号",
    applyuserid: "申请人",
    contact: "联系方式",
    applydate: "申请日期",
    compname: "公司名称",
    compshortname: "公司简称",
    compno: "公司编码",
    effectivetime: "生效日期",
    porgid: "上级公司",
    stopbillid: "公司编码",
    busiaddr: "营业地址",
    remark: "备注",
    inputPlaceholder: "请输入",
    companyinfo: "公司信息",

    changeMsg: "该公司正在变更",
    stopMsg: "该公司正在停用",
    isRepeat: "公司编码重复",
  },
  companylist: {
    indexMethod: "序号",
    billno: "单据编号",
    applydate: "申请日期",
    compname: "公司名称",
    compshortname: "公司简称",
    compno: "公司编码",
    porgid: "上级公司",
    effectivetime: "生效日期",

    curruserid: "当前审批人",

    tab1: "公司创建单",
    tab2: "归档单据"
  },
  //公司变更
  companychangeload: {
    companychange: "公司变更申请",
    billno: "单据编号",
    applyuserid: "申请人",
    contact: "联系方式",
    applydate: "申请日期",
    compname: "公司名称",
    compshortname: "公司简称",
    compno: "公司编码",
    effectivetime: "生效日期",
    porgid: "上级公司",
    stopbillid: "公司编码",
    busiaddr: "营业地址",
    remark: "备注",
    inputPlaceholder: "请输入",
    prechange: "公司变更前信息",
    aftchange: "公司变更后信息",
    companyinfo: "公司信息",
  },
  companychangelist: {
    billno: "单据编号",
    indexMethod: "序号",
    applydate: "申请日期",
    precompname: "变更前公司名称",
    compname: "变更后公司名称",
    compno: "公司编码",
    porgid: "上级公司",
    effectivetime: "生效日期",

    curruserid: "当前审批人",

    tab1: "公司变更单",
    tab2: "归档单据"
  },
  //公司停用
  companystopload: {
    companystop: "公司停用申请",
    billno: "单据编号",
    applyuserid: "申请人",
    contact: "联系方式",
    applydate: "申请日期",
    compname: "公司名称",
    compshortname: "公司简称",
    compno: "公司编码",
    effectivetime: "生效日期",
    porgid: "上级公司",
    stopdate: "停用日期",
    busiaddr: "营业地址",
    remark: "备注",
    inputPlaceholder: "请输入",
    companyinfo: "公司信息",
  },
  companystoplist: {
    indexMethod: "序号",
    billno: "单据编号",
    applydate: "申请日期",
    compname: "公司名称",
    compshortname: "公司简称",
    compno: "公司编码",
    porgid: "上级公司",
    stopdate: "停用时间",

    curruserid: "当前审批人",

    tab1: "公司停用单",
    tab2: "归档单据"
  },
  //岗位创建
  positionload: {
    position: "岗位新增",
    companyid: "所属公司",
    deptid: "所属部门",
    positionno: "岗位编码",
    positionname: "岗位名称",
    deptname:"部门",
    dutyname: "职务名称",
    positionseq: "岗位序列",
    positionlevel: "岗位层级",
    positionshortname: "岗位简称",
    createtime: "创建时间",
    positiongrade: "岗位等级",
    remark: "备注",
    inputPlaceholder: "请输入",

    changeMsg: "该岗位正在变更",
    stopMsg: "该岗位正在停用",
    isRepeat: "岗位编码重复",
    isleader: "是否部门领导",
    checkleadtip: "本部门已经在{0}岗位下设置了部门领导，请重新选择！"
  },
  positionlist: {
    indexMethod: "序号",
    applydate: "申请日期",
    deptid: "所属部门名称",
    positionshortname: "岗位简称",
    positionname: "岗位名称",
    positionno: "岗位编码",
    positionseq: "岗位序列",

    curruserid: "当前审批人",

    tab1: "岗位创建单",
    tab2: "归档单据"
  },
  //岗位变更
  positionchangeload: {
    position: "岗位变更",
    companyid: "所属公司",
    deptid: "所属部门",
    positionno: "岗位编码",
    prepositionname: "原岗位名称",
    predutyname: "原职务名称",
    prepositionseq: "原岗位序列",
    positionname: "现岗位名称",
    dutyname: "现职务名称",
    positionseq: "现岗位序列",
    positionlevel: "现岗位层级",
    positionshortname: "现岗位简称",
    createtime: "创建时间",
    positiongrade: "现岗位等级",
    remark: "备注",
    inputPlaceholder: "请输入"
  },
  positionchangelist: {
    indexMethod: "序号",
    applydate: "申请日期",
    deptid: "所属部门名称",
    prepositionname: "原岗位名称",
    positionname: "现岗位名称",
    positionno: "岗位编码",
    positionseq: "现岗位序列",

    curruserid: "当前审批人",

    tab1: "岗位变更单",
    tab2: "归档单据"
  },
  //岗位停用
  positionstopload: {
    position: "岗位停用",
    companyid: "所属公司",
    deptid: "所属部门",
    positionno: "岗位编码",
    positionname: "岗位名称",
    dutyname: "职务名称",
    positionseq: "岗位序列",
    positionlevel: "岗位层级",
    positionshortname: "岗位简称",
    stopdate: "停用日期",
    positiongrade: "岗位等级",
    remark: "备注",
    inputPlaceholder: "请输入"
  },
  positionstoplist: {
    indexMethod: "序号",
    applydate: "申请日期",
    deptid: "所属部门名称",
    positionname: "岗位名称",
    positionno: "岗位编码",
    positionseq: "岗位序列",
    stopdate: "停用时间",

    curruserid: "当前审批人",

    tab1: "岗位停用单",
    tab2: "归档单据"
  },
  //人事管理
  SelectStaffInfo: {
    title: "人员选择",
    rownum: "序号",
    username: "用户名",
    firstname: "First Name",
    lastname: "Last Name",
    account: "账号",
    deptname: "所属部门",
    clear: "清空",
    query: "查询",
    placeholder: "输入关键字搜索",
    confirm: "确定",
    cancel: "取消",
    nomsg: "暂无数据"
  },
  SelectPostInfo: {
    title: "岗位选择",
    rownum: "序号",
    positionname: "岗位名称",
    positionno: "岗位编号",
    deptname: "所属部门",
    clear: "清空",
    query: "查询",
    placeholder: "输入关键字搜索",
    confirm: "确定",
    cancel: "取消",
    nomsg: "暂无数据",
    nullmsg: "请输入信息",
  },
  //员工入职
  staffentrybaseinfo: {
    baseTitle: "基本信息",
    midname: "中间名",
    fielphto: "证件照",
    delImage: "删除照片",
    famname: "姓",
    name: "名",
    gender: "性别",
    birthday: "出生日期",
    age: "年龄",
    insource: "进入公司来源",
    incomptime: "进入公司时间",
    marstatus: "婚姻状况",
    mobile: "手机号",
    phone: "座机号",
    openbank: "开户银行",
    remitbank: "汇款银行",
    bankcardnum: "银行卡号",
    payeeaddress:"收款人地址",
    accounttype:"帐户类型",

    height: "身高",
    religion: "宗教信仰",
    weight: "体重",
    language: "语言/方言",
    peraddr: "常住地址",
    peraddress: "地址",
    peraddrtype: "常住地址类型",
    curraddr: "当前地址",
    curraddress: "地址",
    curraddrtype: "当前地址类型",
    taxnum: "税务识别号",
    sssnum: "SSS号",
    pagibignum: "PAG-IBIG 号",
    phno: "PHILHEALTH 号",
    emercontact: "紧急联系人姓名",
    emerelation: "关系（紧急联系人）",
    emeraddr: "地址（紧急联系人）",
    emermobile: "手机号（紧急联系人）",
    emerphone: "座机号（紧急联系人）",
    prcnum: "PRC LICENSE NO",
    prcexpirydate: "有效期至(PRC LICENSE NO.)",

    technical: "特殊技能",
    mapfile: "附件",

    email: "工作邮箱",
    personalemail: "私人邮箱",
    nationality: "国籍",
    appellation: "称呼",
    suffix: "后缀",
    mailaddress: "邮件地址（紧急联系人）",
    emailaddress: "电子邮件地址（紧急联系人）",
    staffadmin: "人事管理员",

    delscuphotip: "删除照片成功",
    delfailrphotip: "删除照片失败",
    contracttip: "合同信息至少要有一条，请核查！",
    nameformat: "姓名格式",
    preferredname: "首选姓名",
    percountry: "国家",
    percity: "城市",
    pervillage: "村/社",
    perpostalcode: "邮政编码",
    passport:"护照",
    driverlince:"驾驶执照",
    voterid:"选民身份证",
    workpermit:"工作许可证",
    parttimejob:"兼职信息"
  },
  staffentryeduinfo: {
    entryeduinfo: "教育经历",
    indexMethod: "序号",
    edubegintime: "入学日期",
    eduendtime: "毕业日期",
    eduschooltype: "学校类别",
    edubackgrounp: "学历",

    edumajor: "课程/学位/专业",
    eduschool: "大学/学院/学校",
    eduawards: "奖励/荣誉",
  },
  staffentryfamilyinfo: {
    familyinfo: "家庭信息",
    indexMethod: "序号",
    fappellation: "称谓",

    fmemname: "家庭成员姓名",
    fbirth: "出生日期",
    foccupation: "职业",
  },
  staffentrytraininginfo: {
    traininginfo: "受训经历",
    indexMethod: "序号",

    trabegintime: "开始时间",
    traendtime: "结束时间",
    trattitle: "标题",
    tragrantor: "授予人",
  },
  staffentryofficialexaminfo: {
    officialexaminfo: "公务考试信息",
    indexMethod: "序号",

    examname: "公务考试",
    examdate: "应试日期",
    examgrade: "评级",
  },
  staffentrycommunityinfo: {
    communityinfo: "社团信息",
    indexMethod: "序号",

    communityname: "过去或现阶段工作单位或任何俱乐部/社团/商业/工会",
    communitypost: "岗位",
    communitybegintime: "开始时间",
    communityendtime: "结束时间",
  },
  staffentrylanginfo: {
    langinfo: "语言能力",
    indexMethod: "序号",
    languages: "语种",
    lanlevel: "掌握语种水平的级别",
    lanproficiency: "语种熟练度",
  },
  staffentrycontractinfo: {
    contractinfo: "合同信息",
    indexMethod: "序号",
    contbegintime: "开始日期",
    contendtime: "结束日期",
    contno: "合同号",
    conttype: "合同类型",
    contvalidate: "有效截止日期",
    contworkplace: "工作地点",
    contprobation: "试用期",
  },
  staffentrylist: {
    tab1: "员工入职单",
    tab2: "归档单据",
    billno: "单据编号",
    indexMethod: "序号",
    applydate: "申请日期",
    applydept: "申请部门",
    applyuser: "申请人",
    currstatus: "办理步骤",
  },
  interview:{
    tab1:"面试计划创建",
    tab2:"归档单据",
    tab3:"面试计划变更",
    tabtitle1:"面试计划创建",
    tabtitle2:"面试计划变更",
    documentno:"编号",
    candidatenames:"候选人",
    applyusername:"操作人",
    applydate:"操作日期",
    interviewdate:"面试日期",
    interviewaddr:"面试地址",
    positionid:"面试岗位",
    onlineinterviewaddr:"远程面试地址",
    interviewernames:"面试人",
    remark:"备注",
    ifsendoffer:"是否已发送offer",
    ifsendemail:"是否发送邮件",
    sendemailstatus:"邮件发送状态",
    btnmail:"发送邮件",
    btnexport:"导出",
    btnaction:"操作",
    btnchange:"变更",
    tabresult:"面试结果发起列表",
    resulttitle:"面试结果评分",
    resultname:"候选人",
    resultdept:"部门",
    resultpost:"岗位",
    resultpart1:"第一部分属性",
    resultpart2:"第二部分",
    resultpart3:"第三部分",
    recommendation:"建议",
    recommendationtype:"结果",
    departmentid:"部门",
    critical:"关键",
    description:"描述",
    rating:"得分",
    comments:"得分说明",
    resulttab1:"面试结果发起",
    resulttab2:"进一步面试",
    resulttab3:"进一步参考",
    resulttab4:"面试失败",
    resulttab5:"雇佣",
    btnresult1:"Add to “Failed-评估未通过” List",
    btnresult2:"Add to “Failed-候选人拒绝” List",
    btnresult3:"添加到“雇佣",
    btnresult4:"添加到“进一步面试”",
    btnresult5:"添加到“失败”列表",
    btnresult6:"发送通知电子邮件",
    btnresult7:"评估",
    choosedelbill:"请选择要进行操作的记录",
    msg:"确定进行此操作？",
    hisresult:"历史面试记录",
    resumestatus:"当前状态",
    evaluationstatus:"状态",
    evaluationtitle:"评估表单",
    education:"教育",
    school:"学校",
    mobile:"电话",
    email:"Email",
    position:"岗位",
    checkevaluation:"只能选择一条记录",
    choosesendbill:"请选择要发送的文件",
    evaluationname:"评估历史记录"
  },
  staffentryload: {
    staffentry: "人员入职",
  },
  staffentryresumeinfo: {
    resumeinfo: "履历记录",
    indexMethod: "序号",
    resumebegintime: "履历开始日期",
    resumeendtime: "履历结束日期",
    workposition: "岗位",

    workcompany: "公司",
    leavereason: "离职原因",
    salary: "薪水",
    superleader: "上级领导姓名",
    superleaderrelate: "关系（与上级领导）",
    superleaderpost: "职位（上级领导）",
    superleadercontact: "联系方式",
  },
  staffentryworkinfo: {
    workinfo: "工作信息",
    company: "公司",
    personscope: "人事范围",
    personno: "人员编码",
    persontype: "员工组",
    subpersontype: "员工子组",
    duty: "职务",
    deptid: "所在部门",
    position: "岗位名称",
    positionid:"岗位ID",
    positiongrade: "岗位等级",
    positionlevel: "岗位层级",
    positionseq: "岗位序列",
  },
  //员工借调
  secondedlist: {
    tab1: "员工借调单",
    tab2: "归档单据",
    billno: "单据编号",
    indexMethod: "序号",
    applydate: "申请日期",
    applydept: "申请部门",
    applyuser: "申请人",
    username: "人员姓名",
    usercode: "人员编码",
    postname: "岗位名称",
    deptname: "部门名称",
    dutyname: "职务名称",
    idcard: "身份证号",
    gender: "性别",
    secunit: "借调公司",
    checkintime: "报到日期",
    currstatus: "办理步骤",
    curruser: "当前办理人",
    secstarttime: "借调开始日期",
    secendtime: "借调结束日期",
    checkintime1: "报到日期",
  },
  secondedload: {
    title: "借调申请",
    billno: "单据编号",
    applyuser: "申请人",
    applydate: "申请日期",
    tabtitle: "借调信息",
    secbegintime: "借调开始时间",
    secendtime: "借调结束日期",
    staffunit: "借调员工所在单位",
    contact: "联系方式",
    checkintime: "报到日期",
    contactuser: "联系人",
    secresson: "借调原因"
  },
  secondedbaseinfo: {
    baseTitle: "基本信息",
    fullname: "全名",
    midname: "中间名",
    fielphto: "证件照",
    delImage: "删除照片",
    famname: "姓",
    name: "名",
    idcard: "身份证号",
    gender: "性别",
    birthday: "出生日期",
    age: "年龄",
    birthplace: "出生地",
    nationality: "国籍",
    insource: "进入公司来源",
    worktime: "参加工作时间",
    incomptime: "进入公司时间",
    health: "健康状况",
    marstatus: "婚姻状况",
    email: "电子邮件",
    familyaddr: "家庭地址",
    mobile: "移动电话",
    phone: "固定电话",
    workage: "工龄",
    compworkage: "本企业工龄",
    emercontacttele: "紧急联系人电话",
    emercontactuser: "紧急联系人姓名",
    openbank: "开户行",
    remitbank: "汇款银行",
    bankcardnum: "银行卡号",
  },
  secondedworkinfo: {
    workinfo: "工作信息",
    company: "公司",
    personscope: "人事范围",
    subpersonscope: "人事子范围",
    salaryscope: "工资核算范围",
    workplan: "排班计划",
    costcenter: "成本中心",
    personno: "人员编码",
    persontype: "员工组",
    subpersontype: "人员子类别",
    duty: "职务",
    deptid: "所在部门",
    position: "岗位名称",
    positiongrade: "岗位等级",
    positionlevel: "岗位层级",
    positionseq: "岗位序列",
  },
  //人员档案查询
  filemanage: {
    username: "人员姓名",
    usercode: "人员编码",
    postname: "岗位名称",
    deptname: "部门名称",
    dutyname: "职务名称",
    idcard: "身份证号",
    gender: "性别",
    filemanageload: "人员档案",
    emptype: "员工类型"
  },
  //人员维护信息
  staffmaintain: {
    tab1: "员工信息维护单",
    tab2: "归档单据",
    username: "人员姓名",
    usercode: "人员编码",
    postname: "岗位名称",
    deptname: "部门名称",
    dutyname: "职务名称",
    idcard: "身份证号",
    gender: "性别",
    currstatus: "办理步骤",
    curruser: "当前办理人",
    transfer: "任免信息",
    begintime: "开始日期",
    endtime: "结束日期",
    postgrade: "岗位等级",
    postlevel: "岗位层级",
    postseq: "岗位序列",
    reson: "任职原因",
    remark: "备注",
    dept: "部门",
    post: "岗位",
    traninginfo: "专业培训记录",
    trattitle: "培训活动名称",
    trabegintime: "培训开始时间",
    traendtime: "培训结束时间",
    tratype: "培训类别",
    traway: "培训方式",
    tratarget: "培训目标",
    tracontent: "培训内容",
    learnresult: "学习层评估成绩",
    behaviorresult: "行为层评估成绩",
    hostunit: "主办单位",
    trahours: "培训学时",
    awarddate: "获奖日期",
    tracertiname: "培训证书名称",
    travalidity: "有效期",
    certilevel: "证书等级",
    tracertino: "培训证书编号",
    traaddr: "培训地点",
    traremark: "备注",
    trialinfo: "试用情况",
    tritype: "试用类型",
    tribegintime: "开始日期",
    triendtime: "结束日期",
    tritime: "转正日期",
    triresult: "试用结果",
    tribillend: "是否结束",
    triremark: "备注",
    savetip: "请先选择维护人员后再保存",
    selectusertip: "您存在在途的维护单据，请核查",
    selectuser: "选择人员",
    staffmaintainload: "人员信息维护",
  },
  //员工调动
  transferlist: {
    indexMethod: "序号",

    tranferusername: "人员姓名",
    tranferuserid: "人员编码",
    positionname: "岗位名称",
    transferdeptname: "部门名称",
    dutyname: "职务名称",
    idcard: "身份证号",
    sex: "性别",
    effectivetime: "调动生效时间",
    effectivetime1: "调动生效时间",
    curruserid: "当前审批人",

    tab1: "员工调动单",
    tab2: "归档单据"
  },
  transferload: {
    save: "保存",
    inputPlaceholder: "请输入",
    selectedPlaceholder: "请选择",

    transferload: "调动申请",
    personInfo: "人员信息",
    preInfo: "调动前信息",
    aftInfo: "调动后信息",

    billno: "单据编号",
    applyuserid: "申请人",
    applydate: "申请日期",

    tranferuserid: "调动人员",
    tranferusercode: "调动人员编码",
    tranferreason: "调动原因",
    effectivetime: "调动生效日期",
    tranferremark: "调动说明",

    precompanyid: "公司",
    predeptid: "部门",
    preusertype: "员工组",
    prepdeptid: "上级组织",
    preposition: "岗位",
    prepositionseq: "岗位序列",
    prepositonleavel: "岗位层级",
    prepositiongrade: "岗位等级",
    prepersonscope: "人事范围",
    presubpersontype: "员工子组",
    prestaffadmin: "人事管理员",

    companyid: "公司",
    deptid: "部门",
    usertype: "员工组",
    position: "岗位",
    pdeptid: "上级组织",
    positionseq: "岗位序列",
    positionlevel: "岗位层级",
    positiongrade: "岗位等级",
    workreason: "任职原因",
    isprobation: "是否试用",
    probbegintime: "试用开始时间",
    probendtime: "试用结束时间",
    remark: "备注",
    personscope: "人事范围",
    subpersontype: "员工子组",
    staffadmin: "人事管理员",

    isTransferring: "该人员正在调动",
  },
  //员工转正
  regularlist: {
    indexMethod: "序号",

    regularusername: "人员姓名",
    regularuserid: "人员编码",
    positionname: "岗位名称",
    regulardeptname: "部门名称",
    dutyname: "职务名称",
    idcard: "身份证号",
    sex: "性别",
    regulartime: "转正时间",

    curruserid: "当前审批人",

    tab1: "员工转正单",
    tab2: "归档单据"
  },
  regularload: {
    save: "保存",
    inputPlaceholder: "请输入",
    selectedPlaceholder: "请选择",

    regularload: "转正申请",
    personInfo: "人员信息",
    preInfo: "员工信息",
    aftInfo: "转正后信息",

    billno: "单据编号",
    applyuserid: "申请人",
    applydate: "申请日期",

    regularuserid: "转正人",
    trialtype: "试用类型",
    trialbegintime: "试用开始时间",
    trialendtime: "试用结束时间",
    trialresult: "试用结果",
    extregulartime: "延期转正时间",
    remark: "说明",

    precompanyid: "公司",
    predeptid: "部门",
    preusertype: "员工组",
    preuserduty: "职务",
    prepdeptid: "上级组织",
    prepositionseq: "岗位序列",
    preposition: "岗位",
    prepositonleavel: "岗位层级",
    prepositiongrade: "岗位等级",
    prepersonscope: "人事范围",
    presubpersontype: "员工子组",
    prestaffadmin: "人事管理员",

    companyid: "公司",
    deptid: "部门",
    usertype: "员工组",
    userduty: "职务",
    pdeptid: "上级组织",
    positionseq: "岗位序列",
    position: "岗位",
    positionlevel: "岗位层级",
    positiongrade: "岗位等级",
    salaryadvice: "定薪建议",
    personscope: "人事范围",
    subpersontype: "员工子组",
    staffadmin: "人事管理员",

    isRegulating: "该人员正在转正",
    isNotTrial: "该人员未被试用",
    hasRegular: "该人员已转正",
    hasStopContract: "该人员已终止合同",
  },
  //员工离职
  resignlist: {
    indexMethod: "序号",

    resignusername: "人员姓名",
    resignuserid: "人员编码",
    positionname: "岗位名称",
    resigndeptname: "部门名称",
    dutyname: "职务名称",
    resigntype: "离职类型",
    idcard: "身份证号",
    sex: "性别",
    effectivetime: "离职生效日期",
    effectivetime1: "离职生效日期",
    curruserid: "当前审批人",

    tab1: "员工离职单",
    tab2: "归档单据"
  },
  resignload: {
    save: "保存",
    resignapply: "离职申请",
    billno: "单据编号",
    applyuserid: "申请人",
    applydate: "申请日期",
    resigninfo: "离职信息",
    resignuserid: "离职人员",
    resigncompany: "公司",
    resigndeptid: "部门",
    resignpdeptid: "上级组织",
    preusertype: "离职前员工组",
    aftusertype: "离职后员工组",
    resigntype: "离职业务类型",
    effectivetime: "离职生效日期",
    proresigntime: "提出离职时间",
    remark: "备注",
    inputPlaceholder: "请输入",
    selectedPlaceholder: "请选择",

    isResigning: "该人员正在离职",
  },
  parttimejob:{
    tab1:"员工兼职",
    tab2: "归档单据",
    applydate:"申请日期",
    empname: "人员名称",
    formname:"兼职信息",
    checktip:"请先选择人员后再保存.",
    stafftip:"该员工存在在途维护单据，请核查."
  },
  //人员入职
  //人员入职
  onboardinglist: {
    newnotice: "新员工入职通知",

    famname: "姓",
    midname: "中间名",
    name: "名",
    email: "电子邮件",
    ifrejected: "状态",
    reject: "拒绝录取",
    askreject: "是否拒绝录取？",

    personname: "人员姓名",
    personno: "人员编码",
    positionname: "岗位名称",
    deptid: "部门",
    dutyname: "职务",
    gender: "性别",

    curruserid: "当前审批人",

    tab1: "新员工入职通知",
    tab2: "入职管理",
    tab3: "归档单据"
  },
  onboardingemailload: {
    baseTitle: "试用评估通知",
    baseTitle1: "新员工入职通知",
    send: "发送",
    email: "电子邮件",
    famname: "姓",
    midname: "中间名",
    name: "名",
    checknotice:"请确认是否要发送邮件",
    checknotice1:"该人员已发送过邮件了，是否再次发送",
    copypersonaddr: "生成外网地址",
    title: "标题",
    toptitle:"DITO电信公司通知",
  },
  onboardingload: {
    baseTitle: "人员入职",
    ifsubmit: "是否提交？提交后无法再次编辑！"
  },
  //试用期评估
  evaluationlist: {
    emailnotice: "邮件通知",
    evaluationlaunch: "新员工入职评估发起",

    famname: "姓",
    midname: "中间名",
    name: "名",
    email: "电子邮件",
    personnelcode: "人员编码",

    billno: "单据编号",
    applydate: "申请日期",
    personno: "被评估人姓名",
    deptid: "被评估人所在部门",
    examresults: "入职考试结果",
    evaresults: "评估结果",

    curruserid: "当前审批人",
    postid: "岗位",
    tab1: "邮件通知",
    tab2: "试用评估",
    tab3: "归档单据",
  },
  evaluationemailload: {
    send: "发送",
    person: "人员",

    title: "标题",
  },
  evaluationload: {
    evaluationapply: "新员工入职评估",

    billno: "单据编号",
    applyuserid: "申请人",
    applydate: "申请日期",
    personno: "被评估人",
    deptid: "部门",
    examresults: "入职考试结果",
    evaresults: "评估结果",
    incomdata: "进入公司时间",
    posttitle: "员工所在岗位",
    reviewdata: "评估时间",
    reviewtype: "试用期",

    traininfo: "入职培训信息",
    trabegintime: "开始时间",
    traendtime: "结束时间",
    trainitem: "培训事项",
    trainperson: "培训人员",
    trainresult: "培训结果",
    trainidea: "培训意见",

    hridea: "人力专员评估意见",
    leadidea: "所属部门领导评估意见",

    isEvaluating: "该人员正在评估",
    extperiod: "延长试用期",
    reason: "原因",
    performance: "考核指标",
    rating: "考核结果",
    remark: "备注",
    sign: "领导意见",
    sign1: "Comment From Employee's Direct Manager",
    sign2: "Comment From HR Business Partner",
  },
  //绩效评估
  personalperfevalist: {
    tab1: "绩效评估表",
    tab2: "已归档",
    assessee: "被评估人",
    examinuserid: "被考评人",
    examindeptid: "被考评人部门",
    personalperfeva: "个人绩效评估表",
    scoreinformation: "评分信息",
    score: "评分",
    highscore:"评分不能超过100",
    nullscore:"评分不能为空",
  },
  resumepool:{
    applicationformid:"表单ID",
    appliedpositon:"申请岗位",
    sourcevacancy:"来源",
    highestedu:"最高学历",
    school:"学校",
    phonenum:"电话号码",
    changeposition:"更改岗位信息",
    addcandi:"加入候选人资格",
    discandi:"取消候选人资格",
    addtalen:"添加至人才库",
    addcandimsg:"确定加入候选人资格?",
    discandimsg:"确定取消候选人资格?",
    addtalenmsg:"确定添加至人才库?",
    choosebill:"请选择简历.",
    currposition:"当前岗位",
    afterposition:"变更后的岗位",
    selectposition:"请选择岗位信息",
    savemsg:"确定保存单据吗?",
    emailsend:"发送邮件状态",
    emailsendque:"是否发送邮件",
    status:"状态",

},
talentpool:{
  tab1:"人才库",
  tab2:"人才筛选库",
  addqua:"加入候选人资格",
  sendmail:"发送不合格提醒邮件",
  upload:"通过模板上传人员",
  addscree:"加入人才库筛选列表",
  addscreemsg:"确定加入人才库筛选列表?",
  addquamsg:"确定加入候选人列表?",
},
candidatelist:{
  tab1:"合格候选人列表",
  tab2:"不合格候选人列表",
  disqua:"取消候选人资格, 加入不合格候选人列表",
  movpool:"移回简历库",
  addqua:"赋予候选人资格, 加入合格候选人列表",
  sendemail:"赋予候选人资格, 加入合格候选人列表",
  movpoolmsg:"确定移入到简历库?",
  disquamsg:"确定取消候选人资格?"
},
  //绩效管理
  performancelist: {
    periodtype: "周期类型",
    years: "年份",
    year: "年度",
    semiannual: "半年度",
    quarter: "季度",
    monthly: "月度",
    deptid: "部门",
    applyusername: "发起人",
    billno: "单据号",
    currentapprovalprocess: "当前审批环节",
    currentapproveusername: "当前审批人",
    allType: "年度/半年度/季度/月度",
    tab1: "绩效模板创建单",
    tab2: "已归档",
    selectDepartemtFirst: "请先选择部门",
  },

  performanceload: {
    inputPlaceholder: "请输入",
    performancescoretemplate: "绩效评分模板",
    periodtype: "周期类型",
    years: "年份",
    fourselect: "月度/季度/半年度/年度",
    applydate: "发起日期",
    billno: "单据编号",
    applyusername: "发起人",
    deptid: "部门",
    information: "指标信息",
    indexMethod: "序号",
    metrics: "衡量指标",
    explanation: "指标解释",
    goal: "目标值(百分制)",
    weights: "权重",
    assessment: "员工考核配置",
    employee: "员工",
    employeeno: "员工编号",
    position: "职位",
    rater: "选择评分人(批量)",
    markScore: "分数(百分比)",
    month: "月度",
    quarter: "季度",
    semiAnnual: "半年度",
    AllYear: "年度",
    periodTypeAndYearsIsNotNull: "周期类型和年份不能为空!",
    targetExceed: "指标值不能超过100",
    weightExceed: "权重总和不等于100",
    scoresum:"评分人所占比例之和必须等于100%",
    weightsum:"评分权重之和必须等于100",
    targetnull:"目标值不能为空",
    weightnull:"指标信息的权重不能为空",
  },
  //绩效评估确认
  perfassessconfirm: {
    tab1: "评估表待确认",
    tab2: "评估确认",
    tab3: "归档单据",
    tableInvalid: "作废",
    invalidSuccess: "单据已作废",
    invalidFailure: "单据操作失败",
    operation: "操作",
    billSave: "保存",
    yetBillSave: "已保存",
    saveSuccess: "保存成功",
    saveFailure: "保存失败",
  },
  perfratingconfirm: {
    tab1: "评分确认单",
    tab2: "已归档",
    byEvaluation: "被考评人",
    byEvaluationDepartment: "被考评人部门",
    scoreResult: "评分结果",
    modifiedResult: "修改后结果",
    grade: "等级",
    leadershipOpinion: "领导意见",
    assessee: "被评估人",
    ratingConfirm: "评分确认",
  },
    //招聘计划
    recruitplanlist:{
      tab1: "招聘计划",
      tab2: "归档单据",
      profession:"专业",
      postname:"岗位名称",
      deptname:"部门",
      recruitheadcount:"招聘人数",
      scheduledjoindate:"计划入职时间",
      careerlevel:"职业水平",
      joblocation:"工作地点",
      yearofexperience:"工作年限",
      educationlevel:"教育水平",
      jobtype:"工作性质",
      applicant:"申请人"
    },
    recruitplanload:{
      title:"职位明细",
      applydate:"申请日期",
      postname:"岗位名称",
      deptname:"部门",
      recruitheadcount:"招聘人数",
      scheduledjoindate:"计划入职时间",
      careerlevel:"职业水平",
      joblocation:"工作地点",
      yearofexperience:"工作年限",
      educationlevel:"教育水平",
      jobtype:"工作性质",
      profession:"专业",
      jobsummary:"工作总结",
      jobdescription:"工作描述",
      selectsamepost:"请选择名称相同的岗位",
      selectsamedept:"请在同一个部门下选择岗位"
    },
    recruitpostlist:{
        publicationstatus:"发布状态"
    },
    recruitpostload:{
      title:"岗位信息",
      relestatus:"发布信息到招聘门户"
    },
  // 招聘管理
  recruitposition: {
    positionCreation: "新增职位",
    basicInformation: "基本信息",
    documentNumber: "文档编号",
    applicant: "申请人",
    applicationDate: "申请日期",
    company: "公司",
    department: "部门",
    positionCode: "职位编码",
    positionName: "职位名称",
    jobTitle: "职称",
    positionSequence: "职位序列",
    positionNameAbbreviation: "职位简称",
    recruitHeadcount: "招聘人数",
    positionDescription: "职位描述",
    tab1: "招聘职位创建单",
    tab2: "归档单据"
  },
  //简历管理
  resume: {
    invalidAll: "全部失效",
    clearAllInvalidItems: "清除失效模板",
    appliedPosition: "申请职位",
    applicationFormId: "申请表ID",
    handler: "处理者",
    handlingDate: "处理日期",
    status: "状态",
    copyLink: "复制申请表链接",
    invalid: "失效",
    personalInformation: "个人信息",
    lastName: "姓",
    FirstName: "名",
    middleName: "中间名",
    suffix: "后缀",
    emailAddress: "邮箱地址",
    permanentAddress: "常住地址",
    mobileNumber: "手机号码",
    landlineNumber: "座机号码",
    dateOfBirth: "出生日期",
    emailVerficationCode: "邮箱验证码",
    tab1: "简历模板",
    tab2: "归档单据",
    //load page
    billno: "单据编号",
    createDate: "创建日期",
    department: "部门",
    applicationForm: "申请表",
    applicationId: "应用ID",
    desiredPosition: "期望职位",
    positionDetails: "职位详情",
    jobBoards: "招聘网站",
    campusRoadshow: "校园路演",
    onlineApplication: "网上申请",
    jobFair: "招聘会",
    referralEmployee: "员工推荐",
    jobPosterTarpaulins: "工作海报",
    referralOthers: "其他推荐",
    aboutConpany: "你是怎么知道贵公司的?在框中打勾，然后进一步说明",
    //essay
    essay: "随笔",
    whyDITO: "你为什么加入DITO?",
    placeWrite: "请写一篇简短的文章，解释为什么你应该被考虑申请你所申请的职位",
    //declaration
    declaration: "声明",
    yes: "是",
    no: "否",
    immigrant: "您是否有任何移民或工作签证需要在国外重新定居的申请?",
    applyFor: "你曾经申请过DITO电信公式和它的附属公司吗?",
    subsidiaryCompany: "你是否与DITO电信公司及其附属公司目前或以前的雇员有关系或认识?",
    overtime: "你愿意加班吗?",
    needOvertime: "如果需要的话，你愿意加班吗?",
    NonCompeteClause: "你是否与你现在/以前的公司签署了竞业禁止条款?",
    complaint: "您目前是否参与一宗涉及前雇主/现任雇主的待定案件或书面投诉，是否为呈请人或答辩人?",
    settleALawsuit: "您是否曾作为呈请人或答辩人参与涉及前雇主或现任雇主的已结案?",
    guilt: "你是否曾被起诉或被判有罪?",
    seriousDisease: "您曾经住院或做过手术/有过重病吗?",
    indexMethod: "序号",
    schoolOfGraduation: "毕业学校",
    education: "学历",
    courseDegree: "课程/学位",
    universitySchoolName: "大学/学校名称",
    awardsHonors: "奖项或荣誉",
    durationFrom: "时间(月/年)",
    currentlyEnrolled: "请查询是否已报名",
    workExperience: "工作经验",
    company: "公司(从最近开始)",
    position: "职位",
    durationOfEmployment: "就业时间",
    reasonForLeaving: "离职原因",
    salary: "工资(月)",
    governmentExamsTaken: "政治测试获取",
    dateTaken: "获取时间",
    ratingRank: "排名/评级",
    clubLabor: "过去或现在的附属机构或任何协会/工会/行业",
    date: "日期"
  },
  commonlist: {
    msg: "确定删除单据吗?",
    tiptitle: "提示",
    confirm: "确定",
    cancel: "取消",
    cancelmsg: "已取消操作",
    choosedelbill: "请选择要删除的单据",
    chooseapplydept: "请选择申请部门",
    choosecycandyear: "请选择周期类型和年份"
  },
  givedemand: {
    title: "赠送需求申请单",
    baseinfoTab: "基本信息",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    givesource: "赠送来源",
    invoiceno: "发票",
    taxrate: "综合税率",
    manuno: "供应商编码",
    manuname: "供应商名称",
    remark: "备注（200个汉字以内）",
    fileup: "上传附件",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    price: "单价（元）",
    applynum: "数量",
    recsum: "公允值/金额",
    notes: "备注（200个汉字以内）",
    backusername: "需求退回人",
    backnum: "退回数量",
    backreason: "退回原因",
    billno2: "单据编码",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "备注",
    currency: "交易币种"
  },
  bkdemand: {
    title: "备库需求单",
    baseinfoTab: "基本信息",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    remark: "采购原因/采购明细描述",
    fileup: "上传附件",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    price: "预估单价",
    applynum: "申请数量",
    recsum: "预计金额",
    notes: "备注",
    backusername: "退回人员",
    backnum: "退回数量",
    backreason: "退回原因",
    billno2: "单据编码",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    startdate: "开始日期",
    enddate: "结束日期",
    receiveaddress: "收货地址",
    receivecontacts: "收货联系人",
    receivecontactphone: "收货联系电话",
    chplanuserid_in: "账务管理员",
    stockamount: "预计采购金额",
    currtype: "本位币",
    store_out: "仓库",
    stockuserid: "采购管理员",
    costcenter: "成本中心"
  },
  impEsn: {
    title: "导入串码",
    imp4excel: "Excel文件导入",
    imp4txt: "TXT文件导入",
    imp4write: "扫描或手工录入",
    impTemplate: "导入excel模板",
    clickDownload: "点击此处下载excel模板",
    excelFileImp: "Excel文件导入",
    browse: "浏览",
    import: "导入",
    isOverwriteImp: "是否覆盖导入",
    over: "覆盖",
    append: "追加",
    reqfileTips: "请点击浏览，选择导入文件!",
    esn: "串码",
    imperrormsg: "导入状态",
    close: "关闭",
    save: "保存",
    errormsg: "错误提醒",
    saveEsnSuccedTips: "串码已经保存。如需重新保存,请先选择要导入的数据!",
    saveEsnSuccTips: "保存串码成功!",
    impingTips: "正在导入中,请稍后再进行导入操作!",
    impErrorMsg1: "导入结果中第",
    impErrorMsg2: "行有错误,请将导入结果的错误行处理完后再保存!",
    deleteEsnConfig: "确定要删除吗？",
    txtFileImp: "TXT文件导入",
    reqfileTips2: "请点击浏览，选择导入文件或手工录入串码数据!",
    esntext: "串码(按回车键分割,一行录入一个串码)",
    reqesntextTips: "请先输入串码!"
  },
  selectstorematerial: {
    title: "选择库存物资",
    storedate: "入库时间",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    chunit: "单位",
    storenum: "库存数量",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    orderno: "订单号",
    serialno: "批次",
    price: "批次价格",
    proj: "子项目",
    chstore: "仓库",
    degree: "库存属性",
    sobkz: "库存类型",
    manuno: "供应商",
    projcode: "子项目编码",
    chstoreuser: "实物管理员",
    recbillremark: "备注",
    applynum: "申请数量",
    confirm: "确定",
    reqstorematerialTips: "请选择库存物资!",
    reqapplynumTips: "请输入申请数量!",
    checkapplynumTips1: "第",
    checkapplynumTips2: "行的申请数量不能大于可用库存数量!",
    reqstoreTips: "请选择仓库!",
    chcurrency: "交易币种",
    checkapplynumTips3: "行的可用库存数量为0，无法选择!"
  },
  discarddemand: {
    title: "报废需求申请单",
    baseinfoTab: "基本信息",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    chstore_out: "仓库",
    remark: "报废原因",
    fileup: "上传附件",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    price: "单价",
    currency: "交易币种",
    applynum: "报废数量",
    recsum: "金额合计",
    degree: "库存属性",
    serialno: "库存批次",
    billno2: "单据编码",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "报废原因",
    ifabnormallosses: "是否非正常损失",
    projcode: "子项目编码",
    projname: "子项目名称",
    checkapplynumtip: "行项报废数量不能大于可用库存数量！",
    costcenter: "成本中心"
  },
  materialmove: {
    title: "移库办理单",
    baseinfoTab: "基本信息",
    tomaterialmoveTab: "待开单",
    materialmoveTab: "移库需求正式单",
    choosedemand: "请选择移库需求",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    planusername: "账务管理员",
    storeid: "移出仓库",
    storeuserid: "移出库实物管理员",
    storeid_in: "移入仓库",
    storeuserid_in: "移入库实物管理员",
    logistics_cost_borne: "物流费用承担方",
    expected_logistics_recsum: "预计物流费金额",
    sourcetype: "需求来源",
    remark: "备注",
    demandlistinfo: "需求清单",
    orgdemandbillno: "移库需求单号",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    price: "单价",
    currency: "交易币种",
    donenum: "已开单数量",
    applynum: "申请数量",
    recsum: "金额",
    notes: "备注",
    listinfo: "本次移出清单",
    storenum_que: "可用库存数量",
    onlinenum: "在途占用数量",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum2: "金额",
    serialno: "库存批次",
    notes2: "备注",
    orimanuname: "原厂商",
    manuname: "供应商",
    orimanuspec: "原厂商产品型号",
    degree: "库存属性",
    demandbillno: "需求单据编码",
    applyusername: "申请人",
    createtime: "申请日期",
    receivedate: "到达任务池时间",
    calltypename: "调拨类型",
    movetypename: "发起方",
    startdate: "开始日期",
    enddate: "结束日期",
    recbillno: "正式单据编码",
    checknumtip: "行项实际数量不能大于开单数量!",
    emptyrowlist: "本次移出清单不能为空!",
    checkplannumtip: "行项开单数量不能大于可用库存数量！",
    checkdemandnumtip: "本次开单数量+已办理数量不能大于需求申请数量!",
    orgdemandbillno2: "申请单号"
  },
  materialmovein: {
    title: "移库入库单",
    baseinfoTab: "基本信息",
    tomaterialmoveTab: "待确认移出单",
    materialmoveTab: "移入单",
    chooseRecbill: "请选择移出单",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    storeid_in: "移入仓库",
    planuserid: "移入库账务管理员",
    storeuserid_in: "移入库实物管理员",
    storeid: "移出仓库",
    logistics_cost_borne: "物流费用承担方",
    expected_logistics_recsum: "预计物流费金额",
    sourcetype: "需求来源",
    remark: "备注",
    listinfo: "本次移入清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    price: "单价",
    currency: "交易币种",
    applynum: "移出数量",
    donenum: "已开单数量",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum2: "金额",
    degree: "库存属性",
    notes2: "备注",
    orimanuname: "原厂商",
    manuname: "供应商",
    orimanuspec: "原厂商产品型号",
    orgdemandbillno: "调出单号",
    serialno: "库存批次",
    orgrecbillno: "移出单据号",
    planusername: "开单人",
    receivedate: "到达任务池时间",
    startdate: "开始日期",
    enddate: "结束日期",
    recbillno: "正式单据编码",
    checknumtip: "行项实际数量不能大于开单数量!",
    orgrecbillno2: "移出单号",
    orgdemandbillno2: "申请单号"
  },
  transferdemand: {
    title: "转用需求申请单",
    baseinfoTab: "基本信息",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    transfertype: "转用类型",
    chstore_out: "转出仓库",
    projcode: "子项目编码",
    projname: "子项目名称",
    projcode2: "转出子项目编码",
    projname2: "转出子项目名称",
    remark: "备注",
    fileup: "上传附件",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    price: "单价",
    currency: "交易币种",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    applynum: "申请数量",
    recsum: "金额",
    degree: "库存属性",
    serialno: "库存批次",
    notes: "备注",
    billno2: "单据编码",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "备注",
    reqtransfertypeTips: "请选择转用类型"
  },
  materialtransfer: {
    title: "转用单",
    baseinfoTab: "基本信息",
    tomaterialtransferTab: "待开单",
    materialtransferTab: "转用需求正式单",
    choosedemand: "请选择转用需求",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    transfertype: "转用类型",
    applyusername: "申请人",
    applydeptname: "申请部门",
    createtime: "申请日期",
    storeid: "转出仓库",
    planusername: "转出账务管理员",
    storeuserid: "转出库实物管理员",
    remark: "备注",
    listinfo: "本次转用清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unitid: "计量单位",
    projcode: "子项目编码",
    projname: "子项目名称",
    price: "单价",
    applynum: "申请数量",
    donenum: "已开单数量",
    storenum_que: "可用库存数量",
    onlinenum: "在途占用数量",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum2: "金额",
    degree: "库存属性",
    notes2: "备注",
    serialno: "库存批次",
    demandbillno: "需求单据编码",
    receivedate: "到达任务池时间",
    startdate: "开始日期",
    enddate: "结束日期",
    recbillno: "正式单据编码",
    checknumtip: "行项实际数量不能大于开单数量!",
    plannumMaxTips: "行项开单数量不能大于可转用数量!",
    orgdemandbillno2: "申请单号"
  },
  handindemand: {
    title: "余料退库需求单",
    baseinfoTab: "基本信息",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    sourcetype: "需求来源",
    handintype: "退库类型",
    ifstoremanage: "是否实物库管理",
    store_out: "缴料仓库",
    remark: "备注",
    fileup: "上传附件",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    currency: "交易币种",
    applynum: "申退数量",
    recsum: "申退金额",
    projcode: "子项目编码",
    projname: "子项目名称",
    linkaddress: "收货地址",
    linkuser: "收货联系人",
    linktel: "收货联系电话",
    jh_linkaddress: "交货地址",
    jh_linkuser: "交货联系人",
    jh_linktel: "交货联系电话",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商产品规格型号",
    orimanudrip: "原厂商产品描述",
    notes: "备注",
    costcenter: "成本中心",
    handintransferflag: "是否缴回通用库",
    orgbillno: "原领料单号",
    storenum: "已领数量",
    handinnum: "可退数量",
    degree: "库存属性",
    serialno: "库存批次",
    billno2: "单据编码",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "备注",
    demandtype: "需求类型",
    reqdemandtypeTips: "请选择需求类型",
    reqhandintypeTips: "请选择退库类型",
    chouttype2: "用途类别"
  },
  selectgetbill: {
    title: "选择领料单",
    billno: "领料单号",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    chunit: "单位",
    projname: "子项目名称",
    chcostcenter: "成本中心",
    price: "单价",
    chstore: "仓库",
    serialno: "批次号",
    storedate: "批次入库时间",
    notes: "行项备注",
    storenum: "已领数量",
    handinnum: "可缴数量",
    confirm: "确定",
    projcode: "子项目编码",
    applynum: "申请数量",
    reqgetbillTips: "请选择领料单!",
    reqapplynumTips: "请输入申请数量!",
    checkapplynumTips1: "第",
    checkapplynumTips2: "行的申请数量不能大于可缴数量!",
    chcurrency: "交易币种",
    checkapplynumTips3: "行的可缴数量为0，无法选择!",
    reqcostcenterTips: "请填写领料单号或成本中心查询条件，再点击查询按钮!",
    reqprojcodeTips: "请填写领料单号或子项目编码查询条件，再点击查询按钮!",
    checkapplynumtip: "行项申请数量不能大于可退数量!",
    pleaseclickseach: "请点击查询按钮!"
  },
  materialhandin: {
    title: "余料退库单",
    baseinfoTab: "基本信息",
    tomaterialmoveTab: "待开单",
    materialmoveTab: "余料退库单",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    sourcetype: "需求来源",
    storeid: "仓库",
    planuserid: "账务管理员",
    storeuserid: "实物管理员",
    remark: "备注",
    listinfo: "本次退库清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    currency: "交易币种",
    applynum: "申缴数量",
    donenum: "已开单数量",
    plannum: "开单数量",
    storenum: "实缴数量",
    recsum2: "缴料金额",
    degree: "库存属性",
    notes2: "备注",
    orgdemandbillno: "需求单号",
    orgbillno: "原领料单号",
    projcode: "子项目编码",
    projname: "子项目名称",
    costcenter: "成本中心",
    demandbillno: "需求单据编码",
    applyusername: "申请人",
    createtime: "申请日期",
    demandtype: "需求类型",
    receivedate: "到达任务池时间",
    startdate: "开始日期",
    enddate: "结束日期",
    handintype: "退库类型",
    chstore: "仓库",
    chsourcetype: "需求来源",
    projcode2: "子项目编码/成本中心",
    handintransferflag: "是否缴回通用库",
    recbillno: "正式单据编码",
    checknumtip: "行项实缴数量不能大于开单数量!",
    choosedemand: "请选择余料退库需求!",
    samecompanycodeTips: "请选择相同的公司代码!",
    samedemandtypeTips: "请选择相同的需求类型!",
    samehandintypeTips: "请选择相同的退库类型!",
    samecompanyflagTips: "请选择相同的公司类型!",
    samestoreidTips: "请选择相同的仓库!",
    samesourcetypeTips: "请选择相同的需求来源!",
    sameprojcodeTips: "请选择相同的子项目编码/成本中心!",
    samehandintransferflagTips: "请选择相同的是否缴回通用库!",
    orgdemandbillno2: "申请单号",
    projcode_out: "子项目编码",
    chouttype2: "用途类别"
  },
  materialdiscard: {
    title: "报废单",
    baseinfoTab: "基本信息",
    tomaterialdiscardTab: "待开单",
    materialdiscardTab: "报废单",
    choosedemand: "请选择报废需求",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    applyusername: "申请人",
    applydeptname: "申请部门",
    createtime: "申请日期",
    storeid: "仓库",
    planusername: "账务管理员",
    storeuserid: "实物管理员",
    remark: "报废原因",
    listinfo: "本次报废清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    ifabnormallosses: "是否非正常损失",
    costcenter: "成本中心",
    price: "单价",
    applynum: "报废数量",
    donenum: "已开单数量",
    storenum_que: "可用库存数量",
    onlinenum: "在途占用数量",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum2: "金额合计",
    degree: "库存属性",
    notes2: "备注",
    demandbillno: "需求单据编码",
    receivedate: "到达任务池时间",
    startdate: "开始日期",
    enddate: "结束日期",
    recbillno: "正式单据编码",
    checknumtip: "行项实际数量不能大于开单数量!",
    orgdemandbillno2: "申请单号"
  },
  materialdemandclose: {
    demandReturn: "需求退回",
    choosedemand: "请选择需要退回的需求",
    reqrendertype: "请配置需求退回的业务类型",
    submitbtn: "提交",
    backreason: "退回原因",
    billno: "单据编码",
    applydate: "申请日期",
    applyusername: "申请人",
    chcompanycode: "公司代码",
    projcodeout: "子项目编码/成本中心",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "计量单位",
    price: "单价",
    applynum: "申请数量",
    donenum: "已处理数量",
    canbacknum: "可退回数量",
    reqbackdemandrow: "退回需求列表不能为空",
    checkcanbacknumTips1: "第",
    checkcanbacknumTips2: "行的可退回数量为0，无法退回!"
  },
  demandbacklist: {
    demandbacklistTab: "退回需求清单",
    choosebackdemand: "请选择退回需求",
    reqrendertype: "请配置业务类型",
    billno: "单据编码",
    title: "单据标题",
    createtime: "申请日期",
    applyusername: "申请人",
    chcompanycode: "公司代码",
    chdemandtype: "需求类型",
    sumfee: "合计金额",
    showdetail: "查看明细",
    applydate: "申请日期",
    projcodeout: "子项目编码/成本中心",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    chunit: "计量单位",
    price: "单价",
    applynum: "申请数量",
    donenum: "已处理数量",
    backnum: "退回数量",
    backreason: "退回原因",
    deletebtn: "作废",
    reqbillrowidTips: "请选择需要作废的记录",
    deletemsg: "确定作废所选退回物资吗?",
    deletemsg2: "确定作废所选退回需求吗?",
    dellist: "已作废清单",
    endlist: "已归档",
    chbackuser: "删除人",
    recreatebtn: "重新提交",
    choosebackdemand2: "请选择需要重新提交的单据",
    reqloadRouterPathTips: "请配置重新提交的路由",
    onlyrecreatedemand: "只能选择一个重新提交的单据",
    samebillidTips: "请选择相同的单据!",
    choosebackdemand3: "请选择需要重新提交的单据行项",
    backdemandtoapplybtn: "退回",
    reqbackbillidTips: "当前单据billid不能为空！",
    backdemandToApplymsg: "确定要对该单据执行“退回”操作吗?",
    backsuccmsg: "退回成功！",
    backerrormsg: "当前单据存在关联单据不可执行退回操作！"
  },
  materialgive: {
    title: "赠送单",
    baseinfoTab: "基本信息",
    tomaterialgiveTab: "待开单",
    materialgiveTab: "赠送单",
    choosedemand: "请选择赠送需求",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    applyusername: "申请人",
    createtime: "申请日期",
    givesource: "赠送来源",
    storeid: "仓库",
    planuserid: "账务管理员",
    storeusername: "实物管理员",
    invoiceno: "发票",
    taxrate: "综合税率",
    manuname: "供应商",
    remark: "备注",
    listinfo: "本次入库清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    applynum: "申请数量",
    donenum: "已开单数量",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum2: "公允值/金额",
    notes2: "备注",
    orgdemandbillno: "需求单号",
    serialno: "库存批次",
    demandbillno: "需求单据编码",
    receivedate: "到达任务池时间",
    startdate: "开始日期",
    enddate: "结束日期",
    recbillno: "正式单据编码",
    checknumtip: "行项实际数量不能大于开单数量!",
    orgdemandbillno2: "申请单号"
  },
  itemsearchlist: {
    indexMethod: "序号",
    itemcode: "项目编码",
    itemname: "项目名称",
    currstatus: "当前办理步骤",
    curruser: "当前办理人",
    investyear: "投资年度",
    itemleader: "立项管理员",
    constructunit: "建设单位",
    itemspeccode: "一级专业",
    investtype: "投资渠道",
    expList: "导出",
    reset: "重置",
    query: "查询",
    buscate: "业务大类"
  },
  materialstzgtransfer: {
    title: "受托自管转用单",
    baseinfoTab: "基本信息",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    plandate: "开单日期",
    storedate: "过账日期",
    transfertype: "转用类型",
    chstore_out: "转出仓库",
    planusername: "转出账务管理员",
    storeuserid: "转出库实物管理员",
    projcode_out: "转出子项目编码",
    projname_out: "转出子项目名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    projcode2: "转出子项目编码",
    projname2: "转出子项目名称",
    remark: "备注",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum: "金额",
    degree: "库存属性",
    notes: "备注",
    billno2: "单据编码",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "备注",
    reqtransfertypeTips: "请选择转用类型",
    checkapplynumtip: "行项开单数量不能大于可用库存数量！",
    changeprojTips: "请清空已选择的物资需求明细，再更换转出子项目编码!",
    reqprojcodeTips: "请选择转出子项目编码!",
    checknumtip: "行项实际数量不能大于开单数量!",
    title1: "受托自管转用单",
    title2: "受托自管转用单",
    title3: "受托自管转用单"
  },
  backdemand: {
    title: "退货需求单",
    baseinfoTab: "基本信息",
    tobackdemandTab: "待退货订单",
    backdemandTab: "退货需求",
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    manuname: "供应商",
    stockusername: "采购管理员",
    contractcode: "法律订单编码",
    orderdate: "订单日期",
    startdate: "开始日期",
    enddate: "结束日期",
    rectype: "入库类型",
    chooseorder: "请选择订单",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    applyuser_tel: "申请人电话",
    createtime: "申请日期",
    remark: "备注",
    fileup: "上传附件",
    store_out: "退货仓库",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    currency: "交易币种",
    applynum: "申退数量",
    recsum: "金额合计",
    projcode: "子项目编码",
    projname: "子项目名称",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    degree: "库存属性",
    serialno: "库存批次",
    notes: "备注",
    checkapplynumtip: "行项申退数量不能大于可用库存数量！",
    existsRowlistTips: "已选择了订单物资清单,请先删除行项物资!",
    billno2: "单据编码",
    brecbillno: "正式单据编码",
    chdemandstatus: "需求状态",
    donenum: "已开单数量"
  },
  selectbackorder: {
    title: "选择退货订单信息",
    orderno: "采购订单编号",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    chunit: "单位",
    price: "单价",
    stocknum: "采购数量",
    recnum: "已收数量",
    recnumonline: "在途数量",
    canbacknum: "可退数量",
    searchstore: "查询库存",
    applynum: "本次退货数量",
    projname: "子项目名称",
    chcurrency: "交易币种",
    chstore: "仓库",
    serialno: "批次",
    storenum: "库存数量",
    chdegree: "库存属性",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    confirm: "确定",
    reqselectedOrderrowids: "请选择具体信息！",
    reqorderid: "订单ID不能为空!",
    reqstoreid: "请选择退货仓库!",
    reqstorematerialTips: "请点击查询库存按钮查询库存物资!",
    reqstorematerialTips2: "请点击查询收货行项按钮查询收货行项!",
    reqapplynumTips: "请输入本次退货数量!",
    checkapplynumTips1: "第",
    checkapplynumTips2: "行的本次退货数量不能大于可退货数量!",
    checkapplynumTips3: "行的可用库存数量为0，无法选择!",
    searchbillrow: "查询收货行项",
    mstorenum: "收货数量",
    usablestorenum2: "可退数量",
    onlinenum2: "已退数量",
    projoccupynum: "项目领用数量"
  },
  materialwwlyreg: {
    title: "委托领用登记表",
    baseinfoTab: "基本信息",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    chstore_out: "仓库",
    remark: "备注",
    materialWrap: "物资需求明细",
    serialno: "领用批次号",
    materialcode: "物料编码",
    materialname: "物料名称",
    projcode: "子项目编码",
    projname: "子项目名称",
    price: "单价",
    plannum: "领用数量",
    recsum: "合计金额",
    currency: "交易币种",
    orderno: "采购订单编码",
    manuno: "供应商编码",
    manuname: "供应商名称",
    notes: "备注",
    billno2: "单据编码",
    createtime: "申请日期",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "备注",
    checkapplynumtip: "行项领用数量不能大于可用数量！",
    usablestorenum: "可用数量",
    outmanuno: "委外供应商编码",
    outmanuname: "委外供应商名称"
  },
  selectmaterialserialdoc: {
    title: "选择物资批次",
    materialname: "物料名称",
    materialcode: "物料编码",
    spec: "规格型号",
    chunit: "单位",
    mstorenum: "数量",
    orderno: "订单号",
    stockno: "采购订单单据编码",
    serialno: "批次",
    price: "批次价格",
    manuname: "供应商",
    outmanuname: "委外供应商",
    chstore: "仓库",
    manuno: "供应商编码",
    outmanuno: "委外供应商编码",
    applynum: "申请数量",
    confirm: "确定",
    reqstorematerialTips: "请选择物资批次!",
    reqapplynumTips: "请输入申请数量!",
    checkapplynumTips1: "第",
    checkapplynumTips2: "行的申请数量不能大于可用数量!",
    reqstoreTips: "请选择仓库!",
    chcurrency: "交易币种",
    checkapplynumTips3: "行的可用数量为0，无法选择!",
    usablestorenum: "可用数量",
    onlinenum: "占用数量",
    outproj: "委外子项目"
  },
  materialback: {
    title: "退货单",
    baseinfoTab: "基本信息",
    tomaterialbackTab: "待开单",
    materialbackTab: "退货单",
    choosedemand: "请选择退货需求",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    applyusername: "申请人",
    applydeptname: "申请部门",
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    manuno: "供应商编码",
    manuname: "供应商名称",
    createtime: "申请日期",
    storeid: "仓库",
    planusername: "账务管理员",
    storeuserid: "实物管理员",
    remark: "备注",
    listinfo: "本次退货清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    applynum: "申退数量",
    donenum: "已开单数量",
    storenum_que: "可用库存数量",
    onlinenum: "在途占用数量",
    plannum: "开单数量",
    storenum: "实退数量",
    recsum2: "退料金额",
    degree: "库存属性",
    notes2: "备注",
    demandbillno: "需求单据编码",
    receivedate: "到达任务池时间",
    startdate: "开始日期",
    enddate: "结束日期",
    recbillno: "正式单据编码",
    checknumtip: "行项实退数量不能大于开单数量!",
    orgdemandbillno2: "申请单号"
  },
  materialgzlyreg: {
    title: "办公资产领用登记单",
    baseinfoTab: "基本信息",
    tomaterialgzlyregTab: "待领用",
    materialgzlyregTab: "领用登记单",
    choosegz: "请选择待领用办公资产",
    orderno: "采购订单编号",
    ordername: "采购订单名称",
    manuno: "供应商编码",
    manuname: "供应商名称",
    assetclass: "资产分类",
    assetcodeno: "固定资产卡片编号",
    sn: "实物序列号",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    unit: "计量单位",
    price: "购买价值",
    addlyreginfo: "增加领用信息",
    billno: "单据编码",
    applyusername: "申请人",
    applydeptname: "申请部门",
    listinfo: "本次领用清单",
    description: "说明",
    macaddr: "MAC地址",
    opersystem: "操作系统",
    warrantyinfo: "保修信息（购买日期）",
    adaptercode: "适配器编码",
    sourcedoc: "源文档",
    recsum: "购买价值",
    assignuserid: "领用人",
    assigntime: "领用时间",
    plannum: "领用数量",
    mstoreuserid: "实物管理员",
    useuserid: "使用人",
    usedeptid: "使用部门",
    senduserid: "发货人",
    notes2: "备注",
    slbillno: "收货单编码",
    billno2: "单据编码",
    createtime: "申请日期",
    startdate: "开始日期",
    enddate: "结束日期",
    updateassetbtn: "更新资产卡片",
    updateassetSuccTips: "更新资产卡片成功",
    sendsapflag: "更新资产状态",
    transaptip: "行项资产状态未全部更新成功，请点击[更新资产卡片]按钮！",
    costcenter: "成本中心",
    mstoredeptid: "实物管理部门",
    estimareplacedate: "预计更换日期",
    ifcapitalizable: "是否资本化",
    sameifcapitalizableTips: "请选择相同的是否资本化的办公资产!",
    assetmodifyflagTips: "SAP还未回传反馈，无法进行保存，请刷新页面后重试!"
  },
  materialstorelist: {
    orderno: "采购订单编号",
    query: "查询",
    ordername: "采购订单名称",
    plandate: "开单日期",
    startdate: "开始日期",
    enddate: "结束日期",
    reset: "重置",
    order: "序号",
    manuname: "供应商",
    oper: "操作",
    view: "查看",
    billno: "单据编码",
    applyusername: "制单人",
    applydate: "开单日期",
    chstore: "仓库",
    accountdate: "过账日期",
    tostorelist: "待入账",
    storelist: "已入账",
    chdemandtype: "需求类型",
    chprojcode_out: "工程编码/成本中心"
  },
  materialsdmsgetaccount: {
    title: "出库核销单",
    baseinfoTab: "基本信息",
    tomaterialsdmsgetaccountTab: "待结算",
    materialsdmsgetaccountTab: "出库结算单",
    choosedemand: "请选择待结算需求!",
    samecompanycodeTips: "请选择相同的公司代码!",
    samecompanyflagTips: "请选择相同的公司类型!",
    samestoreidTips: "请选择相同的仓库!",
    sameprojcodeTips: "请选择相同的成本中心!",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    storeid: "仓库",
    projcode_out: "成本中心编码",
    projname_out: "成本中心名称",
    remark: "备注",
    addsdmsgetaccount: "新增",
    listinfo: "本次发货清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    plannum: "数量",
    recsum: "金额",
    notes2: "备注",
    chouttype2: "用途类别",
    serialno: "库存批次",
    recbillno: "正式单据编码",
    startdate: "开始日期",
    enddate: "结束日期",
    orgdemandbillno2: "申请单号",
    createtime: "申请日期",
    spec: "规格型号",
    serialno1: "批次号",
    billno2: "单据编码",
    planusername: "账务管理员",
    storeuserid: "实物管理员"
  },
  materialtohandin: {
    title: "末梢缴料单",
    baseinfoTab: "基本信息",
    tomaterialtohandinTab: "待缴料",
    materialtohandinTab: "末梢缴料单",
    choosedemand: "请选择待缴料需求!",
    samecompanycodeTips: "请选择相同的公司代码!",
    samecompanyflagTips: "请选择相同的公司类型!",
    samestoreidTips: "请选择相同的仓库!",
    sameprojcodeTips: "请选择相同的成本中心!",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    storeid: "仓库",
    projcode_out: "成本中心编码",
    projname_out: "成本中心名称",
    remark: "备注",
    addtohandin: "新增",
    listinfo: "本次退库清单",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    plannum: "数量",
    recsum: "金额",
    notes2: "备注",
    chouttype2: "用途类别",
    serialno: "库存批次",
    recbillno: "正式单据编码",
    startdate: "开始日期",
    enddate: "结束日期",
    orgdemandbillno2: "申请单号",
    createtime: "申请日期",
    spec: "规格型号",
    serialno1: "批次号",
    billno2: "单据编码",
    planuserid: "账务管理员",
    storeuserid: "实物管理员",
    orgbillno: "原领料单号"
  },
  materialcheck: {
    title: "盘点结果",
    baseinfoTab: "基本信息",
    billno: "单据号",
    plandate: "开单日期",
    storedate: "过账日期",
    storeid: "仓库",
    planuserid: "账务管理员",
    storeusername: "实物管理员",
    fileup: "上传附件",
    checktype: "盘点类型",
    remark: "备注",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum: "金额合计",
    currency: "交易币种",
    costcenter: "成本中心",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    degree: "库存属性",
    billno2: "单据编码",
    startdate: "开始日期",
    enddate: "结束日期",
    remark2: "备注",
    reqchecktypeTips: "请选择盘点类型",
    checkapplynumtip: "行项开单数量不能大于可用库存数量！",
    checknumtip: "行项实际数量不能大于开单数量!",
    notes2: "备注"
  },
  demandquery: {
    chcompany: "公司",
    billno: "单据编码",
    applydeptname: "部门",
    chsourcetype: "需求来源",
    createtime: "申请日期",
    startdate: "开始日期",
    enddate: "结束日期",
    billno_exact: "单据号(精确)",
    remark: "主单备注",
    rownotes: "行项备注",
    orderno: "采购订单编号(精确)",
    projcode: "项目编码",
    projcode2: "子项目编码",
    projname: "子项目名称",
    costcenter: "成本中心",
    orgbillno: "关联料单单据号",
    demandstatus: "单据状态",
    applydept: "申请部门",
    applyuserid: "申请人",
    curruserid: "当前办理人",
    outtype2: "用途类别",
    backflag: "是否退回",
    currname: "当前办理人",
    remark2: "主单备注",
    showdetail: "展示明细"
  },
  bstorequerylist: {
    exact: "精确",
    chcompany: "公司",
    billno: "单据编码",
    sobkz: "库存类型",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    storedate: "入库时间",
    serialno: "库存批次",
    manuname: "供应商",
    orderno: "采购订单编号",
    contractcode: "合同编码",
    projcode: "子项目编码",
    orimanuname: "原厂商",
    orimanuprodname: "原厂商产品名称",
    orimanuspec: "原厂商产品型号",
    orimanudrip: "原厂商产品描述",
    chstore: "仓库名称",
    chunit: "计量单位",
    storenum: "库存数量",
    recsum: "金额",
    onlinenum: "在途库存",
    usablestorenum: "可用库存",
    storeusername: "仓管员",
    z_itext: "备注",
    ztlsm: "缴料备注",
    chgivesource: "赠送来源",
    chooseprintitem: "请选择需要打印的库存行项"
  },
  warehousestocklist: {
    exact: "精确",
    companycode: "公司代码",
    chcompany: "公司",
    materialcode: "物料编码",
    materialname: "物料名称",
    lgort: "库存地点",
    chlgort: "库存地点描述",
    storenum: "数量",
    materialgroup: "物料组"
  },
  stockonpostingdatelist: {
    exact: "精确",
    companycode: "公司代码",
    chcompany: "公司",
    materialcode: "物料编码",
    materialname: "物料名称",
    storedate: "过账日期",
    lgort: "库存地点",
    mblnr: "物料凭证",
    zeile: "行项",
    erfmg: "数量",
    bwart: "移动类型",
    erfme: "计量单位",
    stockon: "库存",
    totalreceipts: "总收据",
    totalissu: "总发货",
    fillmaterialinfo: "查询物料编码/名称不能为空!"
  },
  sdmsgetaccount: {
    title: "核销需求单",
    baseinfoTab: "基本信息",
    applyareaname: "申请地区",
    applydeptname: "申请部门",
    applyusername: "申请人",
    billno: "单据编码",
    createtime: "申请日期",
    chstore_out: "仓库",
    materialWrap: "物资需求明细",
    materialcode: "物料编码",
    materialname: "物料名称",
    price: "单价",
    applynum: "申请数量",
    recsum: "金额",
    currency: "交易币种",
    costcenter: "成本中心",
    chouttype2: "用途类别",
    donenum: "已开单数量",
    usablestorenum: "可用库存数量",
    onlinenum: "在途占用数量",
    degree: "库存属性",
    serialno: "库存批次"
  },
  billquery: {
    billno_exact: "单据号(精确)",
    rendertype: "料单类型",
    plandate: "开单日期",
    storeid: "仓库",
    storeuserid: "实物管理员",
    planuserid: "账务管理员",
    accoutedate: "结账月",
    storedate: "过账日期",
    materialcode: "物料编码",
    materialname: "物料名称",
    spec: "规格型号",
    evalclasscode: "评估类",
    costcenter: "成本中心",
    outtype2: "用途类别",
    serialno: "批次号",
    billstatus: "料单状态",
    orderno: "采购订单编号(精确)",
    contractcode: "合同编码(精确)",
    projcode: "项目编码",
    chcompany: "公司",
    billno: "料单号",
    applydeptname: "申请部门",
    orgbillno: "关联单号",
    applyuser_demand: "需求申请人",
    applydept_demand: "需求申请人部门",
    chsourcetype: "需求来源",
    applyuserid: "申请人",
    planusername: "账务管理员",
    storeusername: "实物管理员",
    remark: "主单备注",
    price: "单价",
    plannum: "开单数量",
    storenum: "实际数量",
    recsum: "金额",
    chstatus: "状态",
    rownotes: "行项备注",
    projcode2: "子项目编码",
    projname: "子项目名称",
    currname: "当前办理人",
    showdetail: "展示明细"
  },
  materialmodel: {
    title: "模型物料维护",
    baseinfoTab: "基本信息",
    materialcode: "模型物料编码",
    materialname: "模型物料名称",
    spec: "规格型号",
    chunit: "单位",
    createtime: "编制日期",
    applyusername: "编制人员",
    remark: "备注",
    materialWrap: "明细物料",
    submaterialcode: "明细物料编码",
    rowmaterialname: "明细物料名称",
    rowspec: "规格型号",
    rowchunit: "单位",
    plannum: "数量",
    price: "单价",
    pricescale: "价格占比(%)",
    calpricescalebtn: "计算占比",
    enablebtn: "生效",
    modifybtn: "调整",
    enablesuccess: "生效成功！",
    ifvalid: "是否确认生效",
    pricescalesumTips: "价格占比合计值需为100%!",
    reqmaterialcodeTips: "请选择模型物料编码!",
    changemodelmaterialTips: "请清空已选择的明细物料，再选择模型物料编码!"
  },
  porecquery: {
    manuname: "供应商名称",
    stocknum: "数量",
    price: "单价（不含增值税）",
    costprice: "价款（不含增值税）",
    recsum: "价税总金额",
    rectotalnum: "收货数量",
    outtotalnum: "委外数量",
    occupytotalnum: "使用数量",
    recbillno: "收货单号",
    recdate: "收货日期",
    recserialno: "收货批次",
    recnum: "收货数量",
    outdate: "委外日期",
    outnum: "受托数量",
    occupynum: "使用数量",
    backtotalnum: "退货数量",
    backnum: "退货数量",
    backbillno: "退货单号",
    backdate: "退货时点",
    backserialno: "退货批次"
  },
  materialcarry: {
    title: "结转单"
  },
  outbillquery: {
    manuname: "供应商名称",
    belongeregion: "区域",
    outtotalnum: "委外数量",
    price: "单价（不含增值税）",
    recsum: "金额",
    occupytotalnum: "使用数量",
    occupynum: "使用数量"
  },
  materialofficely: {
    title: "办公用品领用单",
    plannum: "领用数量",
    checkapplynumtip: "行项领用数量不能大于可用库存数量！",
    checknumtip: "行项实际数量不能大于领用数量!"
  },
  officelydemand: {
    demandlistTab: "领用需求",
    title: "办公用品领用申请单"
  },
  materialofficelybl: {
    title: "办公用品领用办理单",
    tomaterialofficelyblTab: "待开单",
    materialofficelyblTab: "领用需求正式单",
    choosedemand: "请选择办公用品领用申请需求",
    orgdemandbillno: "办公用品领用申请单号"
  },
  paramcfgload: {
    paramkey: "参数名",
    paramval: "参数值",
    title_officeaassets: "办公资产参数配置",
    oa_assetsamount: "资本化金额阈值(比索)",
    oa_poamount: "是否走采购订单方案的金额阈值(比索)",
    title_officesupplies: "办公用品参数配置",
    os_poamount: "是否走采购订单方案的金额阈值(比索)"
  },
  materialgzydreg: {
    title: "办公资产预定登记单",
    tomaterialgzydregTab: "待预定",
    materialgzydregTab: "预定登记单",
    addydreginfo: "增加预定信息",
    choosegz: "请选择待预定办公资产",
    listinfo: "本次预定清单",
    plannum: "预定数量",
    useuserid: "预定人",
    usedeptid: "预定部门",
    officeassetcode: "办公资产卡片编号",
    materialgzyd2lyTab: "预定待领用",
    materialgzhs2lyTab: "回收待领用",
    materialgzwx2lyTab: "维修待领用"
  },
  materialgzhsreg: {
    title: "办公资产回收登记单",
    listinfo: "本次回收清单"
  },
  materialgzwxreg: {
    title: "办公资产维修登记单",
    listinfo: "本次维修清单"
  },
  materialgzbfreg: {
    title: "办公资产报废登记单",
    listinfo: "本次报废清单"
  },
  materialgzzyreg: {
    title: "办公资产转移登记单",
    listinfo: "本次转移清单",
    oriuseusername: "原使用人",
    curruseusername: "当前使用人",
    reqoriuseusernameTips: "请先选择原使用人",
    changeoriuseusernameTips: "请清空已选择的办公资产，再更换原使用人!",
    useuseridsameTips: "请选择不同的原使用人和当前使用人!"
  },
  voucherquery: {
    matnr: "物料编码",
    charg: "批次号",
    company: "公司",
    companycode: "公司代码",
    lgort: "库存地点",
    bwart: "移动类型",
    mblnr: "物料凭证",
    zeile: "物料凭证项目",
    budat: "发布日期",
    storenum: "数量",
    chunit: "单位",
    chzkeeper: "收货人",
    ext_doc_no: "收货/发货单",
    ebeln: "采购订单",
    sakto: "总账科目",
    chwaers: "币种",
    chkostl: "成本中心",
    materialname: "物料描述",
    chbwart: "移动类型描述",
    entrydate: "录入日期",
    entrytime: "录入时间",
    chusnam: "用户名"
  },
  materialrecwwback: {
    title: "订单委外退货单",
    tomaterialrecwwbackTab: "待订单委外退货",
    materialrecwwbackTab: "订单委外退货",
    planusername: "开单员",
    checknumtip: "行项实退数量不能大于退货数量!"
  },
  porecquery2: {
    sendsapdate: "发送SAP时间",
    recdatetime: "收货时点",
    isincludgjorder: "是否包含割接订单",
    taxrate: "增值税率",
    recsumnum: "合计数量",
    recsumamount: "合计金额",
    outdatetime: "委外时点",
    costprice: "单价（不含增值税）",
    costsum: "采购金额合计（不含增值税）",
    itemstatus: "行项状态",
    isExistMaterialRecback: "是否存在收货、退货"
  },
  materialsummary: {
    totaldate: "数据汇总日期范围",
    checkstartdate: "请选择数据汇总日期范围",
    title: "物资订单进度汇总",
    applyusername: "发起人",
    applydate: "发起日期",
    summarymonth: "月份",
    billno: "物资订单进度汇总单号",
    summaryname: "物资订单进度汇总单名称",
    startdate: "数据汇总开始日期",
    enddate: "数据汇总结束日期",
    addrate: "加成率(%)",
    eonumber: "EO号",
    stockbillno: "采购单据编码",
    speccode: "专业",
    stocktype: "类型",
    stocknum: "采购数量",
    price: "单价（不含税）",
    costprice: "价款（不含税）",
    completednum: "完成数量",
    completedprice: "完成数量总价（不含税）",
    completedaddprice: "完成数量加成总价（不含税）",
    chtaxrate: "税率",
    taxprice: "增值税",
    completedtotal: "完成数量总价（含税）",
    chcurrency: "币种",
    manuname: "供应商"
  },
  offerProcessLoad: {
    submit:"提交 / 退回",
    offerProcessSheet: 'offer评估表单',
    candidateName: '候选人名',
    candidateOrEmplyee: '候选人编码/内部人员编码',
    candidateType: '候选人类型',
    applicationId: '申请单编码',
    jobTitle: 'Job名称',
    jobId: 'Job编码',
    processTrack: '流程跟踪',
    processFlow: '流程状态',
    processor: '办理人',
    action: '流程动作',
    actionTime: '时间',
    comment: '评论 / 理由',
    showMore: '展示更多',
    showLess: '展示更少',
    candidatePreviousPayslips: '候选人以前的工资单',
    file: '文件',
    cemunerationCalculator: '薪酬计算器',
    preparedDate: '准备日期',
    systemAutomatic: '审批范围(系统自动)',
    manualIndentified: '审批范围(手工识别)',
    deviation: '偏差理由:',
    viewTax: '查看税收和贡献表',
    currectPackage: '现在工资',
    taxable: '是否纳税?',
    monthly: '每月',
    annual: '年度',
    yesTaxable: '纳税',
    noTaxable: '不纳税',
    dito: 'DITO',
    variance: '差异',
    approvalDialog: '审批对话框',
    approve: '批准',
    return: '退回',
    approvalComment: '评论',
    approvalJustification: '理由',
    cancel: '取消',
    ok: '确认',
  },
  offerProcessTax: {
    SSSContribution: '社保表',
    trainTaxTable: '税务表',
    PhilHealthContributionx : '医保表',
    SSSContributiontitle: '社保表 (PHP)',
    trainTaxTabletitle: '税务表 (PHP)',
    PhilHealthContributionxtitle: '医保表 (PHP)',
    compensationRange: '补偿范围',
    monthlySalaryCredit: '月薪信贷',
    regularSocialSecurity: '社会保障 / 雇员补偿',
    mandatoryProvidentFund: '强制性公积金',
    total: '总计',
    contributionAmount: '出资',
    security: '社会保障',
    compensation: '雇员补偿',
    fund: '强制性公积金',
    er: '雇主',
    ee: '员工',
    annualIncome: '年收入',
    taxRate: '税率',
    monthlyBasicSalary: '每月基本工资',
    premiumRate: '保险费率',
    monthlyPremium: '每月的保险费',
  },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js